export const GTM_CODE_DEV = 'GTM-M973827';
export const GTM_CODE_PROD = 'GTM-T47852Z';

export const PAGEVIEW = {
  environment: {
    path: 'site.environment',
    value: null,
  },
  useragent: {
    path: 'site.useragent',
    value: null,
  },
  permissions: {
    path: 'site.permissions',
    value: null,
  },
  accessibility: {
    path: 'site.accessibility',
    value: null,
  },
  geolocation: {
    path: 'visitor.geolocation',
    value: 'NotAvailable',
  },
  channel_131: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  channel_141: {
    path: 'site.channel',
    value: 'SuperAppPF',
  },
  channel_160: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  developmenttype: {
    path: 'site.developmenttype',
    value: null,
  },
  clientIdpf: {
    path: 'visitor.client.idpf',
    value: null,
  },

  // Pantallas de Captura Documento - Trajeta de credito contratar,
  // Pantalla 1 *pantalla comun,
  pv1pageName: {
    path: 'page.name',
    value: 'SolicitudProducto',
  },
  pv1pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv1subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv1pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv1pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv1internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv1errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv1transactionName: {
    path: 'transaction.name',
    value: null,
  },

  // Pantalla 2,
  pv2pageName: {
    path: 'page.name',
    value: 'ConoceMasProducto',
  },
  pv2pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv2subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv2pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv2pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv2internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv2errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv2transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: null,
  },
  pv2transactionName: {
    path: 'transaction.name',
    value: null,
  },

  // Pantalla 3,
  pv414pageName: {
    path: 'page.name',
    value: 'ErrorEnElDispositivoSyxtera',
  },
  pv414pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv414subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv414pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv414pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv414internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv414errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 4,
  pv415pageName: {
    path: 'page.name',
    value: 'ErrorAlgoSalioMal',
  },
  pv415pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv415subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv415pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv415pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv415internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv415errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantalla 5,
  pv416pageName: {
    path: 'page.name',
    value: 'ErrorLoadingPage',
  },
  pv416pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv416subFamily: {
    path: 'page.subfamily',
    value: 'Home',
  },
  pv416pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv416pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv416internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv416errorname: {
    path: 'custom.errorname',
    value: null,
  },

  // Pantallas de Captura Documento - Trajeta de credito contratar,
  // Pantalla 1,

  pv417pageName: {
    path: 'page.name',
    value: 'PasoAPaso',
  },
  pv417pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv417subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv417pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv417pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv417internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv417errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv417transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv417transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 3,

  pv3pageName: {
    path: 'page.name',
    value: 'PrepararCapturaCedula',
  },
  pv3pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv3subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv3pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv3pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv3customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv3internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv3errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv3transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv3transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv3transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 4,

  pv4pageName: {
    path: 'page.name',
    value: 'InicioCapturaCedula',
  },
  pv4pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv4subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv4pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv4pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv4customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv4internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv4errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv4transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv4transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv4transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 5,

  pv6pageName: {
    path: 'page.name',
    value: 'CapturaCedulaPosterior',
  },
  pv6pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv6subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv6pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv6pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv6customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv6internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv6errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv6transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv6transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv6transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 6,

  pv12pageName: {
    path: 'page.name',
    value: 'InicioCedulaFrontal',
  },
  pv12pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv12subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv12pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv12pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv12customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv12internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv12errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv12transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv12transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv12transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 7,

  pv13pageName: {
    path: 'page.name',
    value: 'CapturaCedulaFrontal',
  },
  pv13pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv13subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv13pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv13pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv13customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv13internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv13errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv13transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv13transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv13transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 8,

  pv14pageName: {
    path: 'page.name',
    value: 'ExitoCapturaCedula',
  },
  pv14pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv14subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv14pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv14pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv14customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv14internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv14errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv14transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv14transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv14transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pnatalla 9,

  pv15pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv15pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv15subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv15pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv15pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv15customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv15internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv15errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv15transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv15transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv15transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 10,

  pv17pageName: {
    path: 'page.name',
    value: 'InicioCapturaHuellas',
  },
  pv17pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv17subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv17pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv17pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv17customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv17internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv17errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv17transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv17transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv17transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 11,

  pv19pageName: {
    path: 'page.name',
    value: 'CapturaHuellas',
  },
  pv19pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv19subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv19pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv19pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv19customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv19internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv19errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv19transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv19transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv19transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 12,
  pv21pageName: {
    path: 'page.name',
    value: 'ExitoPrecargaDatos',
  },
  pv21pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv21subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv21pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv21pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv21customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv21internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv21errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv21transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv21transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv21transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 13,
  pv5pageName: {
    path: 'page.name',
    value: 'TratamientoDeDatos',
  },
  pv5pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv5subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv5pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv5pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv5internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv5errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv5transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv5transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 14,
  pv7pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosterior',
  },
  pv7pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv7subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv7pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv7pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv7internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv7errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv7transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv7transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 15,

  pv10pageName: {
    path: 'page.name',
    value: 'ErrorListasRestrictivas',
  },
  pv10pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv10subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv10pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv10pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv10internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv10errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv10transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv10transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 16,
  pv221pageName: {
    path: 'page.name',
    value: 'ErrorCapturaFrontal',
  },
  pv221pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv221subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv221pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv221pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv221internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv221errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv221transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv221transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 17,

  pv16pageName: {
    path: 'page.name',
    value: 'ErrorPersonaPEP',
  },
  pv16pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv16subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv16pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv16pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv16internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv16errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv16transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv16transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 18,
  pv222pageName: {
    path: 'page.name',
    value: 'ErrorCapturaHuellas',
  },
  pv222pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv222subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv222pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv222pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv222internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv222errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv222transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv222transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 19,

  pv20pageName: {
    path: 'page.name',
    value: 'ErrorHuellasInvalidas',
  },
  pv20pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv20subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv20pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv20pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv20internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv20errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv20transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv20transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 20,
  pv220pageName: {
    path: 'page.name',
    value: 'ErrorPermisosUsoCamara',
  },
  pv220pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv220subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv220pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv220pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv220internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv220errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv220transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv220transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 21,

  pv8pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosteriorInvalida',
  },
  pv8pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv8subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv8pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv8pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv8internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv8errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv8transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv8transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 22,
  pv11pageName: {
    path: 'page.name',
    value: 'ErrorDocumentoInvalido',
  },
  pv11pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv11subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv11pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv11pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv11internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv11errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv11transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv11transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantalla 23,
  pv223pageName: {
    path: 'page.name',
    value: 'ErrorCedulaFrontalInvalida',
  },
  pv223pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv223subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv223pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv223pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv223internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv223errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv223transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv223transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 24,
  pv224pageName: {
    path: 'page.name',
    value: 'LinkVTUP',
  },
  pv224pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv224subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv224pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv224pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv224internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv224errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv224transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv224transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 25,

  pv9pageName: {
    path: 'page.name',
    value: 'MensajeClienteExistente',
  },
  pv9pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv9subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv9pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv9pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv9internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv9errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv9transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv9transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },

  // Pantallas de TrajetasCreditoContratar - Ingreso Datos,
  // Pantalla 1,
  pv22pageName: {
    path: 'page.name',
    value: 'VerificarDatoCedula',
  },
  pv22pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv22subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv22pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv22pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv22customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv22internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv22errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv22transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv22transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv22transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2,
  pv23pageName: {
    path: 'page.name',
    value: 'IngresarInformacionesContacto',
  },
  pv23pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv23subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv23pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv23pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv23customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv23internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv23errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv23transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv23transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv23transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3,
  pv24pageName: {
    path: 'page.name',
    value: 'ResidenciaExterior',
  },
  pv24pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv24subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv24pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv24pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv24customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv24internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv24errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv24transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv24transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv24transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4,
  pv25pageName: {
    path: 'page.name',
    value: 'DondeVives',
  },
  pv25pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv25subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv25pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv25pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv25customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv25internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv25errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv25transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv25transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv25transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5,
  pv26pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv26pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv26subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv26pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv26pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv26customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv26internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv26errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv26transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv26transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv26transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6,
  pv27pageName: {
    path: 'page.name',
    value: 'SeleccionEmpleado',
  },
  pv27pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv27subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv27pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv27pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv27customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv27internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv27errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv27transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv27transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv27transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7,
  pv230pageName: {
    path: 'page.name',
    value: 'InformacionEmpresaIndependente',
  },
  pv230pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv230subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv230pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv230pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv230customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv230internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv230errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv230transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv230transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv230transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 8,
  pv231pageName: {
    path: 'page.name',
    value: 'DatosEmpresaIndependente',
  },
  pv231pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv231subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv231pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv231pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv231customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv231internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv231errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv231transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv231transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv231transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 9,
  pv28pageName: {
    path: 'page.name',
    value: 'DondeTrabajasEmpleado',
  },
  pv28pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv28subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv28pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv28pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv28customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv28internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv28errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv28transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv28transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv28transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 10,
  pv232pageName: {
    path: 'page.name',
    value: 'ErrorRechazoContrato',
  },
  pv232pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv232subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv232pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv232pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv232internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv232errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv232transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv232transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 11,
  pv29pageName: {
    path: 'page.name',
    value: 'IngresosMensuales',
  },
  pv29pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv29subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv29pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv29pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv29customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv29internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv29errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv29transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv29transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv29transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv29transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 12,
  pv31pageName: {
    path: 'page.name',
    value: 'OfertaAprobada',
  },
  pv31pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv31subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv31pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv31pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv31customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv31internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv31errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv31transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv31transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv31transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 13,
  pv39pageName: {
    path: 'page.name',
    value: 'ErrorResidenciaExterior',
  },
  pv39pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv39subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv39pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv39pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv39internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv39errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv39transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv39transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 14,
  pv37pageName: {
    path: 'page.name',
    value: 'ActividadEconomica',
  },
  pv37pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv37subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv37pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv37pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv37internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv37errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv37transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv37transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 15,
  pv233pageName: {
    path: 'page.name',
    value: 'SeleccionarFuenteIngreso',
  },
  pv233pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv233subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv233pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv233pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv233internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv233errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv233transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv233transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 16,
  pv234pageName: {
    path: 'page.name',
    value: 'RechazoPCO',
  },
  pv234pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv234subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv234pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv234pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv234internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv234errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv234transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv234transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantallas de TarjetasCreditoSolicitar - ConfigurarVinculacionOficina,
  // Pantalla 1,
  pv40pageName: {
    path: 'page.name',
    value: 'SeleccionaCiudadOficina',
  },
  pv40pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv40subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv40pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv40pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv40customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv40internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv40errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv40transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv40transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv40transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },

  // Pantalla 2,
  pv41agencystoreid: {
    path: 'visitor.agencystoreid',
    value: null,
  },
  pv41pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv41subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv41pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv41pageName: {
    path: 'page.name',
    value: 'ConfirmarOficina',
  },
  pv41pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv41customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv41internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv41errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv41transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv41transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv41transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv41transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 3,
  pv42pageName: {
    path: 'page.name',
    value: 'FechaPagoFranquicia',
  },
  pv42pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv42subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv42pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv42pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv42customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv42internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv42errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv42transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv42transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv42transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },

  // Pantalla 4,
  pv43pageName: {
    path: 'page.name',
    value: 'DireccionEntrega',
  },
  pv43pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv43subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv43pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv43pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv43customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv43internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv43errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv43transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv43transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv43transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv43cardpartner: {
    path: 'transaction.details.cardpartner',
    value: null,
  },
  pv43cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv43transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },

  // Pantalla 5,
  pv44pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracion',
  },
  pv44pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv44subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv44pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv44pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv44customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv44internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv44errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv44transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv44transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv44transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv44cardpartner: {
    path: 'transaction.details.cardpartner',
    value: null,
  },
  pv44cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv44transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv44chosenChannel: {
    path: 'transaction.details.chosenchannel',
    value: null,
  },

  // Pantallas de TarjetaCreditoSolicitar - IngresoDatosFinancieros,
  // Pantalla 1,
  pv45pageName: {
    path: 'page.name',
    value: 'PreguntasFinancieras',
  },
  pv45pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv45subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv45pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv45pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv45customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv45internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv45errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv45transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv45transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv45transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2,
  pv46pageName: {
    path: 'page.name',
    value: 'GastosMensuales',
  },
  pv46pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv46subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv46pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv46pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv46customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv46internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv46errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv46transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv46transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv46transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3,
  pv47pageName: {
    path: 'page.name',
    value: 'BienesDeudas',
  },
  pv47pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv47subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv47pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv47pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv47customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv47internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv47errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv47transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv47transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv47transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4,
  pv48pageName: {
    path: 'page.name',
    value: 'MonedaExtranjera',
  },
  pv48pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv48subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv48pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv48pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv48customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv48internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv48errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv48transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv48transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv48transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5,
  pv49pageName: {
    path: 'page.name',
    value: 'OperacionExtranjera',
  },
  pv49pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv49subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv49pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv49pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv49customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv49internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv49errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv49transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv49transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv49transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6,
  pv50pageName: {
    path: 'page.name',
    value: 'TitularProductosExtranjeros',
  },
  pv50pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv50subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv50pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv50pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv50customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv50internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv50errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv50transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv50transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv50transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7,
  pv53pageName: {
    path: 'page.name',
    value: 'ExitoIngresoDatos',
  },
  pv53pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv53subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv53pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv53pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv53customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv53internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv53errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv53transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv53transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv53transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 8,
  pv51pageName: {
    path: 'page.name',
    value: 'DatosProductosExtranjeros',
  },
  pv51pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv51subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv51pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv51pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv51customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv51internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv51errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv51transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv51transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv51transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantallas de TarjetaCreditoSolicitar - Vinculacion,
  // Pantalla 1,
  pv54pageName: {
    path: 'page.name',
    value: 'VinculacionTarjetaCredito',
  },
  pv54pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv54subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv54pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv54pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv54customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv54internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv54errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv54transactionName: {
    path: 'transaction.name',
    value: 'VinculacionProducto',
  },
  pv54transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv54cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv54cardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv54cardlimitrange: {
    path: 'transaction.details.cardlimitrange',
    value: null,
  },
  pv54transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv54transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },

  // Pantalla 2,
  pv56pageName: {
    path: 'page.name',
    value: 'ExitoTarjetaCreada',
  },
  pv56pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv56subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv56pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv56pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv56internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv56errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv56customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv56transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv56transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv56cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv56cardcategory: {
    path: 'transaction.details.cardcategory',
    value: null,
  },
  pv56cardlimitrange: {
    path: 'transaction.details.cardlimitrange',
    value: null,
  },
  pv56status: {
    path: 'transaction.details.transactionstatus',
    value: null,
  },
  pv56transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv1transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },

  // Pantalla 3,
  pv235pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv235pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv235subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv235pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv235pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv235internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv235errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv235customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv235transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv235transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },

  // Pantalla 4,
  pv236pageName: {
    path: 'page.name',
    value: 'Registrate',
  },
  pv236pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv236subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv236pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv236pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv236internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv236errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv236transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv236transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 5,
  pv418pageName: {
    path: 'page.name',
    value: 'ZonaGrisVinculacionTarjetaCredito',
  },
  pv418pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv418subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv418pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv418pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv418internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv418errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv418transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv418cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv418transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 6,
  pv419pageName: {
    path: 'page.name',
    value: 'ZonaGrisResumenDeSolicitud',
  },
  pv419pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv419subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv419pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv419pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv419internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv419errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv419transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv419transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 7,
  pv420pageName: {
    path: 'page.name',
    value: 'SolicitudEnValidacion',
  },
  pv420pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv420subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv420pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv420pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv420internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv420errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv420transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv420transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 7,
  pv421pageName: {
    path: 'page.name',
    value: 'ErroProductoNoCreado',
  },
  pv421pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv421subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv421pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv421pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv421internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv421errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv421transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCN',
  },
  pv421transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantallas de CuentasCapturaDocumentoAbrir  - Cuenta Ahorros - CN,

  // Pantalla 1,
  pv135pageName: {
    path: 'page.name',
    value: 'ErrorClienteDigital',
  },
  pv135pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv135subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv135pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv135pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv135internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv135errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv135transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv135transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 3,
  pv59pageName: {
    path: 'page.name',
    value: 'PreparaTuCedula',
  },
  pv59pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv59subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv59pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv59pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv59internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv59errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv59transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv59transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 4,
  pv60pageName: {
    path: 'page.name',
    value: 'InicioCapturaCedula',
  },
  pv60pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv60subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv60pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv60pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv60internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv60errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv60transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv60transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 6,
  pv62pageName: {
    path: 'page.name',
    value: 'InicioCedulaFrontal',
  },
  pv62pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv62subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv62pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv62pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv62internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv62errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv62transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv62transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8,
  pv64pageName: {
    path: 'page.name',
    value: 'ExitoCapturaCedula',
  },
  pv64pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv64subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv64pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv64pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv64internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv64errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv64transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv64transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 9,
  pv65pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv65pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv65subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv65pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv65pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv65internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv65errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv65transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv65transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 10,
  pv66pageName: {
    path: 'page.name',
    value: 'InicioCapturaHuellas',
  },
  pv66pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv66subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv66pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv66pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv66internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv66errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv66transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv66transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 12,
  pv68pageName: {
    path: 'page.name',
    value: 'ExitoPreCargaDatos',
  },
  pv68pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv68subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv68pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv68pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv68internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv68errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv68transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv68transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 14,
  pv70pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosterior',
  },
  pv70pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv70subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv70pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv70pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv70internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv70errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv70transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv70transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 16,
  pv72pageName: {
    path: 'page.name',
    value: 'ErrorCapturaFrontal',
  },
  pv72pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv72subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv72pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv72pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv72internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv72errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv72transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv72transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 18,
  pv74pageName: {
    path: 'page.name',
    value: 'ErrorCapturaHuellas',
  },
  pv74pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv74subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv74pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv74pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv74internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv74errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv74transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv74transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 19,
  pv75pageName: {
    path: 'page.name',
    value: 'ErrorHuellasInvalidas',
  },
  pv75pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv75subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv75pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv75pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv75internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv75errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv75transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv75transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8,
  pv77pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosteriorInvalida',
  },
  pv77pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv77subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv77pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv77pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv77internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv77errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv77transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv77transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 22,
  pv78pageName: {
    path: 'page.name',
    value: 'ErrorDocumentoInvalido',
  },
  pv78pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv78subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv78pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv78pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv78internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv78errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv78transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv78transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 23,
  pv79pageName: {
    path: 'page.name',
    value: 'ErrorCedulaFrontalInvalida',
  },
  pv79pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv79subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv79pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv79pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv79internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv79errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv79transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv79transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantallas de Cuenta Ahorros Cliente Existente,
  // Pantalla 1,
  pv81pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv81pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv81subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv81pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv81pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv81internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv81errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv81transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv81transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 2,
  pv82pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatosOpcional',
  },
  pv82pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv82subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv82pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv82pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv82internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv82errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv82transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv82transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 3,
  pv83pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatos',
  },
  pv83pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv83subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv83pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv83pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv83internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv83errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv83transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv83transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 4,
  pv84pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracionProducto',
  },
  pv84pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv84subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv84pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv84pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv84internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv84errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv84transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv84transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 6,
  pv86pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatosObligatoria',
  },
  pv86pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv86subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv86pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv86pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv86internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv86errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv86transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv86transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantallas de CuentasConfiguracionVinculacionAbrir - Cuenta Ahorros Cliente Existente,
  // Pantalla 1,
  pv88pageName: {
    path: 'page.name',
    value: 'ConfirmaCelular',
  },
  pv88pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv88subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv88pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv88pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv88internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv88errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv88transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv88transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 2,
  pv89pageName: {
    path: 'page.name',
    value: 'VinculacionBasica',
  },
  pv89pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv89subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv89pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv89pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv89internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv89errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv89transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv89transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv89transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },

  // Pantalla 4,
  pv91pageName: {
    path: 'page.name',
    value: 'ExitoCuentaCreada',
  },
  pv91pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv91subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv91pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv91pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv91internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv91errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv91transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv91transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 5,
  pv92pageName: {
    path: 'page.name',
    value: 'VinculacionSucursales',
  },
  pv92pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv92subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv92pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv92pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv92internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv92errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv92transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv92transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 7,
  pv94pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv94pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv94subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv94pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv94pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv94internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv94errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv94transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv94transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 8,
  pv95pageName: {
    path: 'page.name',
    value: 'VinculacionPersonal',
  },
  pv95pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv95subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv95pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv95pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv95internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv95errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv95transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv95transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantallas de   CuentasCapturaDocumentoAbrir  - Cuenta Nomina,

  // Pantalla 1,
  pv120pageName: {
    path: 'page.name',
    value: 'LinkVTUP',
  },
  pv120pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv120subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv120pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv120pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv120internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv120errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv120transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv120transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 2,
  pv98pageName: {
    path: 'page.name',
    value: 'CuentaNomina',
  },
  pv98pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv98subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv98pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv98pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv98internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv98errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv98transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv98transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 3,
  pv100pageName: {
    path: 'page.name',
    value: 'PrepararCapturaCedula',
  },
  pv100pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv100subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv100pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv100pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv100customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv100internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv100errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv100transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv100transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv100transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 4,
  pv101pageName: {
    path: 'page.name',
    value: 'InicioCapturaCedula',
  },
  pv101pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv101subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv101pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv101pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv101customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv101internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv101errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv101transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv101transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv101transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 5,
  pv102pageName: {
    path: 'page.name',
    value: 'CapturaCedulaPosterior',
  },
  pv102pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv102subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv102pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv102pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv102customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv102internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv102errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv102transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv102transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv102transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 6,
  pv103pageName: {
    path: 'page.name',
    value: 'InicioCedulaFrontal',
  },
  pv103pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv103subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv103pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv103pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv103customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv103internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv103errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv103transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv103transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv103transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 7,
  pv104pageName: {
    path: 'page.name',
    value: 'CapturaCedulaFrontal',
  },
  pv104pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv104subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv104pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv104pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv104customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv104internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv104errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv104transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv104transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv104transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 8,
  pv105pageName: {
    path: 'page.name',
    value: 'ExitoCapturaCedula',
  },
  pv105pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv105subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv105pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv105pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv105customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv105internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv105errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv105transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv105transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv105transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 9,
  pv106pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv106pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv106subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv106pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv106pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv106customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv106internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv106errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv106transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv106transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv106transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 10,
  pv107pageName: {
    path: 'page.name',
    value: 'InicioCapturaHuellas',
  },
  pv107pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv107subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv107pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv107pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv107customTransactionStep: {
    path: 'custom.events.transactionstep09',
    value: '1',
  },
  pv107internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv107errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv107transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '9',
  },
  pv107transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv107transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 11,
  pv108pageName: {
    path: 'page.name',
    value: 'CapturaHuellas',
  },
  pv108pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv108subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv108pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv108pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv108customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv108internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv108errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv108transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv108transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv108transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 12,
  pv388pageName: {
    path: 'page.name',
    value: 'ExitoPreCargaDatos',
  },
  pv388pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv388subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv388pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv388pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv388customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv388internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv388errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv388transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv388transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv388transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 13,
  pv109pageName: {
    path: 'page.name',
    value: 'TratamientoDeDatos',
  },
  pv109pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv109subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv109pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv109pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv109internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv109errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv109transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv109transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 14,
  pv110pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosterior',
  },
  pv110pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv110subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv110pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv110pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv110internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv110errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv110transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv110transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 15,
  pv111pageName: {
    path: 'page.name',
    value: 'ErrorListasRestrictivas',
  },
  pv111pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv111subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv111pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv111pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv111internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv111errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv111transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv111transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 16,
  pv112pageName: {
    path: 'page.name',
    value: 'ErrorCapturaFrontal',
  },
  pv112pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv112subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv112pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv112pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv112internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv112errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv112transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv112transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 17,
  pv113pageName: {
    path: 'page.name',
    value: 'ErrorPersonaPEP',
  },
  pv113pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv113subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv113pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv113pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv113internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv113errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv113transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv113transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 18,
  pv114pageName: {
    path: 'page.name',
    value: 'ErrorCapturaHuellas',
  },
  pv114pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv114subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv114pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv114pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv114internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv114errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv114transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv114transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 19,
  pv115pageName: {
    path: 'page.name',
    value: 'ErrorHuellasInvalidas',
  },
  pv115pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv115subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv115pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv115pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv115internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv115errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv115transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv115transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 20,
  pv116pageName: {
    path: 'page.name',
    value: 'ErrorPermisosUsoCamara',
  },
  pv116pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv116subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv116pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv116pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv116internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv116errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv116transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv116transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 21,
  pv117pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosteriorInvalida',
  },
  pv117pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv117subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv117pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv117pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv117internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv117errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv117transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv117transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 22,
  pv118pageName: {
    path: 'page.name',
    value: 'ErrorDocumentoInvalido',
  },
  pv118pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv118subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv118pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv118pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv118internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv118errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv118transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv118transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 23,
  pv119pageName: {
    path: 'page.name',
    value: 'ErrorCedulaFrontalInvalida',
  },
  pv119pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv119subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv119pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv119pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv119internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv119errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv119transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv119transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 24,
  pv389pageName: {
    path: 'page.name',
    value: 'BuscaConvenio',
  },
  pv389pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv389subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv389pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv389pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv389customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv389internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv389errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv389transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv389transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv389transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 25,
  pv390pageName: {
    path: 'page.name',
    value: 'MensajeClienteExistente',
  },
  pv390pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv390subFamily: {
    path: 'page.subfamily',
    value: 'CapturaDocumento',
  },
  pv390pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv390pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv390internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv390errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv390transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNomina',
  },
  pv390transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantallas de CuentasIngresoDatosAbrir - Cuenta Nomina Cliente Existente,
  // Pantalla 1,
  pv121pageName: {
    path: 'page.name',
    value: 'ActualizacionVoluntaria',
  },
  pv121pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv121subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv121pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv121pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv121customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv121internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv121errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv121transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv121transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv121transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2,
  pv122pageName: {
    path: 'page.name',
    value: 'ConfirmacionActualizacionDatos',
  },
  pv122pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv122subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv122pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv122pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv122customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv122internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv122errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv122transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv122transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv122transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3,
  pv123pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracionProducto',
  },
  pv123pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv123subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv123pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv123pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv123customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv123internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv123errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv123transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv123transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv123transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4,
  pv124pageName: {
    path: 'page.name',
    value: 'ActualizacionObligatoria',
  },
  pv124pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv124subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv124pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv124pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv124customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv124internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv124errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv124transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv124transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv124transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5,
  pv125pageName: {
    path: 'page.name',
    value: 'SeleccionRecibirTarjeta',
  },
  pv125pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv125subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv125pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv125pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv125customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv125internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv125errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv125transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv125transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv125transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6,
  pv126pageName: {
    path: 'page.name',
    value: 'SeleccionarDireccionEntrega',
  },
  pv126pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv126subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv126pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv126pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv126customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv126internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv126errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv126transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv126transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv126transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantallas de CuentasConfiguracionVinculacionAbrir - Cuenta Nomina Cliente Existente,
  // Pantalla 1,
  pv127pageName: {
    path: 'page.name',
    value: 'ConfirmaCelular',
  },
  pv127pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv127subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv127pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv127pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv127customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv127internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv127errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv127transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv127transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv127transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 2,
  pv128pageName: {
    path: 'page.name',
    value: 'VinculacionUsaYNoPaguesSucursales',
  },
  pv128pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv128subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv128pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv128pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv128customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv128internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv128errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv128transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv128transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv128transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 3,
  pv129pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv129pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv129subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv129pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv129pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv129internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv129errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv129customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv129transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv129transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv129transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 4,
  pv130pageName: {
    path: 'page.name',
    value: 'ExitoCuentaCreada',
  },
  pv130pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv130subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv130pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv130pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv130customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv130internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv130errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv130transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv130transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv130transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 5,
  pv131pageName: {
    path: 'page.name',
    value: 'VinculacionConBeneficios',
  },
  pv131pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv131subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv131pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv131pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv131customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv131internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv131errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv131transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv131transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv131transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 6,
  pv132pageName: {
    path: 'page.name',
    value: 'ErrorCargaVinculacion',
  },
  pv132pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv132subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv132pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv132pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv132internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv132errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv132transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv132transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 7,
  pv133pageName: {
    path: 'page.name',
    value: 'TerminosYCondiciones',
  },
  pv133pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv133subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv133pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv133pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv133internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv133errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv133transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv133transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 8,
  pv134pageName: {
    path: 'page.name',
    value: 'VinculacionSinBeneficios',
  },
  pv134pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv134subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv134pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv134pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv134customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv134internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv134errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv134transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv134transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCE',
  },
  pv134transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantallas de CuentasIngresoDatosAbrir  - Ahorro CN,
  // Pantalla 1,
  pv165pageName: {
    path: 'page.name',
    value: 'VerificarDatoFrontal',
  },
  pv165pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv165subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv165pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv165pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv165internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv165errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv165transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv165transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 2,
  pv167pageName: {
    path: 'page.name',
    value: 'IngresarInformacionesContacto',
  },
  pv167pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv167subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv167pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv167pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv167internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv167errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv167transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv167transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 3,
  pv168pageName: {
    path: 'page.name',
    value: 'ResidenciaExterior',
  },
  pv168pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv168subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv168pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv168pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv168internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv168errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv168transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv168transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 22,
  pv169pageName: {
    path: 'page.name',
    value: 'ErrorResideEnElExterior',
  },
  pv169pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv169subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv169pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv169pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv169internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv169errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv169transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv169transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 4,
  pv170pageName: {
    path: 'page.name',
    value: 'DondeVives',
  },
  pv170pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv170subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv170pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv170pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv170internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv170errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv170transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv170transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 5,
  pv171pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv171pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv171subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv171pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv171pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv171internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv171errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv171transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv171transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 6,
  pv173pageName: {
    path: 'page.name',
    value: 'DondeTrabajasEmpleado',
  },
  pv173pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv173subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv173pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv173pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv173internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv173errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv173transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv173transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 7,
  pv174pageName: {
    path: 'page.name',
    value: 'ActividadEconomica',
  },
  pv174pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv174subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv174pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv174pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv174internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv174errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv174transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv174transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 8,
  pv175pageName: {
    path: 'page.name',
    value: 'InformacionEmpresaIndependente',
  },
  pv175pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv175subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv175pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv175pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv175internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv175errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv175transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv175transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 9,
  pv176pageName: {
    path: 'page.name',
    value: 'PreguntasFinancieras',
  },
  pv176pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv176subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv176pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv176pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv176internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv176errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv176transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv176transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 10,
  pv172pageName: {
    path: 'page.name',
    value: 'ErrorOcupacion',
  },
  pv172pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv172subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv172pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv172pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv172internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv172errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv172transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv172transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 11,
  pv177pageName: {
    path: 'page.name',
    value: 'IngresosMensuales',
  },
  pv177pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv177subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv177pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv177pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv177internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv177errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv177transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv177transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 12,
  pv178pageName: {
    path: 'page.name',
    value: 'GastosMensuales',
  },
  pv178pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv178subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv178pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv178pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv178internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv178errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv178transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv178transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 13,
  pv179pageName: {
    path: 'page.name',
    value: 'BienesDeudas',
  },
  pv179pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv179subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv179pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv179pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv179internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv179errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv179transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv179transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 14,
  pv180pageName: {
    path: 'page.name',
    value: 'MonedaExtranjera',
  },
  pv180pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv180subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv180pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv180pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv180internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv180errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv180transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv180transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 15,
  pv181pageName: {
    path: 'page.name',
    value: 'OperacionExtranjera',
  },
  pv181pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv181subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv181pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv181pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv181internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv181errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv181transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv181transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 16,
  pv182pageName: {
    path: 'page.name',
    value: 'TitularProductosExtranjeros',
  },
  pv182pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv182subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv182pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv182pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv182internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv182errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv182transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv182transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 17,
  pv183pageName: {
    path: 'page.name',
    value: 'DatosProductosExtranjeros',
  },
  pv183pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv183subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv183pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv183pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv183internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv183errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv183transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv183transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 18,
  pv184pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracionProducto',
  },
  pv184pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv184subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv184pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv184pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv184internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv184errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv184transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv184transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 19,
  pv225pageName: {
    path: 'page.name',
    value: 'SeleccionRecibirTarjeta',
  },
  pv225pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv225subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv225pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv225pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv225internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv225errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv225transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv225transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 20,
  pv226pageName: {
    path: 'page.name',
    value: 'SeleccionarDireccionEntrega',
  },
  pv226pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv226subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv226pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv226pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv226internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv226errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv226transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv226transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 23,
  pv166pageName: {
    path: 'page.name',
    value: 'ErrorProductosExtranjero',
  },
  pv166pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv166subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv166pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv166pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv166internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv166errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv166transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv166transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantallas de CuentasIngresoDatosAbrir  - Nomina CN,
  // Pantalla 1,
  pv187pageName: {
    path: 'page.name',
    value: 'VerificarDatoFrontal',
  },
  pv187pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv187subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv187pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv187pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv187customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv187internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv187errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv187transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv187transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv187transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2,
  pv189pageName: {
    path: 'page.name',
    value: 'IngresarInformacionesContacto',
  },
  pv189pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv189subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv189pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv189pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv189customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv189internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv189errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv189transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv189transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv189transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3,
  pv190pageName: {
    path: 'page.name',
    value: 'EnDondeNaciste',
  },
  pv190pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv190subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv190pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv190pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv190customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv190internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv190errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv190transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv190transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv190transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4,
  pv192pageName: {
    path: 'page.name',
    value: 'DondeVives',
  },
  pv192pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv192subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv192pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv192pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv192customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv192internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv192errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv192transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv192transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv192transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5,
  pv193pageName: {
    path: 'page.name',
    value: 'DondeTrabajas',
  },
  pv193pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv193subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv193pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv193pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv193customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv193internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv193errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv193transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv193transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv193transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6,
  pv191pageName: {
    path: 'page.name',
    value: 'ErrorResidenciaExterior',
  },
  pv191pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv191subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv191pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv191pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv191internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv191errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv191transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv191transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7,
  pv188pageName: {
    path: 'page.name',
    value: 'ErrorProductosExtranjero',
  },
  pv188pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv188subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv188pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv188pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv188internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv188errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv188transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv188transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 8,
  pv196pageName: {
    path: 'page.name',
    value: 'OrigenIngresos',
  },
  pv196pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv196subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv196pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv196pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv196internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv196errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv196transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv196transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 9,
  pv194pageName: {
    path: 'page.name',
    value: 'PreguntasFinancieras',
  },
  pv194pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv194subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv194pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv194pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv194customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv194internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv194errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv194transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv194transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv194transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 10,
  pv195pageName: {
    path: 'page.name',
    value: 'IngresosMensuales',
  },
  pv195pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv195subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv195pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv195pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv195customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv195internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv195errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv195transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv195transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv195transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 11,
  pv197pageName: {
    path: 'page.name',
    value: 'GastosMensuales',
  },
  pv197pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv197subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv197pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv197pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv197customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv197internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv197errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv197transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv197transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv197transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 12,
  pv198pageName: {
    path: 'page.name',
    value: 'BienesDeudas',
  },
  pv198pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv198subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv198pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv198pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv198customTransactionStep: {
    path: 'custom.events.transactionstep09',
    value: '1',
  },
  pv198internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv198errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv198transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '9',
  },
  pv198transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv198transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 13,
  pv199pageName: {
    path: 'page.name',
    value: 'MonedaExtranjera',
  },
  pv199pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv199subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv199pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv199pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv199customTransactionStep: {
    path: 'custom.events.transactionstep10',
    value: '1',
  },
  pv199internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv199errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv199transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '10',
  },
  pv199transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv199transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 14,
  pv200pageName: {
    path: 'page.name',
    value: 'OperacionExtranjera',
  },
  pv200pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv200subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv200pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv200pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv200customTransactionStep: {
    path: 'custom.events.transactionstep11',
    value: '1',
  },
  pv200internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv200errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv200transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '11',
  },
  pv200transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv200transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 15,
  pv201pageName: {
    path: 'page.name',
    value: 'TitularProductosExtranjeros',
  },
  pv201pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv201subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv201pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv201pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv201customTransactionStep: {
    path: 'custom.events.transactionstep12',
    value: '1',
  },
  pv201internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv201errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv201transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '12',
  },
  pv201transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv201transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 16,
  pv202pageName: {
    path: 'page.name',
    value: 'DatosProductosExtranjeros',
  },
  pv202pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv202subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv202pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv202pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv202customTransactionStep: {
    path: 'custom.events.transactionstep13',
    value: '1',
  },
  pv202internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv202errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv202transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '13',
  },
  pv202transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv202transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 17,
  pv203pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracionProducto',
  },
  pv203pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv203subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv203pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv203pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv203customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv203internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv203errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv203transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv203transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv203transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 18,
  pv228pageName: {
    path: 'page.name',
    value: 'SeleccionRecibirTarjeta',
  },
  pv228pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv228subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv228pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv228pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv228customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv228internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv228errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv228transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv228transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv228transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 19,
  pv229pageName: {
    path: 'page.name',
    value: 'SeleccionarDireccionEntrega',
  },
  pv229pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv229subFamily: {
    path: 'page.subfamily',
    value: 'IngresoDatos',
  },
  pv229pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv229pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv229customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv229internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv229errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv229transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv229transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv229transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantallas de CuentasConfiguracionVinculacionAbrir - Cuenta Ahorros Cliente Nuevo,

  // Pantalla 1,
  pv205pageName: {
    path: 'page.name',
    value: 'SeleccionaOficina',
  },
  pv205pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv205subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv205pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv205pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv205internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv205errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv205transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv205transactionName: {
    path: 'transaction.name',
    value: 'Configurar',
  },

  // Pantalla 2,
  pv206pageName: {
    path: 'page.name',
    value: 'ConfimaOficina',
  },
  pv206pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv206subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv206pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv206pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv206internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv206errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv206transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv206transactionName: {
    path: 'transaction.name',
    value: 'Configurar',
  },

  // Pantalla 3,
  pv207pageName: {
    path: 'page.name',
    value: 'ConfirmaCelular',
  },
  pv207pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv207subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv207pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv207pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv207internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv207errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv207transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv207transactionName: {
    path: 'transaction.name',
    value: 'Configurar',
  },

  // Pantalla 4,
  pv208pageName: {
    path: 'page.name',
    value: 'VinculacionBasica',
  },
  pv208pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv208subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv208pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv208pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv208internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv208errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv208transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv208transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 5,
  pv209pageName: {
    path: 'page.name',
    value: 'VinculacionSucursales',
  },
  pv209pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv209subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv209pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv209pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv209internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv209errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv209transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv209transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 6,
  pv210pageName: {
    path: 'page.name',
    value: 'VinculacionPersonal',
  },
  pv210pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv210subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv210pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv210pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv210internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv210errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv210transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv210transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 7,
  pv211pageName: {
    path: 'page.name',
    value: 'ExitoCuentaCreada',
  },
  pv211pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv211subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv211pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv211pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv211internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv211errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv211transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv211transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantallas de CuentasConfiguracionVinculacionAbrir - Cuenta Nomina Cliente Nuevo,

  // Pantalla 1,
  pv213pageName: {
    path: 'page.name',
    value: 'SeleccionaOficina',
  },
  pv213pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv213subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv213pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv213pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv213customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv213internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv213errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv213transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv213transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv213transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 2,
  pv214agencystoreid: {
    path: 'visitor.agencystoreid',
    value: null,
  },
  pv214pageName: {
    path: 'page.name',
    value: 'ConfimaOficina',
  },
  pv214pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv214subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv214pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv214pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv214customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv214internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv214errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv214transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv214transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv214transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv214transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 3,
  pv215pageName: {
    path: 'page.name',
    value: 'ConfirmaCelular',
  },
  pv215pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv215subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv215pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv215pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv215customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv215internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv215errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv215transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv215transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv215transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 4,
  pv216pageName: {
    path: 'page.name',
    value: 'VinculacionUsaYNoPaguesSucursales',
  },
  pv216pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv216subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv216pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv216pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv216customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv216internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv216errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv216transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv216transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv216transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 5,
  pv217pageName: {
    path: 'page.name',
    value: 'VinculacionConBeneficios',
  },
  pv217pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv217subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv217pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv217pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv217customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv217internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv217errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv217transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv217transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv217transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 6,
  pv218pageName: {
    path: 'page.name',
    value: 'VinculacionSinBeneficios',
  },
  pv218pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv218subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv218pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv218pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv218customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv218internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv218errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv218transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv218transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv218transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 7,
  pv219pageName: {
    path: 'page.name',
    value: 'ExitoCuentaCreada',
  },
  pv219pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv219subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv219pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv219pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv219customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv219internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv219errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv219transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv219transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaNominaCN',
  },
  pv219transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantallas de PrestamoPersonalesContratar - Captura Documento,

  // Pantalla 1,
  pv262pageName: {
    path: 'page.name',
    value: 'MensajeClienteExistente',
  },
  pv262pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv262subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv262pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv262pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv262internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv262errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv262transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv262transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 2,
  pv238pageName: {
    path: 'page.name',
    value: 'SolicitudTC',
  },
  pv238pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv238subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv238pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv238pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv238internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv238errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv238transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv238transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 3,
  pv239pageName: {
    path: 'page.name',
    value: 'PasoAPaso',
  },
  pv239pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv239subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv239pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv239pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv239customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv239internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv239errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv239transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv239transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv239transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 4,

  pv240pageName: {
    path: 'page.name',
    value: 'PrepararCapturaCedula',
  },
  pv240pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv240subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv240pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv240pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv240customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv240internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv240errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv240transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv240transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv240transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 5,

  pv241pageName: {
    path: 'page.name',
    value: 'InicioCapturaCedula',
  },
  pv241pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv241subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv241pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv241pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv241customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv241internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv241errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv241transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv241transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv241transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 6,

  pv242pageName: {
    path: 'page.name',
    value: 'CapturaCedulaPosterior',
  },
  pv242pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv242subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv242pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv242pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv242customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv242internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv242errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv242transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv242transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv242transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 7,

  pv243pageName: {
    path: 'page.name',
    value: 'InicioCedulaFrontal',
  },
  pv243pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv243subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv243pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv243pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv243customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv243internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv243errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv243transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv243transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv243transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 8,

  pv244pageName: {
    path: 'page.name',
    value: 'CapturaCedulaFrontal',
  },
  pv244pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv244subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv244pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv244pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv244customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv244internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv244errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv244transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv244transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv244transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 9,

  pv245pageName: {
    path: 'page.name',
    value: 'ExitoCapturaCedula',
  },
  pv245pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv245subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv245pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv245pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv245customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv245internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv245errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv245transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv245transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv245transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pnatalla 10,

  pv246pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv246pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv246subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv246pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv246pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv246customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv246internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv246errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv246transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv246transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv246transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 11,

  pv247pageName: {
    path: 'page.name',
    value: 'InicioCapturaHuellas',
  },
  pv247pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv247subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv247pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv247pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv247customTransactionStep: {
    path: 'custom.events.transactionstep09',
    value: '1',
  },
  pv247internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv247errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv247transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv247transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '9',
  },
  pv247transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 12,

  pv248pageName: {
    path: 'page.name',
    value: 'CapturaHuellas',
  },
  pv248pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv248subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv248pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv248pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv248customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv248internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv248errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv248transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv248transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv248transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 13,

  pv249pageName: {
    path: 'page.name',
    value: 'ExitoPrecargaDatos',
  },
  pv249pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv249subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv249pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv249pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv249customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv249internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv249errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv249transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv249transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv249transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 14,
  pv250pageName: {
    path: 'page.name',
    value: 'TratamientoDeDatos',
  },
  pv250pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv250subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv250pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv250pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv250internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv250errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv250transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv250transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 15,
  pv251pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosterior',
  },
  pv251pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv251subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv251pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv251pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv251internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv251errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv251transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv251transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 16,

  pv252pageName: {
    path: 'page.name',
    value: 'ErrorListasRestrictivas',
  },
  pv252pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv252subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv252pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv252pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv252internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv252errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv252transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv252transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 17,
  pv253pageName: {
    path: 'page.name',
    value: 'ErrorCapturaFrontal',
  },
  pv253pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv253subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv253pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv253pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv253internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv253errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv253transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv253transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 18,

  pv254pageName: {
    path: 'page.name',
    value: 'ErrorPersonaPEP',
  },
  pv254pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv254subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv254pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv254pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv254internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv254errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv254transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv254transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 19,
  pv255pageName: {
    path: 'page.name',
    value: 'ErrorCapturaHuellas',
  },
  pv255pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv255subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv255pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv255pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv255internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv255errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv255transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv255transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 20,

  pv256pageName: {
    path: 'page.name',
    value: 'ErrorHuellasInvalidas',
  },
  pv256pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv256subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv256pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv256pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv256internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv256errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv256transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv256transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 21,
  pv257pageName: {
    path: 'page.name',
    value: 'ErrorPermisosUsoCamara',
  },
  pv257pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv257subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv257pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv257pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv257internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv257errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv257transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv257transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 22,

  pv258pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosteriorInvalida',
  },
  pv258pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv258subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv258pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv258pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv258internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv258errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv258transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv258transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 23,
  pv259pageName: {
    path: 'page.name',
    value: 'ErrorDocumentoInvalido',
  },
  pv259pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv259subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv259pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv259pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv259internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv259errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv259transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },
  pv259transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },

  // Pantalla 24,
  pv260pageName: {
    path: 'page.name',
    value: 'ErrorCedulaFrontalInvalida',
  },
  pv260pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv260subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv260pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv260pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv260internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv260errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv260transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv260transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 25,
  pv261pageName: {
    path: 'page.name',
    value: 'LinkVTUP',
  },
  pv261pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv261subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv261pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv261pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv261internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv261errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv261transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv261transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantallas de PrestamoPersonalesContratar - Credito Rotativo Ingreso,
  // Pantalla 1,
  pv263pageName: {
    path: 'page.name',
    value: 'Asegurabilidad',
  },
  pv263pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv263subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv263pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv263pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv263customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv263internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv263errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv263transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv263transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv263transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2,
  pv264pageName: {
    path: 'page.name',
    value: 'DeclaracionAsegurabilidad',
  },
  pv264pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv264subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv264pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv264pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv264internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv264errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv264transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv264transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3,
  pv265pageName: {
    path: 'page.name',
    value: 'ErrorNoAsegurable',
  },
  pv265pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv265subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv265pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv265pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv265internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv265errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv265transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv265transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4,
  pv266pageName: {
    path: 'page.name',
    value: 'VerificarDatoCedula',
  },
  pv266pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv266subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv266pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv266pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv266customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv266internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv266errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv266transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv266transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv266transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5,
  pv267pageName: {
    path: 'page.name',
    value: 'IngresarInformacionesContacto',
  },
  pv267pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv267subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv267pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv267pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv267customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv267internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv267errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv267transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv267transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv267transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6,
  pv268pageName: {
    path: 'page.name',
    value: 'ResidenciaExterior',
  },
  pv268pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv268subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv268pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv268pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv268customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv268internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv268errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv268transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv268transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv268transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7,
  pv269pageName: {
    path: 'page.name',
    value: 'ErrorResidenciaExterior',
  },
  pv269pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv269subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv269pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv269pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv269internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv269errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv269transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv269transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 8,
  pv270pageName: {
    path: 'page.name',
    value: 'DondeVives',
  },
  pv270pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv270subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv270pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv270pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv270customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv270internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv270errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv270transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv270transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv270transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 9,
  pv271pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv271pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv271subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv271pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv271pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv271customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv271internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv271errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv271transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv271transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv271transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 10,
  pv272pageName: {
    path: 'page.name',
    value: 'SeleccionEmpleado',
  },
  pv272pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv272subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv272pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv272pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv272internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv272errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv272transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv272transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 11,
  pv273pageName: {
    path: 'page.name',
    value: 'DondeTrabajasEmpleado',
  },
  pv273pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv273subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv273pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv273pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv273internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv273errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv273transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv273transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 12,
  pv274pageName: {
    path: 'page.name',
    value: 'IngresosMensuales',
  },
  pv274pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv274subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv274pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv274pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv274customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv274internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv274errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv274transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv274transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv274transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv274transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 13,
  pv275pageName: {
    path: 'page.name',
    value: 'OfertaAprobada',
  },
  pv275pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv275subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv275pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv275pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv275customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv275internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv275errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv275transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv275transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv275transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 14,
  pv276pageName: {
    path: 'page.name',
    value: 'ZonaGris',
  },
  pv276pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv276subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv276pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv276pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv276customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv276internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv276errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv276transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv276transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv276transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 15,
  pv277pageName: {
    path: 'page.name',
    value: 'ErrorRechazadoPco',
  },
  pv277pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv277subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv277pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv277pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv277internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv277errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv277transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv277transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 16,
  pv312pageName: {
    path: 'page.name',
    value: 'ErrorQueremosConocerte',
  },
  pv312pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv312subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv312pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv312pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv312internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv312errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv312transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv312transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 17,
  pv278pageName: {
    path: 'page.name',
    value: 'DocumentosEmpleado',
  },
  pv278pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv278subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv278pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv278pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv278internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv278errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv278transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv278transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 18,
  pv279pageName: {
    path: 'page.name',
    value: 'DocumentosPensionado',
  },
  pv279pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv279subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv279pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv279pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv279internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv279errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv279transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv279transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 19,
  pv280pageName: {
    path: 'page.name',
    value: 'DocumentosIndependiente',
  },
  pv280pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv280subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv280pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv280pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv280internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv280errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv280transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv280transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 20,
  pv281pageName: {
    path: 'page.name',
    value: 'DocumentosRentista',
  },
  pv281pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv281subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv281pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv281pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv281internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv281errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv281transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv281transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 21,
  pv282pageName: {
    path: 'page.name',
    value: 'InformacionEmpresaIndependente',
  },
  pv282pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv282subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv282pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv282pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv282internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv282errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv282transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv282transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 22,
  pv285pageName: {
    path: 'page.name',
    value: 'DatosInformacionEmpresa',
  },
  pv285pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv285subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv285pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv285pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv285internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv285errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv285transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv285transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 23,
  pv286pageName: {
    path: 'page.name',
    value: 'OrigenIngresos',
  },
  pv286pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv286subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv286pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv286pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv286internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv286errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv286transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv286transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 24,
  pv287pageName: {
    path: 'page.name',
    value: 'ErrorRechazoContrato',
  },
  pv287pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv287subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv287pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv287pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv287internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv287errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv287transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv287transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantallas de PrestamoPersonalesContratar - Credito rotativo Vinculacion,
  // Pantalla 1,
  pv288pageName: {
    path: 'page.name',
    value: 'GastosMensuales',
  },
  pv288pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv288subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv288pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv288pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv288customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv288internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv288errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv288transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv288transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv288transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 2,
  pv289pageName: {
    path: 'page.name',
    value: 'ValorBienesYDeudas',
  },
  pv289pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv289subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv289pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv289pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv289customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv289internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv289errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv289transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv289transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv289transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 3,
  pv290pageName: {
    path: 'page.name',
    value: 'RealizaOpMonedaExtranjera',
  },
  pv290pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv290subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv290pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv290pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv290customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv290internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv290errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv290transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv290transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv290transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 4,
  pv291pageName: {
    path: 'page.name',
    value: 'TipoOperacionME',
  },
  pv291pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv291subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv291pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv291pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv291internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv291errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv291transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv291transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 5,
  pv292pageName: {
    path: 'page.name',
    value: 'TitularMonedaExtranjera',
  },
  pv292pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv292subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv292pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv292pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv292customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv292internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv292errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv292transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv292transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv292transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 6,
  pv293pageName: {
    path: 'page.name',
    value: 'TipoProductoME',
  },
  pv293pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv293subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv293pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv293pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv293internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv293errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv293transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv293transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 7,
  pv294pageName: {
    path: 'page.name',
    value: 'ErrorPais',
  },
  pv294pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv294subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv294pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv294pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv294internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv294errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv294transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv294transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 8,
  pv295pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracion',
  },
  pv295pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv295subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv295pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv295pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv295customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv295internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv295errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv295transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv295transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv295transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 9,
  pv296pageName: {
    path: 'page.name',
    value: 'SeleccionaOficina',
  },
  pv296pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv296subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv296pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv296pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv296customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv296internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv296errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv296transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv296transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv296transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 10,
  pv297pageName: {
    path: 'page.name',
    value: 'ConfirmaOficina',
  },
  pv297pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv297subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv297pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv297pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv297customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv297internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv297errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv297transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv297transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv297transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 11,
  pv298pageName: {
    path: 'page.name',
    value: 'ConfirmarCuentaAhorros',
  },
  pv298pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv298subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv298pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv298pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv298customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv298internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv298errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv298transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv298transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv298transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 12,
  pv299pageName: {
    path: 'page.name',
    value: 'RecibirTuTarjeta',
  },
  pv299pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv299subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv299pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv299pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv299customTransactionStep: {
    path: 'custom.events.transactionstep09',
    value: '1',
  },
  pv299internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv299errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv299transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '9',
  },
  pv299transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv299transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 13,
  pv300pageName: {
    path: 'page.name',
    value: 'SeleccionaUnaDireccion',
  },
  pv300pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv300subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv300pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv300pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv300internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv300errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv300transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv300transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 14,
  pv302pageName: {
    path: 'page.name',
    value: 'ConfirmaCelular',
  },
  pv302pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv302subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv302pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv302pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv302customTransactionStep: {
    path: 'custom.events.transactionstep10',
    value: '1',
  },
  pv302internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv302errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv302transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '10',
  },
  pv302transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv302transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv302transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 15,
  pv303pageName: {
    path: 'page.name',
    value: 'AsistidoOAutogestion',
  },
  pv303pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv303subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv303pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv303pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv303customTransactionStep: {
    path: 'custom.events.transactionstep11',
    value: '1',
  },
  pv303internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv303errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv303transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '11',
  },
  pv303transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv303transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 16,
  pv304pageName: {
    path: 'page.name',
    value: 'OnLineVinculacionSucursales',
  },
  pv304pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv304subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv304pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv304pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv304customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv304internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv304errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv304transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv304transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv304transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv304transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 17,
  pv305pageName: {
    path: 'page.name',
    value: 'ExitoCuentaCreada',
  },
  pv305pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv305subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv305pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv305pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv305customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv305internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv305errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv305transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv305transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv305transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv305transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv305transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 18,
  pv306pageName: {
    path: 'page.name',
    value: 'ExitoRotativoCreado',
  },
  pv306pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv306subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv306pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv306pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv306customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv306internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv306errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv306transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv306transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv306transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv306transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv306transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 19,
  pv307pageName: {
    path: 'page.name',
    value: 'RotativoEnProceso',
  },
  pv307pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv307subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv307pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv307pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv307internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv307errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv307transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv307transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv307transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv307transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 20,
  pv308pageName: {
    path: 'page.name',
    value: 'TerminosYCondiciones',
  },
  pv308pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv308subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv308pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv308pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv308internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv308errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv308transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv308transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 21,
  pv309pageName: {
    path: 'page.name',
    value: 'OffLineVinculacionSucursales',
  },
  pv309pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv309subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv309pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv309pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv309customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv309internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv309errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv309transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv309transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv309transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv309transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 22,
  pv310pageName: {
    path: 'page.name',
    value: 'OffLineVinculacionPersonal',
  },
  pv310pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv310subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv310pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv310pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv310customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv310internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv310errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv310transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv310transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv310transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'RotativoCN',
  },
  pv310transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Prestamo Personales Contratar - Prestamos,

  // Pantalla 1,
  pv387pageName: {
    path: 'page.name',
    value: 'ErrorLocalizacion',
  },
  pv387pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv387subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv387pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv387pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv387internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv387errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv387transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv387transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 2,
  pv313pageName: {
    path: 'page.name',
    value: 'SolicitudTC',
  },
  pv313pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv313subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv313pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv313pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv313internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv313errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv313transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv313transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 3,
  pv314pageName: {
    path: 'page.name',
    value: 'PasoAPaso',
  },
  pv314pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv314subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv314pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv314pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv314customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv314internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv314errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv314transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv314transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv314transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 27,
  pv315pageName: {
    path: 'page.name',
    value: 'EscogeMonto',
  },
  pv315pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv315subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv315pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv315pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv315customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv315internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv315errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv315transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv315transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv315transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 28,
  pv316pageName: {
    path: 'page.name',
    value: 'EscogePlazo',
  },
  pv316pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv316subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv316pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv316pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv316customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv316internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv316errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv316transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv316transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv316transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 4,
  pv317pageName: {
    path: 'page.name',
    value: 'PrepararCapturaCedula',
  },
  pv317pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv317subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv317pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv317pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv317customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv317internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv317errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv317transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv317transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv317transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 5,
  pv318pageName: {
    path: 'page.name',
    value: 'InicioCapturaCedula',
  },
  pv318pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv318subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv318pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv318pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv318customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv318internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv318errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv318transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv318transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv318transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 6,
  pv319pageName: {
    path: 'page.name',
    value: 'CapturaCedulaPosterior',
  },
  pv319pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv319subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv319pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv319pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv319customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv319internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv319errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv319transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv319transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv319transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 7,
  pv320pageName: {
    path: 'page.name',
    value: 'InicioCedulaFrontal',
  },
  pv320pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv320subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv320pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv320pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv320customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv320internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv320errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv320transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv320transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv320transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 8,
  pv321pageName: {
    path: 'page.name',
    value: 'CapturaCedulaFrontal',
  },
  pv321pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv321subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv321pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv321pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv321customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv321internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv321errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv321transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv321transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv321transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 9,
  pv322pageName: {
    path: 'page.name',
    value: 'ExitoCapturaCedula',
  },
  pv322pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv322subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv322pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv322pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv322customTransactionStep: {
    path: 'custom.events.transactionstep09',
    value: '1',
  },
  pv322internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv322errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv322transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '9',
  },
  pv322transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv322transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 10,
  pv323pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv323pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv323subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv323pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv323pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv323customTransactionStep: {
    path: 'custom.events.transactionstep10',
    value: '1',
  },
  pv323internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv323errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv323transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '10',
  },
  pv323transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv323transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 11,
  pv324pageName: {
    path: 'page.name',
    value: 'InicioCapturaHuellas',
  },
  pv324pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv324subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv324pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv324pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv324customTransactionStep: {
    path: 'custom.events.transactionstep11',
    value: '1',
  },
  pv324internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv324errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv324transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '11',
  },
  pv324transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv324transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 12,
  pv325pageName: {
    path: 'page.name',
    value: 'CapturaHuellas',
  },
  pv325pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv325subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv325pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv325pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv325customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv325internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv325errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv325transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv325transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv325transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 13,
  pv326pageName: {
    path: 'page.name',
    value: 'ExitoPreCargaDatos',
  },
  pv326pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv326subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv326pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv326pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv326customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv326internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv326errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv326transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv326transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv326transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 14,
  pv327pageName: {
    path: 'page.name',
    value: 'TratamientoDeDatos',
  },
  pv327pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv327subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv327pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv327pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv327internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv327errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv327transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv327transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 15,
  pv328pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosterior',
  },
  pv328pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv328subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv328pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv328pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv328internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv328errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv328transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv328transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 16,
  pv329pageName: {
    path: 'page.name',
    value: 'ErrorListasRestrictivas',
  },
  pv329pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv329subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv329pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv329pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv329internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv329errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv329transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv329transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 17,
  pv330pageName: {
    path: 'page.name',
    value: 'ErrorCapturaFrontal',
  },
  pv330pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv330subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv330pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv330pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv330internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv330errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv330transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv330transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 18,
  pv331pageName: {
    path: 'page.name',
    value: 'ErrorPersonaPEP',
  },
  pv331pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv331subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv331pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv331pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv331internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv331errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv331transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv331transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 19,
  pv332pageName: {
    path: 'page.name',
    value: 'ErrorCapturaHuellas',
  },
  pv332pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv332subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv332pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv332pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv332internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv332errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv332transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv332transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 20,
  pv333pageName: {
    path: 'page.name',
    value: 'ErrorHuellasInvalidas',
  },
  pv333pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv333subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv333pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv333pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv333internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv333errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv333transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv333transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 21,
  pv334pageName: {
    path: 'page.name',
    value: 'ErrorPermisosUsoCamara',
  },
  pv334pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv334subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv334pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv334pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv334internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv334errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv334transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv334transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 22,
  pv335pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosteriorInvalida',
  },
  pv335pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv335subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv335pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv335pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv335internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv335errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv335transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv335transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 23,
  pv336pageName: {
    path: 'page.name',
    value: 'ErrorDocumentoInvalido',
  },
  pv336pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv336subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv336pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv336pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv336internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv336errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv336transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv336transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 24,
  pv337pageName: {
    path: 'page.name',
    value: 'ErrorCedulaFrontalInvalida',
  },
  pv337pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv337subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv337pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv337pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv337internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv337errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv337transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv337transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 25,
  pv338pageName: {
    path: 'page.name',
    value: 'LinkVTUP',
  },
  pv338pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv338subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv338pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv338pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv338internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv338errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv338transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv338transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 26,
  pv339pageName: {
    path: 'page.name',
    value: 'MensajeClienteExistente',
  },
  pv339pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv339subFamily: {
    path: 'page.subfamily',
    value: 'Personales',
  },
  pv339pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv339pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv339internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv339errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv339transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv339transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Prestamo Credito Contratar - Prestamos,
  // Pantalla 1,
  pv340pageName: {
    path: 'page.name',
    value: 'Asegurabilidad',
  },
  pv340pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv340subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv340pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv340pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv340customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv340internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv340errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv340transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv340transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv340transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2,
  pv341pageName: {
    path: 'page.name',
    value: 'DeclaracionAsegurabilidad',
  },
  pv341pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv341subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv341pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv341pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv341internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv341errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv341transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv341transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3,
  pv342pageName: {
    path: 'page.name',
    value: 'ErrorNoAsegurable',
  },
  pv342pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv342subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv342pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv342pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv342internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv342errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv342transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv342transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4,
  pv343pageName: {
    path: 'page.name',
    value: 'VerificarDatoCedula',
  },
  pv343pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv343subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv343pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv343pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv343customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv343internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv343errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv343transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv343transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv343transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5,
  pv344pageName: {
    path: 'page.name',
    value: 'IngresarInformacionesContacto',
  },
  pv344pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv344subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv344pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv344pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv344customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv344internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv344errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv344transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv344transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv344transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6,
  pv345pageName: {
    path: 'page.name',
    value: 'ResidenciaExterior',
  },
  pv345pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv345subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv345pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv345pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv345customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv345internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv345errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv345transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv345transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv345transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7,
  pv346pageName: {
    path: 'page.name',
    value: 'ErrorResidenciaExterior',
  },
  pv346pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv346subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv346pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv346pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv346internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv346errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv346transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv346transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 8,
  pv347pageName: {
    path: 'page.name',
    value: 'DondeVives',
  },
  pv347pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv347subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv347pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv347pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv347customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv347internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv347errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv347transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv347transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv347transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 9,
  pv348pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv348pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv348subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv348pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv348pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv348customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv348internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv348errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv348transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv348transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv348transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 10,
  pv349pageName: {
    path: 'page.name',
    value: 'SeleccionEmpleado',
  },
  pv349pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv349subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv349pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv349pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv349internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv349errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv349transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv349transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 11,
  pv350pageName: {
    path: 'page.name',
    value: 'DondeTrabajasEmpleado',
  },
  pv350pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv350subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv350pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv350pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv350internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv350errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv350transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv350transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 12,
  pv351pageName: {
    path: 'page.name',
    value: 'IngresosMensuales',
  },
  pv351pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv351subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv351pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv351pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv351customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv351internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv351errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv351transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv351transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv351transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv351transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 13,
  pv352pageName: {
    path: 'page.name',
    value: 'OfertaAprobada',
  },
  pv352pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv352subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv352pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv352pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv352customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv352internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv352errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv352transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv352transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv352transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 14,
  pv353pageName: {
    path: 'page.name',
    value: 'ZonaGris',
  },
  pv353pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv353subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv353pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv353pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv353customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv353internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv353errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv353transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv353transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv353transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 15,
  pv354pageName: {
    path: 'page.name',
    value: 'ErrorRechazadoPco',
  },
  pv354pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv354subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv354pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv354pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv354internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv354errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv354transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv354transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 16,
  pv355pageName: {
    path: 'page.name',
    value: 'DocumentosEmpleado',
  },
  pv355pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv355subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv355pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv355pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv355internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv355errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv355transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv355transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 17,
  pv356pageName: {
    path: 'page.name',
    value: 'DocumentosPensionado',
  },
  pv356pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv356subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv356pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv356pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv356internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv356errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv356transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv356transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 18,
  pv357pageName: {
    path: 'page.name',
    value: 'DocumentosIndependiente',
  },
  pv357pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv357subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv357pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv357pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv357internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv357errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv357transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv357transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 19,
  pv358pageName: {
    path: 'page.name',
    value: 'DocumentosRentista',
  },
  pv358pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv358subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv358pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv358pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv358internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv358errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv358transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv358transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 20,
  pv359pageName: {
    path: 'page.name',
    value: 'InformacionEmpresaIndependente',
  },
  pv359pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv359subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv359pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv359pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv359internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv359errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv359transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv359transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 21,
  pv360pageName: {
    path: 'page.name',
    value: 'EstadoCivil',
  },
  pv360pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv360subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv360pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv360pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv360customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv360internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv360errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv360transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv360transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv360transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 22,
  pv361pageName: {
    path: 'page.name',
    value: 'ErrorQueremosConocerte',
  },
  pv361pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv361subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv361pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv361pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv361internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv361errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv361transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv361transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 23,
  pv362pageName: {
    path: 'page.name',
    value: 'DatosInformacionEmpresa',
  },
  pv362pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv362subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv362pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv362pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv362internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv362errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv362transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv362transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 24,
  pv363pageName: {
    path: 'page.name',
    value: 'OrigenIngresos',
  },
  pv363pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv363subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv363pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv363pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv363internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv363errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv363transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv363transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 25,
  pv364pageName: {
    path: 'page.name',
    value: 'ErrorRechazoContrato',
  },
  pv364pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv364subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv364pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv364pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv364internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv364errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv364transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv364transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Prestamo ConfiguracionVinculacion Abrir - Prestamos,
  // Pantalla 1,
  pv365pageName: {
    path: 'page.name',
    value: 'GastosMensuales',
  },
  pv365pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv365subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv365pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv365pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv365customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv365internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv365errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv365transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv365transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv365transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 2,
  pv366pageName: {
    path: 'page.name',
    value: 'ValorBienesYDeudas',
  },
  pv366pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv366subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv366pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv366pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv366customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv366internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv366errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv366transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv366transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv366transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 3,
  pv367pageName: {
    path: 'page.name',
    value: 'RealizaOpMonedaExtranjera',
  },
  pv367pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv367subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv367pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv367pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv367customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv367internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv367errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv367transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv367transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv367transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 4,
  pv368pageName: {
    path: 'page.name',
    value: 'TipoOperacionME',
  },
  pv368pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv368subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv368pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv368pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv368internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv368errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv368transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv368transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 5,
  pv369pageName: {
    path: 'page.name',
    value: 'TitularMonedaExtranjera',
  },
  pv369pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv369subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv369pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv369pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv369customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv369internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv369errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv369transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv369transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv369transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 6,
  pv370pageName: {
    path: 'page.name',
    value: 'TipoProductoME',
  },
  pv370pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv370subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv370pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv370pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv370internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv370errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv370transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv370transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 7,
  pv371pageName: {
    path: 'page.name',
    value: 'ErrorPais',
  },
  pv371pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv371subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv371pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv371pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv371internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv371errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv371transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv371transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 8,
  pv372pageName: {
    path: 'page.name',
    value: 'ExitoConfiguracion',
  },
  pv372pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv372subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv372pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv372pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv372customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv372internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv372errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv372transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv372transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv372transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 9,
  pv373pageName: {
    path: 'page.name',
    value: 'SeleccionaOficina',
  },
  pv373pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv373subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv373pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv373pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv373customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv373internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv373errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv373transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv373transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv373transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 10,
  pv374agencystoreid: {
    path: 'visitor.agencystoreid',
    value: null,
  },
  pv374pageName: {
    path: 'page.name',
    value: 'ConfirmaOficina',
  },
  pv374pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv374subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv374pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv374pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv374customTransactionStep: {
    path: 'custom.events.transactionstep07',
    value: '1',
  },
  pv374internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv374errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv374transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '7',
  },
  pv374transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv374transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv374transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 11,
  pv375pageName: {
    path: 'page.name',
    value: 'ConfirmarCuentaAhorros',
  },
  pv375pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv375subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv375pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv375pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv375customTransactionStep: {
    path: 'custom.events.transactionstep08',
    value: '1',
  },
  pv375internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv375errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv375transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '8',
  },
  pv375transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv375transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 12,
  pv376pageName: {
    path: 'page.name',
    value: 'RecibirTuTarjeta',
  },
  pv376pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv376subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv376pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv376pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv376customTransactionStep: {
    path: 'custom.events.transactionstep09',
    value: '1',
  },
  pv376internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv376errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv376transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '9',
  },
  pv376transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv376transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 13,
  pv377pageName: {
    path: 'page.name',
    value: 'SeleccionaUnaDireccion',
  },
  pv377pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv377subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv377pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv377pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv377internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv377errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv377transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv377transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 14,
  pv378pageName: {
    path: 'page.name',
    value: 'ConfirmaCelular',
  },
  pv378pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv378subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv378pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv378pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv378customTransactionStep: {
    path: 'custom.events.transactionstep10',
    value: '1',
  },
  pv378internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv378errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv378transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '10',
  },
  pv378transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv378transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 15,
  pv379pageName: {
    path: 'page.name',
    value: 'AsistidoOAutogestion',
  },
  pv379pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv379subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv379pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv379pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv379customTransactionStep: {
    path: 'custom.events.transactionstep11',
    value: '1',
  },
  pv379internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv379errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv379transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '11',
  },
  pv379transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv379transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 16,
  pv380pageName: {
    path: 'page.name',
    value: 'OffLineVinculacionSucursales',
  },
  pv380pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv380subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv380pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv380pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv380customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv380internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv380errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv380transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv380transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv380transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv380transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 17,
  pv381pageName: {
    path: 'page.name',
    value: 'OffLineVinculacionPersonal',
  },
  pv381pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv381subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv381pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv381pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv381customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv381internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv381errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv381transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv381transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv381transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv381transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 18,
  pv382pageName: {
    path: 'page.name',
    value: 'OnLineVinculacionSucursales',
  },
  pv382pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv382subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv382pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv382pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv382customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv382internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv382errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv382transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv382transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv382transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv382transactionOriginAccountType: {
    path: 'transaction.details.originaccounttype',
    value: null,
  },
  pv382transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 19,
  pv383pageName: {
    path: 'page.name',
    value: 'ExitoCuentaCreada',
  },
  pv383pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv383subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv383pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv383pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv383customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv383internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv383errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv383transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv383transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv383transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv383transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 20,
  pv384pageName: {
    path: 'page.name',
    value: 'ExitoRotativoCreado',
  },
  pv384pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv384subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv384pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv384pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv384customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv384internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv384errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv384transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv384transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv384transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv384transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 21,
  pv385pageName: {
    path: 'page.name',
    value: 'RotativoEnProceso',
  },
  pv385pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv385subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv385pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv385pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv385internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv385errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv385transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv385transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: 'Asistido | ',
  },
  pv385transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 22,
  pv386pageName: {
    path: 'page.name',
    value: 'TerminosYCondiciones',
  },
  pv386pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv386subFamily: {
    path: 'page.subfamily',
    value: 'ConfiguracionVinculacion',
  },
  pv386pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv386pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv386internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv386errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv386transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'PersonalCN',
  },
  pv386transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantallas de Onboarding - vivienda,
  // Pantalla 1,
  pv391pageName: {
    path: 'page.name',
    value: 'InicioSimulacion',
  },
  pv391pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv391subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv391pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv391pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv391internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv391errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv391customTransactionStep: {
    path: 'custom.events.transactionstep01',
    value: '1',
  },
  pv391transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '1',
  },
  pv391transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv391transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 2,
  pv392pageName: {
    path: 'page.name',
    value: 'AutorizacionTratamientoDeDatos',
  },
  pv392pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv392subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv392pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv392pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv392internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv392errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv392transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv392transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 3,
  pv393pageName: {
    path: 'page.name',
    value: 'IngresoDatosBasicos',
  },
  pv393pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv393subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv393pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv393pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv393internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv393errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv393customTransactionStep: {
    path: 'custom.events.transactionstep02',
    value: '1',
  },
  pv393transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '2',
  },
  pv393transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv393transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 4,
  pv394pageName: {
    path: 'page.name',
    value: 'IngresarInformacionDeContacto',
  },
  pv394pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv394subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv394pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv394pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv394internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv394errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv394customTransactionStep: {
    path: 'custom.events.transactionstep03',
    value: '1',
  },
  pv394transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '3',
  },
  pv394transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv394transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 5,
  pv395pageName: {
    path: 'page.name',
    value: 'QueTipoDeCreditoQuieres',
  },
  pv395pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv395subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv395pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv395pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv395internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv395errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv395customTransactionStep: {
    path: 'custom.events.transactionstep04',
    value: '1',
  },
  pv395transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '4',
  },
  pv395transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv395transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 6,
  pv396pageName: {
    path: 'page.name',
    value: 'TiposDeCreditoDeVivienda',
  },
  pv396pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv396subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv396pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv396pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv396internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv396errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv396transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv396transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 7,
  pv397pageName: {
    path: 'page.name',
    value: 'YaElegisteLaVivienda',
  },
  pv397pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv397subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv397pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv397pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv397internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv397errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv397transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv397transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 8,
  pv398pageName: {
    path: 'page.name',
    value: 'CuentanosMasSobreLaVivienda',
  },
  pv398pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv398subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv398pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv398pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv398internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv398errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv398transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv398transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 9,
  pv399pageName: {
    path: 'page.name',
    value: 'SeleccionModificacion',
  },
  pv399pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv399subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv399pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv399pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv399internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv399errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv399transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv399transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 10,
  pv400pageName: {
    path: 'page.name',
    value: 'CuentanosMasCompraVivienda',
  },
  pv400pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv400subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv400pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv400pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv400internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv400errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv400transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv400transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 11,
  pv401pageName: {
    path: 'page.name',
    value: 'CuentanosMasSobreElCreditoAPedir',
  },
  pv401pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv401subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv401pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv401pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv401internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv401errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv401transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv401transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 12,
  pv402pageName: {
    path: 'page.name',
    value: 'CuentanosMasCompraCartera',
  },
  pv402pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv402subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv402pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv402pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv402internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv402errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv402transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv402transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 13,
  pv403pageName: {
    path: 'page.name',
    value: 'ValorSolicitado',
  },
  pv403pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv403subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv403pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv403pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv403internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv403errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv403transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv403transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 14,
  pv404pageName: {
    path: 'page.name',
    value: 'PlazoSolicitado',
  },
  pv404pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv404subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv404pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv404pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv404internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv404errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv404customTransactionStep: {
    path: 'custom.events.transactionstep05',
    value: '1',
  },
  pv404transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '5',
  },
  pv404transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv404transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 15,
  pv405pageName: {
    path: 'page.name',
    value: 'ResultadoDeSimulacion',
  },
  pv405pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv405subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv405pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv405pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv405internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv405errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv405customTransactionSimulationValue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv405transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv405transactionInstallmentsterm: {
    path: 'transaction.details.installmentsterm',
    value: null,
  },
  pv405transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 16,
  pv406pageName: {
    path: 'page.name',
    value: 'SolicitudLeasing',
  },
  pv406pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv406subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv406pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv406pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv406internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv406errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv406customTransactionStep: {
    path: 'custom.events.transactionstep06',
    value: '1',
  },
  pv406transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: '6',
  },
  pv406transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv406transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 17,
  pv407pageName: {
    path: 'page.name',
    value: 'AplicaSubsidio',
  },
  pv407pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv407subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv407pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv407pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv407internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv407errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv407customTransactionCheckout: {
    path: 'custom.events.transactioncheckout',
    value: '1',
  },
  pv407transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Checkout',
  },
  pv407transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv407transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 18,
  pv408pageName: {
    path: 'page.name',
    value: 'OfertaAprobada',
  },
  pv408pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv408subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv408pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv408pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv408internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv408errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv408customTransactionComplete: {
    path: 'custom.events.transactioncomplete',
    value: '1',
  },
  pv408transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Complete',
  },
  pv408customTransactionSimulationValue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },
  pv408customTransactionvalue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },
  pv408transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv408transactionInstallmentsterm: {
    path: 'transaction.details.installmentsterm',
    value: null,
  },
  pv408transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv408transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 19,
  pv409pageName: {
    path: 'page.name',
    value: 'EditarSolicitudLeasing',
  },
  pv409pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv409subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv409pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv409pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv409internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv409errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv409transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv409transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 20,
  pv410pageName: {
    path: 'page.name',
    value: 'EditarPlazoSolicitado',
  },
  pv410pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv410subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv410pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv410pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv410internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv410errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv410transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv410transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 21,
  pv411pageName: {
    path: 'page.name',
    value: 'EditarValorSolicitado',
  },
  pv411pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv411subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv411pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv411pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv411internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv411errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv411transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv411transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 22,
  pv412pageName: {
    path: 'page.name',
    value: 'EditarCuentanosMasVivienda',
  },
  pv412pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv412subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv412pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv412pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv412internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv412errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv412transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv412transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantalla 23,
  pv413pageName: {
    path: 'page.name',
    value: 'ErrorGeneral',
  },
  pv413pageFamily: {
    path: 'page.family',
    value: 'Prestamo',
  },
  pv413subFamily: {
    path: 'page.subfamily',
    value: 'Hipotecarios',
  },
  pv413pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv413pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv413internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv413errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv413transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'HipotecarioCN',
  },
  pv413transactionName: {
    path: 'transaction.name',
    value: 'Simulacion',
  },

  // Pantallas Cliente existente
  // Pantallas de Captura Documento - Trajeta de credito,
  // Pantalla 1
  pv422pageName: {
    path: 'page.name',
    value: 'PasoaPaso',
  },
  pv422pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv422subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv422pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv422pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv422internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv422errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv422transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv422transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 2
  pv423pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv423pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv423subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv423pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv423pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv423internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv423errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv423transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv423transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 3
  pv424pageName: {
    path: 'page.name',
    value: 'IngresarCodigoDeConfirmacion',
  },
  pv424pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv424subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv424pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv424pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv424internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv424errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv424transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv424transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 4
  pv425pageName: {
    path: 'page.name',
    value: 'ErrorNoEsPosibleContinuar',
  },
  pv425pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv425subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv425pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv425pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv425internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv425errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv425transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv425transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 5
  pv426pageName: {
    path: 'page.name',
    value: 'ErrorProcesoEnTramite',
  },
  pv426pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv426subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv426pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv426pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv426internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv426errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv426transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv426transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 6
  pv427pageName: {
    path: 'page.name',
    value: 'ProblemasConElCodigo',
  },
  pv427pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv427subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv427pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv427pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv427internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv427errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv427transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv427transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 7
  pv428pageName: {
    path: 'page.name',
    value: 'ErrorIdentidadNoValidada',
  },
  pv428pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv428subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv428pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv428pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv428internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv428errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv428transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv428transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantallas tarjeta de credito - ingreso datos - cliente existente
  // Pantalla 1
  pv429pageName: {
    path: 'page.name',
    value: 'ConfirmacionOcupacionActual',
  },
  pv429pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv429subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv429pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv429pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv429internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv429errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv429transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv429transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2
  pv430pageName: {
    path: 'page.name',
    value: 'ErrorCambioOcupacion',
  },
  pv430pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv430subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv430pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv430pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv430internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv430errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv430transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv430transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3
  pv431pageName: {
    path: 'page.name',
    value: 'ActualizacionVoluntaria',
  },
  pv431pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv431subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv431pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv431pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv431internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv431errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv431transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv431transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4
  pv432pageName: {
    path: 'page.name',
    value: 'ActualizacionObligatoria',
  },
  pv432pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv432subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv432pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv432pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv432internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv432errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv432transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv432transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5
  pv433pageName: {
    path: 'page.name',
    value: 'ErrorDatosDesactualizados',
  },
  pv433pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv433subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv433pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv433pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv433internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv433errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv433transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv433transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6
  pv434pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatos',
  },
  pv434pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv434subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv434pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv434pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv434internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv434errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv434transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv434transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7
  pv435pageName: {
    path: 'page.name',
    value: 'OfertaAprobada',
  },
  pv435pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv435subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv435pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv435pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv435internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv435errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv435transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv435transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 8
  pv436pageName: {
    path: 'page.name',
    value: 'CambioValorOferta',
  },
  pv436pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv436subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv436pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv436pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv436internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv436errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv436transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv436transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 9
  pv437pageName: {
    path: 'page.name',
    value: 'ZonaGrisOfertaAprobada',
  },
  pv437pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv437subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv437pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv437pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv437internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv437errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv437transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv437transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 10
  pv438pageName: {
    path: 'page.name',
    value: 'ErrorSolicitudNoAprobada',
  },
  pv438pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv438subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv438pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv438pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv438internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv438errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv438transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv438transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 11
  pv439pageName: {
    path: 'page.name',
    value: 'ExitoIngresoDatos',
  },
  pv439pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv439subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv439pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv439pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv439internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv439errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv439transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv439transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 12
  pv440pageName: {
    path: 'page.name',
    value: 'ErrorQueremosConocerte',
  },
  pv440pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv440subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv440pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv440pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv440internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv440errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv440transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv440transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 13
  pv441pageName: {
    path: 'page.name',
    value: 'DocumentosIndependiente',
  },
  pv441pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv441subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv441pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv441pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv441internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv441errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv441transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv441transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 14
  pv442pageName: {
    path: 'page.name',
    value: 'DocumentosPensionado',
  },
  pv442pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv442subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv442pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv442pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv442internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv442errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv442transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv442transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 15
  pv443pageName: {
    path: 'page.name',
    value: 'DocumentosEmpleado',
  },
  pv443pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv443subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv443pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv443pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv443internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv443errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv443transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv443transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 16
  pv444pageName: {
    path: 'page.name',
    value: 'DocumentosRentistaDeCapital',
  },
  pv444pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv444subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv444pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv444pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv444internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv444errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv444transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv444transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantallas tarjeta de credito - configurar vinculacion - cliente existente
  // Pantalla 1
  pv445pageName: {
    path: 'page.name',
    value: 'FechaPagoFranquicia',
  },
  pv445pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv445subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv445pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv445pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv445internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv445errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv445transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv445transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 2
  pv446pageName: {
    path: 'page.name',
    value: 'IngresoCupoPorTarjeta',
  },
  pv446pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv446subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv446pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv446pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv446internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv446errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv446transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv446cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv446transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 3
  pv447pageName: {
    path: 'page.name',
    value: 'FranquiciaTarjetaVirtual',
  },
  pv447pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv447subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv447pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv447pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv447internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv447errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv447transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv447transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 4
  pv448pageName: {
    path: 'page.name',
    value: 'DireccionEntrega',
  },
  pv448pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv448subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv448pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv448pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv448internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv448errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv448transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv448transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 5
  pv449pageName: {
    path: 'page.name',
    value: 'Error',
  },
  pv449pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv449subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv449pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv449pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv449internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv449errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv449transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv449transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 6
  pv450pageName: {
    path: 'page.name',
    value: 'ConfirmarCelular',
  },
  pv450pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv450subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv450pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv450pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv450internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv450errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv450transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv450transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 7
  pv451pageName: {
    path: 'page.name',
    value: 'UnAsesorOAliadoTeAcompaña',
  },
  pv451pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv451subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv451pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv451pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv451internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv451errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv451transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv451transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 8
  pv452pageName: {
    path: 'page.name',
    value: 'CaracteristicasProducto',
  },
  pv452pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv452subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv452pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv452pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv452internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv452errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv452transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv452cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv452transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv452customTransactionSimulationValue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },

  // Pantalla 9
  pv453pageName: {
    path: 'page.name',
    value: 'ZonaGrisCaracteristicasProducto',
  },
  pv453pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv453subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv453pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv453pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv453internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv453errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv453transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv453cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv453transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 10
  pv454pageName: {
    path: 'page.name',
    value: 'ZonaGrisResumenSolicitud',
  },
  pv454pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv454subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv454pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv454pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv454internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv454errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv454transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv454cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv454transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 11
  pv455pageName: {
    path: 'page.name',
    value: 'ExitoTarjetaCreada',
  },
  pv455pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv455subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv455pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv455pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv455internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv455errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv455transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv455cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv455transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv455customTransactionCompletedValue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },

  // Pantalla 12
  pv456pageName: {
    path: 'page.name',
    value: 'SolicitudEnProcesoTimeOut',
  },
  pv456pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv456subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv456pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv456pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv456internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv456errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv456transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv456transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 13
  pv457pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv457pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv457subFamily: {
    path: 'page.subfamily',
    value: 'TarjetaCredito',
  },
  pv457pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv457pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv457internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv457errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv457transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTCCE',
  },
  pv457transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantallas consulta solicitudes - Cliente nuevo
  // Pantalla 1
  pv458pageName: {
    path: 'page.name',
    value: 'ConoceMasSolicitud',
  },
  pv458pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv458subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv458pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv458pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv458internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv458errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv458transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCN',
  },
  pv458transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 2
  pv459pageName: {
    path: 'page.name',
    value: 'BusquedaDeSolicitud',
  },
  pv459pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv459subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv459pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv459pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv459internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv459errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv459transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCN',
  },
  pv459transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 3
  pv460pageName: {
    path: 'page.name',
    value: 'ResultadoConsultaSolicitud',
  },
  pv460pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv460subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv460pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv460pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv460internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv460errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv460transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCN',
  },
  pv460status: {
    path: 'transaction.details.transactionstatus',
    value: null,
  },
  pv460transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 4
  pv461pageName: {
    path: 'page.name',
    value: 'SolicitudCaduco',
  },
  pv461pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv461subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv461pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv461pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv461internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv461errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv461transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCN',
  },
  pv461transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 5
  pv462pageName: {
    path: 'page.name',
    value: 'ErrorTecnico',
  },
  pv462pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv462subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv462pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv462pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv462internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv462errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv462transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCN',
  },
  pv462transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 6
  pv463pageName: {
    path: 'page.name',
    value: 'EnvioDocumentos',
  },
  pv463pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv463subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv463pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv463pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv463internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv463errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv463transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCN',
  },
  pv463transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantallas consulta solicitudes - Cliente existente
  // Pantalla 1
  pv464pageName: {
    path: 'page.name',
    value: 'ConoceMasSolicitud',
  },
  pv464pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv464subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv464pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv464pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv464internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv464errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv464transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv464transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 2
  pv465pageName: {
    path: 'page.name',
    value: 'BusquedaDeSolicitud',
  },
  pv465pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv465subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv465pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv465pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv465internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv465errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv465transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv465transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 3
  pv466pageName: {
    path: 'page.name',
    value: 'SinSolicitudes',
  },
  pv466pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv466subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv466pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv466pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv466internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv466errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv466transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv466transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 4
  pv467pageName: {
    path: 'page.name',
    value: 'ResultadoConsultaSolicitud',
  },
  pv467pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv467subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv467pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv467pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv467internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv467errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv467transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv467status: {
    path: 'transaction.details.transactionstatus',
    value: null,
  },
  pv467transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 5
  pv468pageName: {
    path: 'page.name',
    value: 'SolicitudCaduco',
  },
  pv468pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv468subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv468pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv468pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv468internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv468errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv468transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv468transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 6
  pv469pageName: {
    path: 'page.name',
    value: 'ErrorTecnico',
  },
  pv469pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv469subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv469pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv469pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv469internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv469errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv469transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv469transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantalla 7
  pv470pageName: {
    path: 'page.name',
    value: 'EnvioDocumentos',
  },
  pv470pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv470subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv470pageAction: {
    path: 'page.action',
    value: 'Consultar',
  },
  pv470pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv470internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv470errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv470transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'ConsultaDeSolicitudesCE',
  },
  pv470transactionName: {
    path: 'transaction.name',
    value: 'Consulta',
  },

  // Pantallas Onboarding Multiproducto - CN - CE - Solicitud
  // Pantalla 1
  pv471pageName: {
    path: 'page.name',
    value: 'SeleccionProductosDisponibles',
  },
  pv471pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv471subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv471pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv471pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv471internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv471errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv471transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv471transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantalla 2
  pv472pageName: {
    path: 'page.name',
    value: 'IngresoMontoYPlazo',
  },
  pv472pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv472subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv472pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv472pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv472internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv472errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv472transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv472transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantalla 3
  pv473pageName: {
    path: 'page.name',
    value: 'SeleccionOrdenProductos',
  },
  pv473pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv473subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv473pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv473pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv473internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv473errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv473transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv473transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantalla 4
  pv474pageName: {
    path: 'page.name',
    value: 'ErrorBiocatchYGeolocalizacion',
  },
  pv474pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv474subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv474pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv474pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv474internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv474errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv474transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv474transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantalla 5
  pv475pageName: {
    path: 'page.name',
    value: 'ErrorElServicioNoResponde',
  },
  pv475pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv475subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv475pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv475pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv475internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv475errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv475transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv475transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantalla 6
  pv476pageName: {
    path: 'page.name',
    value: 'ErrorProductosSolicitud',
  },
  pv476pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv476subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv476pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv476pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv476internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv476errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv476transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv476transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },
  pv476clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 7
  pv477pageName: {
    path: 'page.name',
    value: 'ErrorSolicitud',
  },
  pv477pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv477subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv477pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv477pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv477internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv477errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv477transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv477transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },
  pv477clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 8
  pv478pageName: {
    path: 'page.name',
    value: 'CompraDeCartera',
  },
  pv478pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv478subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv478pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv478pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv478internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv478errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv478transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv478transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantallas Onboarding Multiproducto - CN - Identificacion
  // Pantalla 1
  pv479pageName: {
    path: 'page.name',
    value: 'ErrorPermisosUsoCamara',
  },
  pv479pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv479subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv479pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv479pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv479internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv479errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv479transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv479transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 2
  pv480pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosteriorInvalida',
  },
  pv480pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv480subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv480pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv480pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv480internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv480errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv480transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv480transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 3
  pv481pageName: {
    path: 'page.name',
    value: 'PrepararCapturaCedula',
  },
  pv481pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv481subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv481pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv481pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv481internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv481errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv481transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv481transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv481clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 4
  pv482pageName: {
    path: 'page.name',
    value: 'InicioCapturaCedula',
  },
  pv482pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv482subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv482pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv482pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv482internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv482errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv482transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv482transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 5
  pv483pageName: {
    path: 'page.name',
    value: 'ErrorCapturaPosterior',
  },
  pv483pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv483subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv483pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv483pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv483internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv483errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv483transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv483transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 6
  pv484pageName: {
    path: 'page.name',
    value: 'InicioCedulaFrontal',
  },
  pv484pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv484subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv484pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv484pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv484internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv484errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv484transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv484transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv484clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 7
  pv485pageName: {
    path: 'page.name',
    value: 'ErrorCapturaFrontal',
  },
  pv485pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv485subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv485pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv485pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv485internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv485errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv485transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv485transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8
  pv486pageName: {
    path: 'page.name',
    value: 'ExitoCapturaCedula',
  },
  pv486pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv486subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv486pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv486pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv486internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv486errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv486transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv486transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv486clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 9
  pv487pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv487pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv487subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv487pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv487pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv487internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv487errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv487transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv487transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 10
  pv488pageName: {
    path: 'page.name',
    value: 'InicioCapturaHuellas',
  },
  pv488pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv488subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv488pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv488pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv488internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv488errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv488transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv488transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv488clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 11
  pv489pageName: {
    path: 'page.name',
    value: 'ErrorCapturaHuellas',
  },
  pv489pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv489subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv489pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv489pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv489internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv489errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv489transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv489transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 12
  pv490pageName: {
    path: 'page.name',
    value: 'ErrorListasRestrictivas',
  },
  pv490pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv490subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv490pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv490pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv490internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv490errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv490transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv490transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 13
  pv491pageName: {
    path: 'page.name',
    value: 'ErrorHuellasInvalidas',
  },
  pv491pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv491subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv491pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv491pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv491internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv491errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv491transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv491transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 14
  pv492pageName: {
    path: 'page.name',
    value: 'ErrorPersonaPEP',
  },
  pv492pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv492subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv492pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv492pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv492internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv492errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv492transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv492transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantallas Onboarding Multiproducto - CN - Oferta
  // Pantalla 1
  pv494pageName: {
    path: 'page.name',
    value: 'OfertaAprobada',
  },
  pv494pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv494subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv494pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv494pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv494internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv494errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv494transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv494transactionName: {
    path: 'transaction.name',
    value: 'Oferta',
  },
  pv494status: {
    path: 'transaction.details.transactionstatus',
    value: null,
  },
  pv494clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 2
  pv495pageName: {
    path: 'page.name',
    value: 'OfertaZonaGris',
  },
  pv495pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv495subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv495pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv495pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv495internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv495errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv495transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv495transactionName: {
    path: 'transaction.name',
    value: 'Oferta',
  },
  pv495status: {
    path: 'transaction.details.transactionstatus',
    value: null,
  },
  pv495clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 3
  pv496pageName: {
    path: 'page.name',
    value: 'ModificarValor',
  },
  pv496pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv496subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv496pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv496pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv496internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv496errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv496transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv496transactionName: {
    path: 'transaction.name',
    value: 'Oferta',
  },
  pv496clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 4
  pv497pageName: {
    path: 'page.name',
    value: 'ErrorNoAprobado',
  },
  pv497pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv497subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv497pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv497pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv497internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv497errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv497transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv497transactionName: {
    path: 'transaction.name',
    value: 'Oferta',
  },
  pv497clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantallas Onboarding Multiproducto - CN - Configuracion
  // Pantalla 1
  pv498pageName: {
    path: 'page.name',
    value: 'InicioEtapaConfiguracion',
  },
  pv498pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv498subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv498pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv498pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv498internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv498errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv498transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv498transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },
  pv498clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 2
  pv499pageName: {
    path: 'page.name',
    value: 'SeleccionaCiudadOficina',
  },
  pv499pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv499subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv499pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv499pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv499internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv499errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv499transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv499transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 3
  pv500pageName: {
    path: 'page.name',
    value: 'ErrorElServicioNoResponde',
  },
  pv500pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv500subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv500pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv500pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv500internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv500errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv500transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv500transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 4
  pv501pageName: {
    path: 'page.name',
    value: 'ConfigurarDesembolso',
  },
  pv501pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv501subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv501pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv501pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv501internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv501errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv501transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv501transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },
  pv501clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 5
  pv502pageName: {
    path: 'page.name',
    value: 'ConfigurarCuentaAhorros',
  },
  pv502pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv502subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv502pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv502pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv502internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv502errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv502transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv502transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },
  pv502clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 6
  pv503pageName: {
    path: 'page.name',
    value: 'FechaPagoFranquicia',
  },
  pv503pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv503subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv503pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv503pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv503internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv503errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv503transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv503transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },
  pv503clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 7
  pv504pageName: {
    path: 'page.name',
    value: 'FranquiciaTarjetaVirtual',
  },
  pv504pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv504subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv504pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv504pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv504internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv504errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv504transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv504transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 8
  pv505pageName: {
    path: 'page.name',
    value: 'SeleccionarEntregaProducto',
  },
  pv505pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv505subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv505pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv505pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv505internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv505errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv505transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv505transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 9
  pv506pageName: {
    path: 'page.name',
    value: 'ConfirmarCelular',
  },
  pv506pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv506subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv506pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv506pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv506internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv506errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv506transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv506transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 10
  pv507pageName: {
    path: 'page.name',
    value: 'UnAsesorOAliadoTeAcompaña',
  },
  pv507pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv507subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv507pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv507pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv507internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv507errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv507transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv507transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantallas Onboarding Multiproducto - CN - Vinculacion
  // Pantalla 1
  pv508pageName: {
    path: 'page.name',
    value: 'CaracteristicasProducto',
  },
  pv508pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv508subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv508pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv508pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv508internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv508errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv508transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv508transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv508transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv508cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv508status: {
    path: 'transaction.details.transactionstatus',
    value: 'Asistido | ',
  },
  pv508clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 2
  pv509pageName: {
    path: 'page.name',
    value: 'DocumentosZonaGris',
  },
  pv509pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv509subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv509pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv509pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv509internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv509errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv509transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv509transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv509clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 3
  pv510pageName: {
    path: 'page.name',
    value: 'ZonaGrisCaracteristicasProducto',
  },
  pv510pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv510subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv510pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv510pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv510internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv510errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv510transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv510transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv510transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv510cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv510status: {
    path: 'transaction.details.transactionstatus',
    value: 'Asistido | ',
  },
  pv510clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 4
  pv511pageName: {
    path: 'page.name',
    value: 'ErrorServicioNoResponde',
  },
  pv511pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv511subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv511pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv511pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv511internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv511errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv511transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv511transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 5
  pv512pageName: {
    path: 'page.name',
    value: 'ErrorRechazo',
  },
  pv512pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv512subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv512pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv512pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv512internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv512errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv512transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv512transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 6
  pv513pageName: {
    path: 'page.name',
    value: 'ExitoProductoCreado',
  },
  pv513pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv513subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv513pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv513pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv513internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv513errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv513transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv513transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv513transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv513cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv513status: {
    path: 'transaction.details.transactionstatus',
    value: 'Asistido | ',
  },
  pv513clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 7
  pv514pageName: {
    path: 'page.name',
    value: 'ZonaGrisSolicitudRecibida',
  },
  pv514pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv514subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv514pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv514pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv514internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv514errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv514transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv514transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv514transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv514cardnetwork: {
    path: 'transaction.details.cardnetwork',
    value: null,
  },
  pv514status: {
    path: 'transaction.details.transactionstatus',
    value: 'Asistido | ',
  },
  pv514clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 8
  pv515pageName: {
    path: 'page.name',
    value: 'ErrorCreacionProducto',
  },
  pv515pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv515subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv515pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv515pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv515internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv515errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv515transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv515transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 9
  pv516pageName: {
    path: 'page.name',
    value: 'SolicitudEnProcesoTimeOut',
  },
  pv516pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv516subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv516pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv516pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv516internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv516errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv516transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv516transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv516clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 10
  pv517pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv517pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv517subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv517pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv517pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv517internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv517errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv517transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv517transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv517clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 11
  pv518pageName: {
    path: 'page.name',
    value: 'ZonaGrisSolicitudRecibida',
  },
  pv518pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv518subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv518pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv518pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv518internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv518errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv518transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv518transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },
  pv518clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantallas Onboarding Multiproducto - CE - Solicitud
  // Pantalla 9
  pv519pageName: {
    path: 'page.name',
    value: 'SeleccionCreditosARetanquear',
  },
  pv519pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv519subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv519pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv519pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv519internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv519errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv519transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv519transactionName: {
    path: 'transaction.name',
    value: 'Solicitud',
  },

  // Pantallas Onboarding Multiproducto - CE - Identificacion
  // Pantalla 2
  pv520pageName: {
    path: 'page.name',
    value: 'IngresoCodigoDeConfirmacion',
  },
  pv520pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv520subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv520pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv520pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv520internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv520errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv520transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv520transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 3
  pv521pageName: {
    path: 'page.name',
    value: 'ProblemasConElCodigo',
  },
  pv521pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv521subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv521pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv521pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv521internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv521errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv521transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv521transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 4
  pv522pageName: {
    path: 'page.name',
    value: 'ErrorCodigoNoValidado',
  },
  pv522pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv522subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv522pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv522pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv522internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv522errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv522transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv522transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 5
  pv523pageName: {
    path: 'page.name',
    value: 'InicioEtapaIdentificacion',
  },
  pv523pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv523subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv523pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv523pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv523internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv523errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv523transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv523transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv523clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 6
  pv524pageName: {
    path: 'page.name',
    value: 'ErrorElServicioNoResponde',
  },
  pv524pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv524subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv524pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv524pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv524internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv524errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv524transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv524transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 7
  pv525pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatosObligatoria',
  },
  pv525pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv525subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv525pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv525pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv525internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv525errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv525transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv525transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 8
  pv526pageName: {
    path: 'page.name',
    value: 'ErrorCondicionesDeAsegurabilidad',
  },
  pv526pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv526subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv526pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv526pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv526internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv526errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv526transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv526transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 9
  pv527pageName: {
    path: 'page.name',
    value: 'ErrorBoqueoSARLAFT',
  },
  pv527pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv527subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv527pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv527pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv527internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv527errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv527transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv527transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 10
  pv528pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatosOpcional',
  },
  pv528pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv528subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv528pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv528pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv528internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv528errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv528transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv528transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 11
  pv529pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatos',
  },
  pv529pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv529subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv529pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv529pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv529internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv529errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv529transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv529transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },
  pv529clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantallas Onboarding Multiproducto - CN Web - Identificacion
  // Pantalla 1
  pv530pageName: {
    path: 'page.name',
    value: 'ComenzarIdentificacionAutorizacionDeDatos',
  },
  pv530pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv530subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv530pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv530pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv530internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv530errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv530transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv530transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv530clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 2
  pv531pageName: {
    path: 'page.name',
    value: 'IngresoDatosPersonales',
  },
  pv531pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv531subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv531pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv531pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv531internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv531errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv531transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv531transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 3
  pv532pageName: {
    path: 'page.name',
    value: 'VerificaDatosDocumento',
  },
  pv532pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv532subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv532pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv532pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv532internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv532errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv532transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv532transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv532clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 5
  pv533pageName: {
    path: 'page.name',
    value: 'ErrorYaEresClienteItau',
  },
  pv533pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv533subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv533pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv533pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv533internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv533errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv533transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv533transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 6
  pv534pageName: {
    path: 'page.name',
    value: 'ErrorInconvenientesTecnicos',
  },
  pv534pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv534subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv534pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv534pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv534internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv534errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv534transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv534transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 7
  pv535pageName: {
    path: 'page.name',
    value: 'ErrorContinuidadEnLaSolicitud',
  },
  pv535pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv535subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv535pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv535pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv535internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv535errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv535transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv535transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8
  pv536pageName: {
    path: 'page.name',
    value: 'InformacionDeContacto',
  },
  pv536pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv536subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv536pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv536pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv536internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv536errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv536transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv536transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 9
  pv537pageName: {
    path: 'page.name',
    value: 'EnvioCodigoOTP',
  },
  pv537pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv537subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv537pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv537pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv537internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv537errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv537transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv537transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },
  pv537clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 10
  pv538pageName: {
    path: 'page.name',
    value: 'ErrorValidacionDeIdentidad',
  },
  pv538pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv538subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv538pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv538pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv538internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv538errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv538transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv538transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 11
  pv539pageName: {
    path: 'page.name',
    value: 'ErrorInconvenientesTecnicosIdentificacion',
  },
  pv539pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv539subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv539pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv539pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv539internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv539errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv539transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv539transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 12
  pv540pageName: {
    path: 'page.name',
    value: 'ProblemasConElCodigo',
  },
  pv540pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv540subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv540pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv540pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv540internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv540errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv540transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv540transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 16
  pv541pageName: {
    path: 'page.name',
    value: 'ErrorNoHaySuficientesPreguntas',
  },
  pv541pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv541subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv541pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv541pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv541internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv541errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv541transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv541transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 17
  pv542pageName: {
    path: 'page.name',
    value: 'InicioPreguntasDeValidacionDeIdentidad',
  },
  pv542pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv542subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv542pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv542pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv542internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv542errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv542transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv542transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 18
  pv543pageName: {
    path: 'page.name',
    value: 'ErrorRespuestasIncorrectas',
  },
  pv543pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv543subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv543pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv543pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv543internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv543errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv543transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv543transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 19
  pv544pageName: {
    path: 'page.name',
    value: 'ErrorTecnicoPreguntasDeIdentificacion',
  },
  pv544pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv544subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv544pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv544pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv544internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv544errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv544transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv544transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 20
  pv545pageName: {
    path: 'page.name',
    value: 'PrimeraPreguntaDeSeguridad',
  },
  pv545pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv545subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv545pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv545pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv545internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv545errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv545transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv545transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 21
  pv546pageName: {
    path: 'page.name',
    value: 'SegundaPreguntaDeSeguridad',
  },
  pv546pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv546subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv546pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv546pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv546internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv546errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv546transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv546transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 22
  pv547pageName: {
    path: 'page.name',
    value: 'TerceraPreguntaDeSeguridad',
  },
  pv547pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv547subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv547pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv547pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv547internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv547errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv547transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv547transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 23
  pv548pageName: {
    path: 'page.name',
    value: 'CuartaPreguntaDeSeguridad',
  },
  pv548pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv548subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv548pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv548pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv548internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv548errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv548transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv548transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 24
  pv549pageName: {
    path: 'page.name',
    value: 'RegistroCompleto',
  },
  pv549pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv549subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv549pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv549pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv549internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv549errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv549transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv549transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 25
  pv550pageName: {
    path: 'page.name',
    value: 'ErrorUsuarioSuperoIntentosPermitidos',
  },
  pv550pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv550subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv550pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv550pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv550internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv550errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv550transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv550transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantallas Onboarding Multiproducto - CN - Captura
  // Pantalla 1
  pv551pageName: {
    path: 'page.name',
    value: 'InicioEtapaCaptura',
  },
  pv551pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv551subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv551pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv551pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv551internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv551errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv551transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv551transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },
  pv551clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 2
  pv552pageName: {
    path: 'page.name',
    value: 'VerificarDatoCedula',
  },
  pv552pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv552subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv552pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv552pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv552internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv552errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv552transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv552transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 3
  pv553pageName: {
    path: 'page.name',
    value: 'OtraNacionalidad',
  },
  pv553pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv553subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv553pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv553pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv553internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv553errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv553transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv553transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 4
  pv554pageName: {
    path: 'page.name',
    value: 'DondeVives',
  },
  pv554pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv554subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv554pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv554pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv554internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv554errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv554transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv554transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 5
  pv555pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv555pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv555subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv555pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv555pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv555internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv555errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv555transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv555transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 6
  pv556pageName: {
    path: 'page.name',
    value: 'DondeTrabajasEmpleado',
  },
  pv556pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv556subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv556pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv556pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv556internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv556errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv556transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv556transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 7
  pv557pageName: {
    path: 'page.name',
    value: 'InformacionEmpresaIndependente',
  },
  pv557pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv557subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv557pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv557pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv557internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv557errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv557transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv557transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 8
  pv558pageName: {
    path: 'page.name',
    value: 'DatosEmpresaIndependente',
  },
  pv558pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv558subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv558pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv558pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv558internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv558errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv558transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv558transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 9
  pv559pageName: {
    path: 'page.name',
    value: 'ErrorRechazoContrato',
  },
  pv559pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv559subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv559pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv559pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv559internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv559errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv559transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv559transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 10
  pv560pageName: {
    path: 'page.name',
    value: 'PreguntasFinancieras',
  },
  pv560pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv560subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv560pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv560pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv560internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv560errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv560transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv560transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 11
  pv561pageName: {
    path: 'page.name',
    value: 'BienesDeudas',
  },
  pv561pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv561subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv561pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv561pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv561internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv561errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv561transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv561transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 12
  pv562pageName: {
    path: 'page.name',
    value: 'GastosMensuales',
  },
  pv562pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv562subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv562pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv562pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv562internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv562errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv562transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv562transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 13
  pv563pageName: {
    path: 'page.name',
    value: 'MonedaExtranjera',
  },
  pv563pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv563subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv563pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv563pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv563internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv563errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv563transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv563transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 14
  pv564pageName: {
    path: 'page.name',
    value: 'OperacionExtranjera',
  },
  pv564pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv564subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv564pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv564pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv564internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv564errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv564transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv564transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 15
  pv565pageName: {
    path: 'page.name',
    value: 'TitularProductosExtranjeros',
  },
  pv565pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv565subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv565pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv565pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv565internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv565errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv565transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv565transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 16
  pv566pageName: {
    path: 'page.name',
    value: 'DatosProductosExtranjeros',
  },
  pv566pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv566subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv566pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv566pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv566internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv566errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv566transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv566transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 17
  pv567pageName: {
    path: 'page.name',
    value: 'ExitoCaptura',
  },
  pv567pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv567subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv567pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv567pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv567internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv567errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv567transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv567transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },
  pv567clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantalla 18
  pv568pageName: {
    path: 'page.name',
    value: 'ExitoCaptura',
  },
  pv568pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv568subFamily: {
    path: 'page.subfamily',
    value: 'Productos',
  },
  pv568pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv568pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv568internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv568errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv568transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'Multiproducto',
  },
  pv568transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },
  pv568clientElegibility: {
    path: 'visitor.client.elegibility',
    value: null,
  },

  // Pantallas Onboarding Cuenta de Ahorros - CE
  // Pantalla 1
  pv569pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv569pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv569subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv569pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv569pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv569internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv569errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv569transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv569transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 2
  pv570pageName: {
    path: 'page.name',
    value: 'IngresoCodigoDeConfirmacion',
  },
  pv570pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv570subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv570pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv570pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv570internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv570errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv570transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv570transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8
  pv571pageName: {
    path: 'page.name',
    value: 'UnAsesorOAliadoTeAcompaña',
  },
  pv571pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv571subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv571pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv571pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv571internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv571errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv571transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv571transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 11
  pv572pageName: {
    path: 'page.name',
    value: 'ErrorProcesoEnTramite',
  },
  pv572pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv572subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv572pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv572pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv572internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv572errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv572transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv572transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 12
  pv573pageName: {
    path: 'page.name',
    value: 'ErrorNoEPosibleContinuar',
  },
  pv573pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv573subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv573pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv573pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv573internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv573errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv573transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv573transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 13
  pv574pageName: {
    path: 'page.name',
    value: 'ProblemasConElCodigo',
  },
  pv574pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv574subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv574pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv574pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv574internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv574errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv574transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv574transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 14
  pv575pageName: {
    path: 'page.name',
    value: 'ErrorCodigoNoValidado',
  },
  pv575pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv575subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv575pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv575pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv575internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv575errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv575transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv575transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 15
  pv576pageName: {
    path: 'page.name',
    value: 'ErrorQueremosConocerte',
  },
  pv576pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv576subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv576pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv576pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv576internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv576errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv576transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv576transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 17
  pv577pageName: {
    path: 'page.name',
    value: 'ErrorBloqueoSARLAFT',
  },
  pv577pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv577subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv577pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv577pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv577internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv577errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv577transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv577transactionName: {
    path: 'transaction.name',
    value: 'Captura',
  },

  // Pantalla 21
  pv578pageName: {
    path: 'page.name',
    value: 'ErrorCrearTuCuenta',
  },
  pv578pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv578subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv578pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv578pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv578internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv578errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv578transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv578transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 22
  pv579pageName: {
    path: 'page.name',
    value: 'ErrorInconvenienteTecnico',
  },
  pv579pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv579subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv579pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv579pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv579internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv579errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv579transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv579transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 23
  pv580pageName: {
    path: 'page.name',
    value: 'ErrorBiocatch',
  },
  pv580pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv580subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv580pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv580pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv580internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv580errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv580transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv580transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Onboarding Cuenta ahorros cliente nuevo
  // Pantalla 6
  pv581pageName: {
    path: 'page.name',
    value: 'ErrorTienesProcesoEnTramite',
  },
  pv581pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv581subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv581pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv581pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv581internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv581errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv581transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv581transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8
  pv582pageName: {
    path: 'page.name',
    value: 'ErrorBiocatch',
  },
  pv582pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv582subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv582pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv582pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv582internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv582errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv582transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv582transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 11
  pv583pageName: {
    path: 'page.name',
    value: 'UnAsesorOAliadoTeAcompaña',
  },
  pv583pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv583subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv583pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv583pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv583internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv583errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv583transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv583transactionName: {
    path: 'transaction.name',
    value: 'Configuracion',
  },

  // Pantalla 16
  pv584pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv584pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv584subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv584pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv584pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv584internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv584errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv584transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv584transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 17
  pv585pageName: {
    path: 'page.name',
    value: 'ErrorCrearTuCuenta',
  },
  pv585pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv585subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv585pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv585pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv585internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv585errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv585transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv585transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 18
  pv586pageName: {
    path: 'page.name',
    value: 'ErrorInconvenienteTecnico',
  },
  pv586pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv586subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv586pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv586pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv586internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv586errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv586transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv586transactionName: {
    path: 'transaction.name',
    value: 'Vinculacion',
  },

  // Pantalla 7
  pv587pageName: {
    path: 'page.name',
    value: 'ErrorClienteExistente',
  },
  pv587pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv587subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv587pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv587pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv587internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv587errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv587transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv587transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantallas Onboarding Cuenta Ahorros - CN Web - Identificacion
  // Pantalla 1
  pv588pageName: {
    path: 'page.name',
    value: 'ComenzarIdentificacionAutorizacionDeDatos',
  },
  pv588pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv588subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv588pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv588pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv588internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv588errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv588transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv588transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 2
  pv589pageName: {
    path: 'page.name',
    value: 'IngresoDatosPersonales',
  },
  pv589pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv589subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv589pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv589pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv589internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv589errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv589transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv589transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 3
  pv590pageName: {
    path: 'page.name',
    value: 'VerificaDatosDocumento',
  },
  pv590pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv590subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv590pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv590pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv590internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv590errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv590transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv590transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 5
  pv591pageName: {
    path: 'page.name',
    value: 'ErrorYaEresClienteItau',
  },
  pv591pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv591subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv591pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv591pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv591internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv591errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv591transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv591transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 6
  pv592pageName: {
    path: 'page.name',
    value: 'ErrorInconvenientesTecnicos',
  },
  pv592pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv592subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv592pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv592pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv592internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv592errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv592transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv592transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 7
  pv593pageName: {
    path: 'page.name',
    value: 'ErrorContinuidadEnLaSolicitud',
  },
  pv593pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv593subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv593pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv593pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv593internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv593errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv593transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv593transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 8
  pv594pageName: {
    path: 'page.name',
    value: 'InformacionDeContacto',
  },
  pv594pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv594subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv594pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv594pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv594internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv594errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv594transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv594transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 9
  pv595pageName: {
    path: 'page.name',
    value: 'EnvioCodigoOTP',
  },
  pv595pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv595subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv595pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv595pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv595internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv595errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv595transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv595transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 10
  pv596pageName: {
    path: 'page.name',
    value: 'ErrorValidacionDeIdentidad',
  },
  pv596pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv596subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv596pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv596pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv596internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv596errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv596transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv596transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 11
  pv597pageName: {
    path: 'page.name',
    value: 'ErrorInconvenientesTecnicosIdentificacion',
  },
  pv597pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv597subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv597pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv597pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv597internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv597errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv597transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv597transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 15
  pv598pageName: {
    path: 'page.name',
    value: 'ErrorUsuarioSuperoIntentosPermitidos',
  },
  pv598pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv598subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv598pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv598pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv598internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv598errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv598transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv598transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 16
  pv599pageName: {
    path: 'page.name',
    value: 'ErrorNoHaySuficientesPreguntas',
  },
  pv599pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv599subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv599pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv599pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv599internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv599errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv599transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv599transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 17
  pv600pageName: {
    path: 'page.name',
    value: 'InicioPreguntasDeValidacionDeIdentidad',
  },
  pv600pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv600subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv600pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv600pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv600internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv600errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv600transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv600transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 18
  pv601pageName: {
    path: 'page.name',
    value: 'ErrorRespuestasIncorrectas',
  },
  pv601pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv601subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv601pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv601pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv601internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv601errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv601transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv601transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 19
  pv602pageName: {
    path: 'page.name',
    value: 'ErrorTecnicoPreguntasDeIdentificacion',
  },
  pv602pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv602subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv602pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv602pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv602internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv602errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv602transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv602transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 20
  pv603pageName: {
    path: 'page.name',
    value: 'PrimeraPreguntaDeSeguridad',
  },
  pv603pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv603subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv603pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv603pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv603internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv603errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv603transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv603transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 21
  pv604pageName: {
    path: 'page.name',
    value: 'SegundaPreguntaDeSeguridad',
  },
  pv604pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv604subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv604pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv604pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv604internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv604errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv604transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv604transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 22
  pv605pageName: {
    path: 'page.name',
    value: 'TerceraPreguntaDeSeguridad',
  },
  pv605pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv605subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv605pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv605pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv605internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv605errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv605transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv605transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 23
  pv606pageName: {
    path: 'page.name',
    value: 'CuartaPreguntaDeSeguridad',
  },
  pv606pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv606subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv606pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv606pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv606internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv606errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv606transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv606transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 24
  pv607pageName: {
    path: 'page.name',
    value: 'RegistroCompleto',
  },
  pv607pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv607subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv607pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv607pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv607internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv607errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv607transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv607transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  // Pantalla 25
  pv608pageName: {
    path: 'page.name',
    value: 'DondeNaciste',
  },
  pv608pageFamily: {
    path: 'page.family',
    value: 'Cuentas',
  },
  pv608subFamily: {
    path: 'page.subfamily',
    value: 'Ahorros',
  },
  pv608pageAction: {
    path: 'page.action',
    value: 'Abrir',
  },
  pv608pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv608internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv608errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv608transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CuentaAhorros',
  },
  pv608transactionName: {
    path: 'transaction.name',
    value: 'Identificacion',
  },

  //////////////////////////////////// Onboarding Cliete Existe Credito Personal Web - App
  // Etapa Captura Documento
  // Pantalla 1
  pv609pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv609pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv609subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv609pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv609pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv609internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv609errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv609transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv609transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 2
  pv610pageName: {
    path: 'page.name',
    value: 'IngresarCodigoDeConfirmacion',
  },
  pv610pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv610subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv610pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv610pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv610internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv610errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv610transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv610transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 3
  pv611pageName: {
    path: 'page.name',
    value: 'ErrorNoEsPosibleContinuar',
  },
  pv611pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv611subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv611pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv611pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv611internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv611errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv611transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv611transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 4
  pv612pageName: {
    path: 'page.name',
    value: 'ErrorProcesoEnTramite',
  },
  pv612pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv612subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv612pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv612pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv612internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv612errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv612transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv612transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 5
  pv613pageName: {
    path: 'page.name',
    value: 'EmpleadoDelBanco',
  },
  pv613pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv613subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv613pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv613pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv613internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv613errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv613transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv613transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 6
  pv614pageName: {
    path: 'page.name',
    value: 'ProblemaConElCodigo',
  },
  pv614pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv614subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv614pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv614pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv614internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv614errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv614transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv614transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Etapa Ingreso Datos
  // Pantalla 1
  pv615pageName: {
    path: 'page.name',
    value: 'CondicionesDeAsegurabilidad',
  },
  pv615pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv615subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv615pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv615pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv615internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv615errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv615transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv615transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 2
  pv616pageName: {
    path: 'page.name',
    value: 'ConfirmacionOcupacionActual',
  },
  pv616pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv616subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv616pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv616pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv616internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv616errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv616transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv616transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 3
  pv617pageName: {
    path: 'page.name',
    value: 'ErrorCambioOcupacion',
  },
  pv617pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv617subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv617pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv617pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv617internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv617errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv617transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv617transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 4
  pv618pageName: {
    path: 'page.name',
    value: 'ActualizacionVoluntaria',
  },
  pv618pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv618subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv618pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv618pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv618internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv618errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv618transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv618transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 5
  pv619pageName: {
    path: 'page.name',
    value: 'ActualizacionObligatoria',
  },
  pv619pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv619subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv619pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv619pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv619internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv619errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv619transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv619transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 6
  pv620pageName: {
    path: 'page.name',
    value: 'ErrorDatosDesactualizados',
  },
  pv620pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv620subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv620pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv620pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv620internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv620errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv620transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv620transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7
  pv621pageName: {
    path: 'page.name',
    value: 'ActualizacionDeDatos',
  },
  pv621pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv621subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv621pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv621pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv621internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv621errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv621transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv621transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Etapa Configuracion Vinculación
  // Pantalla 1
  pv622pageName: {
    path: 'page.name',
    value: 'FechaPagoCredito',
  },
  pv622pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv622subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv622pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv622pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv622internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv622errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv622transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv622transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 2
  pv623pageName: {
    path: 'page.name',
    value: 'OpcionesDesembolso',
  },
  pv623pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv623subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv623pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv623pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv623internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv623errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv623transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv623transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 3
  pv624pageName: {
    path: 'page.name',
    value: 'OficinaCheque',
  },
  pv624pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv624subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv624pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv624pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv624internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv624errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv624transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv624transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 4
  pv625pageName: {
    path: 'page.name',
    value: 'AperturaCuenta',
  },
  pv625pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv625subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv625pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv625pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv625internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv625errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv625transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv625transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 5
  pv626pageName: {
    path: 'page.name',
    value: 'FormaEntregaTarjeta',
  },
  pv626pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv626subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv626pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv626pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv626internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv626errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv626transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv626transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 6
  pv627pageName: {
    path: 'page.name',
    value: 'DireccionEntrega',
  },
  pv627pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv627subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv627pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv627pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv627internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv627errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv627transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv627transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 7
  pv628pageName: {
    path: 'page.name',
    value: 'ConfirmarCelular',
  },
  pv628pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv628subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv628pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv628pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv628internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv628errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv628transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv628transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 8
  pv629pageName: {
    path: 'page.name',
    value: 'DatosCuentaOtroBanco',
  },
  pv629pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv629subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv629pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv629pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv629internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv629errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv629transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv629transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 9
  pv630pageName: {
    path: 'page.name',
    value: 'SeleccionarCuentaDesembolso',
  },
  pv630pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv630subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv630pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv630pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv630internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv630errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv630transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv630transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 10
  pv631pageName: {
    path: 'page.name',
    value: 'UnAsesorOAliadoTeAcompaña',
  },
  pv631pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv631subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv631pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv631pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv631internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv631errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv631transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv631transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 11
  pv632pageName: {
    path: 'page.name',
    value: 'CaractersiticasProducto',
  },
  pv632pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv632subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv632pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv632pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv632internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv632errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv632transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv632transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv632transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv632transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv632customTransactionSimulationValue: {
    path: 'custom.events.transactionsimulationvalue',
    value: null,
  },

  // Pantalla 12
  pv633pageName: {
    path: 'page.name',
    value: 'ExitoCreditoPersonal',
  },
  pv633pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv633subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv633pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv633pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv633internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv633errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv633transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv633transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },
  pv633transactionTax: {
    path: 'transaction.details.tax',
    value: null,
  },
  pv633transactionProductDetails: {
    path: 'transaction.details.productdetails',
    value: null,
  },
  pv633customTransactionvalue: {
    path: 'custom.events.transactionvalue',
    value: null,
  },

  // Pantalla 13
  pv634pageName: {
    path: 'page.name',
    value: 'SolicitudEnProcesoTimeOut',
  },
  pv634pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv634subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv634pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv634pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv634internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv634errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv634transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv634transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 14
  pv635pageName: {
    path: 'page.name',
    value: 'SolicitudRecibida',
  },
  pv635pageFamily: {
    path: 'page.family',
    value: 'Onboarding',
  },
  pv635subFamily: {
    path: 'page.subfamily',
    value: 'CreditoPersonal',
  },
  pv635pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv635pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv635internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv635errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv635transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'CreditoPersonal',
  },
  pv635transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Onboarding Tarjeta de Credito CN Web
  // Pantalla 2
  pv636pageName: {
    path: 'page.name',
    value: 'IngresarCodigoDeConfirmacion',
  },
  pv636pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv636subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv636pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv636pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv636internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv636errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv636transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv636transactionName: {
    path: 'transaction.name',
    value: 'CapturaDocumento',
  },

  // Pantalla 3
  pv637pageName: {
    path: 'page.name',
    value: 'EstadoCivil',
  },
  pv637pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv637subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv637pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv637pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv637internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv637errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv637transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv637transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },

  // Pantalla 7
  pv638pageName: {
    path: 'page.name',
    value: 'SolicitudEnProcesoTimeOut',
  },
  pv638pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv638subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv638pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv638pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv638internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv638errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv638transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv638transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 8
  pv639pageName: {
    path: 'page.name',
    value: 'SolicitudEnValidacion',
  },
  pv639pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv639subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv639pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv639pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv639internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv639errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv639transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv639transactionName: {
    path: 'transaction.name',
    value: 'ConfigurarVinculacion',
  },

  // Pantalla 11
  pv640pageName: {
    path: 'page.name',
    value: 'ErrorProductoNoCreado',
  },
  pv640pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv640subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv640pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv640pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv640internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv640errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv640transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv640transactionName: {
    path: 'transaction.name',
    value: 'VinculacionProducto',
  },

  // Pantalla 12
  pv641pageName: {
    path: 'page.name',
    value: 'ZonaGrisOfertaAprobada',
  },
  pv641pageFamily: {
    path: 'page.family',
    value: 'Tarjetas',
  },
  pv641subFamily: {
    path: 'page.subfamily',
    value: 'Credito',
  },
  pv641pageAction: {
    path: 'page.action',
    value: 'Contratar',
  },
  pv641pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv641internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv641errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv641transactionProductCategory: {
    path: 'transaction.details.productcategory',
    value: 'SolicitudTC',
  },
  pv641transactionName: {
    path: 'transaction.name',
    value: 'IngresoDatos',
  },
};

export const EVENT = {
  customCategory: {
    module: {
      body: 'Body',
      carousel: 'Carousel',
      footer: 'Footer',
      header: 'Header',
      lightbox: 'Lightbox',
      menu: 'Menu',
    },
    type: {
      accordion: 'Accordion',
      arrow: 'Arrow',
      button: 'Button',
      card: 'Card',
      checkbox: 'Checkbox',
      dropdown: 'Dropdown',
      image: 'Image',
      link: 'Link',
      pagination: 'Pagination',
      radio: 'Radio',
      tab: 'Tab',
      textField: 'TextField',
      tooltip: 'Tooltip',
      warning: 'Warning',
      content: 'Content',
    },
    position: {
      bottom: 'Bottom',
      center: 'Center',
      left: 'Left',
      rigt: 'Right',
      top: 'Top',
    },
  },
  customAction: {
    click: 'Click',
    close: 'Close',
    download: 'Download',
    hide: 'Hide',
    open: 'Open',
    print: 'Print',
    scroll: 'Scroll',
    search: 'Search',
    share: 'Share',
    show: 'Show',
    swipeToLeft: 'SwipeToLeft',
    swipeToRigth: 'SwipeToRigth',
  },
  // Pantallas de Captura Documento - Tarjetas,

  // Eventos Pantalla 1,
  pv1E1customLabel: 'ConoceMas',
  pv1E2customLabel: 'SolicitudProducto',
  pv1E3customLabel: 'Consultar',
  pv1E4customLabel: 'Consultar | ConsultarSolicitudes',

  // Eventos Pantalla 2,
  pv2E1customLabel: null,
  pv2E1setData: {
    pv2E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
  },

  pv2E2customLabel: 'Solicitar',
  pv2E2setData: {
    pv2E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
  },

  pv1E3setData: {
    pv1E3transactionName: {
      path: 'transaction.name',
      value: 'OfertaSoloCP',
    },
    pv1E3transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 4,
  pv4E1customLabel: 'TratamientoDatos',
  pv4E1setData: {
    pv4E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv4E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv4E2customLabel: 'TomarFoto',
  pv4E2setData: {
    pv4E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv4E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv4E5customLabel: 'ModalTratamientoDatos',
  pv4E5setData: {
    pv4E5transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
    pv4E5transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv4E10customLabel: null,
  pv4E10setData: {
    pv4E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv4E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv4E11customLabel: 'Salir',
  pv4E11setData: {
    pv4E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv4E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 5,
  pv6E1customLabel: 'CapturaCedulaPosteriorExito',
  pv6E1setData: {
    pv6E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv6E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Pantalla popup custom labels
  pv10E9customLabel: 'PopUpFinanciamiento',
  pv10E10customLabel: 'PopUpFinanciamiento | ConoceOferta',
  pv10E11customLabel: 'PopUpFinanciamiento | NoMeInteresa',

  // Eventos Pantalla 6,
  pv12E1customLabel: 'TomarFoto',
  pv12E1setData: {
    pv12E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv12E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv12E10customLabel: null,
  pv12E10setData: {
    pv12E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv12E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv12E11customLabel: 'Salir',
  pv12E11setData: {
    pv12E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv12E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 7,

  pv13E1customLabel: 'CapturaCedulaFrontalExito',
  pv13E1setData: {
    pv13E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv13E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos Pantalla 8,

  pv14E1customLabel: 'Continuar',
  pv14E1setData: {
    pv14E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv14E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos Pantalla 9,
  pv15E10customLabel: null,
  pv15E10setData: {
    pv15E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv15E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv15E11customLabel: 'Salir',
  pv15E11setData: {
    pv15E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv15E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 10,

  pv17E1customLabel: 'TomarFoto',
  pv17E1setData: {
    pv17E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv17E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv17E10customLabel: null,
  pv17E10setData: {
    pv17E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv17E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv17E11customLabel: 'Salir',
  pv17E11setData: {
    pv17E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
    pv17E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 11,

  pv19E1customLabel: 'CapturaHuellasExito',
  pv19E1setData: {
    pv19E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv19E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos Pantalla 12,

  pv21E1customLabel: 'TomarFoto',
  pv21E1setData: {
    pv21E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv21E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos Pantalla 14,

  pv7E1customLabel: 'Reintentar',
  pv7E1setData: {
    pv7E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv7E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos Pantalla 16,

  pv221E1customLabel: 'Reintentar',
  pv221E1setData: {
    pv221E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv221E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos Pantalla 18,

  pv222E1customLabel: 'Reintentar',
  pv222E1setData: {
    pv222E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv222E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTC',
    },
  },

  // Eventos de Pantallas de TarjetasCreditoContratar  - IngresoDatos,
  // Eventos Pantalla 1,

  pv22E6customLabel: 'VerificarDatoReverso',
  pv22E6setData: {
    pv22E6transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv22E6transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv22E7customLabel: 'VerificarDatoFrontal',
  pv22E7setData: {
    pv22E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv22E7transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv22E10customLabel: null,
  pv22E10setData: {
    pv22E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv22E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv22E11customLabel: 'Salir',
  pv22E11setData: {
    pv22E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv22E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 2,
  pv23E10customLabel: null,
  pv23E10setData: {
    pv23E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv23E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv23E11customLabel: 'Salir',
  pv23E11setData: {
    pv23E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv23E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 3,
  pv24E10customLabel: null,
  pv24E10setData: {
    pv24E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv24E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv24E11customLabel: 'Salir',
  pv24E11setData: {
    pv24E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv24E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 4,
  pv25E10customLabel: null,
  pv25E10setData: {
    pv25E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv25E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv25E11customLabel: 'Salir',
  pv25E11setData: {
    pv25E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv25E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5

  pv26E10customLabel: null,
  pv26E10setData: {
    pv26E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv26E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv26E11customLabel: 'Salir',
  pv26E11setData: {
    pv26E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv26E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 6,
  pv27E3customLabel: 'Contrato',
  pv27E3setData: {
    pv27E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv27E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv27E10customLabel: null,
  pv27E10setData: {
    pv27E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv27E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv27E11customLabel: 'Salir',
  pv27E11setData: {
    pv27E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv27E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 7,
  pv230E3customLabel: 'InfoActividadEconomica',
  pv230E3setData: {
    pv230E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv230E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv230E10customLabel: null,
  pv230E10setData: {
    pv230E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv230E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv230E11customLabel: 'Salir',
  pv230E11setData: {
    pv230E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv230E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 8,

  pv231E11customLabel: 'Salir',
  pv231E11setData: {
    pv231E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv231E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 9,
  pv28E10customLabel: null,
  pv28E10setData: {
    pv28E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv28E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv28E11customLabel: 'Salir',
  pv28E11setData: {
    pv28E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv28E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 11,
  pv29E3customLabel: 'Continuar  | Ingresos',
  pv29E3setData: {
    pv29E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv29E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv29E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv29E4customLabel: null,
  pv29E4setData: {
    pv29E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv29E4transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv29E10customLabel: null,
  pv29E10setData: {
    pv29E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv29E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv29E11customLabel: 'Salir',
  pv29E11setData: {
    pv29E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv29E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 12,
  pv31E1customLabel: 'QuieroMiCupo',
  pv31E1setData: {
    pv31E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv31E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv31E2customLabel: 'MejorOtroDia',
  pv31E2setData: {
    pv31E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv31E2transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv31E10customLabel: null,
  pv31E10setData: {
    pv31E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv31E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv31E11customLabel: 'Salir',
  pv31E11setData: {
    pv31E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv31E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Pantallas de Configurar,
  // Eventos Pantalla 1,
  pv40E1customLabel: 'BuscarCiudad',
  pv40E1setData: {
    pv40E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv40E1transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv40E2customLabel: 'BuscarOficina',
  pv40E2setData: {
    pv40E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv40E2transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv40E3customLabel: 'ErrorNoSucursalesCiudad',
  pv40E3setData: {
    pv40E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv40E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv40E4customLabel: 'ErrorNoEncuentraOficina',
  pv40E4setData: {
    pv40E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv40E4transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv40E10customLabel: null,
  pv40E10setData: {
    pv40E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv40E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv40E11customLabel: 'Salir',
  pv40E11setData: {
    pv40E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv40E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 2,
  pv41E1customLabel: 'CambiarSucursal',
  pv41E1setData: {
    pv41E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv41E1transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv41E10customLabel: null,
  pv41E10setData: {
    pv41E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv41E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv41E11customLabel: 'Salir',
  pv41E11setData: {
    pv41E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv41E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 3,
  pv42E10customLabel: null,
  pv42E10setData: {
    pv42E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv42E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv42E11customLabel: 'Salir',
  pv42E11setData: {
    pv42E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv42E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 4,
  pv43E10customLabel: null,
  pv43E10setData: {
    pv43E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv43E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv43E11customLabel: 'Salir',
  pv43E11setData: {
    pv43E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv43E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantallas de TarjetaCreditoSolicitar - IngresoDatosFinancieros,
  // Eventos Pantalla 2,
  pv46E3customLabel: 'Continuar | GastosMensuales',
  pv46E3setData: {
    pv46E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv46E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv46E10customLabel: null,
  pv46E10setData: {
    pv46E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv46E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv46E11customLabel: 'Salir',
  pv46E11setData: {
    pv46E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv46E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 3,

  pv47E10customLabel: null,
  pv47E10setData: {
    pv47E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv47E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv47E11customLabel: 'Salir',
  pv47E11setData: {
    pv47E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv47E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 4,
  pv48E3customLabel: 'TooltipOperacionesExtranjeras',
  pv48E3setData: {
    pv48E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv48E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv48E10customLabel: null,
  pv48E10setData: {
    pv48E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv48E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv48E11customLabel: 'Salir',
  pv48E11setData: {
    pv48E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv48E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5,
  pv49E1customLabel: 'Continuar | OperacionRealizada | ',
  pv49E1setData: {
    pv49E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv49E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv49E10customLabel: null,
  pv49E10setData: {
    pv49E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv49E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv49E11customLabel: 'Salir',
  pv49E11setData: {
    pv49E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv49E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 6,

  pv50E10customLabel: null,
  pv50E10setData: {
    pv50E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv50E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv50E11customLabel: 'Salir',
  pv50E11setData: {
    pv50E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv50E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 7,

  pv53E10customLabel: null,
  pv53E10setData: {
    pv53E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv53E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv53E11customLabel: 'Salir',
  pv53E11setData: {
    pv53E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv53E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 8,
  pv51E1customLabel: 'Continuar | TipoProducto | ',
  pv51E1setData: {
    pv51E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv51E1transactionDetailsCurrency: {
      path: 'transaction.details.currency',
      value: null,
    },
    pv51E1transactionDetailsTransactioninstitution: {
      path: 'transaction.details.transactioninstitution',
      value: null,
    },
    pv51E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv51E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv51E10customLabel: null,
  pv51E10setData: {
    pv51E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv51E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv51E11customLabel: 'Salir',
  pv51E11setData: {
    pv51E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv51E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Pantallas de Vinculacion,
  // Eventos Pantalla 1,
  pv54E2customLabel: 'VerTerminosYCondiciones',
  pv54E2setData: {
    pv54E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv54E2transactionName: {
      path: 'transaction.name',
      value: 'VinculacionProducto',
    },
  },
  pv54E3customLabel: 'PageViewed',
  pv54E3setData: {
    pv54E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv54E3transactionName: {
      path: 'transaction.name',
      value: 'VinculacionProducto',
    },
  },

  pv54E10customLabel: null,
  pv54E10setData: {
    pv54E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv54E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv54E11customLabel: 'Salir',
  pv54E11setData: {
    pv54E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv54E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 2,
  pv56E1customLabel: 'PageViewed',
  pv56E1setData: {
    pv56E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCN',
    },
    pv56E1transactionName: {
      path: 'transaction.name',
      value: 'VinculacionProducto',
    },
  },

  // Eventos de CuentasCapturaDocumentoAbrir  - Cuenta Ahorros,
  // Eventos Pantalla 4,

  pv60E1customLabel: 'TratamientoDatos',
  pv60E1setData: {
    pv60E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv60E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv60E2customLabel: 'TomarFoto',
  pv60E2setData: {
    pv60E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv60E2transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv60E10customLabel: null,
  pv60E10setData: {
    pv60E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv60E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv60E11customLabel: 'Salir',
  pv60E11setData: {
    pv60E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv60E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 6,

  pv62E1customLabel: 'TomarFoto',
  pv62E1setData: {
    pv62E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv62E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv62E10customLabel: null,
  pv62E10setData: {
    pv62E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv62E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv62E11customLabel: 'Salir',
  pv62E11setData: {
    pv62E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv62E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 8,
  pv64E1customLabel: 'Continuar',
  pv64E1setData: {
    pv64E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv64E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 9,
  pv65E1customLabel: 'Continuar',
  pv65E1setData: {
    pv65E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv65E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
    pv65E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  pv65E10customLabel: null,
  pv65E10setData: {
    pv65E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv65E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv65E11customLabel: 'Salir',
  pv65E11setData: {
    pv65E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv65E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 10,

  pv66E1customLabel: 'TomarFoto',
  pv66E1setData: {
    pv66E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv66E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv66E10customLabel: null,
  pv66E10setData: {
    pv66E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv66E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  pv66E11customLabel: 'Salir',
  pv66E11setData: {
    pv66E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv66E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 12,
  pv68E1customLabel: 'TomarFoto',
  pv68E1setData: {
    pv68E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv68E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 14,
  pv70E1customLabel: 'Reintentar',
  pv70E1setData: {
    pv70E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv70E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 16,
  pv72E1customLabel: 'Reintentar',
  pv72E1setData: {
    pv72E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv72E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 18,
  pv74E1customLabel: 'Reintentar',
  pv74E1setData: {
    pv74E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv74E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos de CuentasIngresoDatosAbrir  - Cuenta Ahorros Cliente Existente,
  // Eventos Pantalla 1,
  pv81E1customLabel: 'Continuar',
  pv81E1setData: {
    pv81E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv81E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv81E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'Ocupacion | ',
    },
  },

  pv81E10customLabel: null,
  pv81E10setData: {
    pv81E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv81E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv81E11customLabel: 'Salir',
  pv81E11setData: {
    pv81E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv81E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 2,
  pv82E1customLabel: 'Actualizar | ',
  pv82E1setData: {
    pv82E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv82E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 3,
  pv83E1customLabel: null,
  pv83E1setData: {
    pv83E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv83E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv83E2customLabel: 'ActualizacionExitosa',
  pv83E2setData: {
    pv83E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv83E2transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv83E10customLabel: null,
  pv83E10setData: {
    pv83E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv83E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv83E11customLabel: 'Salir',
  pv83E11setData: {
    pv83E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv83E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 6,
  pv86E10customLabel: null,
  pv86E10setData: {
    pv86E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorrosCE',
    },
    pv86E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv86E11customLabel: 'Salir',
  pv86E11setData: {
    pv86E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorrosCE',
    },
    pv86E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos de CuentasConfiguracionVinculacionAbrir - Cuenta Ahorros Cliente Existente,

  // Eventos Pantalla 1,
  pv88E10customLabel: null,
  pv88E10setData: {
    pv88E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv88E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  pv88E11customLabel: 'Salir',
  pv88E11setData: {
    pv88E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv88E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 2,
  pv89E1customLabel: 'Volver',
  pv89E1setData: {
    pv89E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv89E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv89E2customLabel: 'Solicitar',
  pv89E2setData: {
    pv89E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv89E2transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv89E10customLabel: null,
  pv89E10setData: {
    pv89E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv89E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv89E11customLabel: 'Salir',
  pv89E11setData: {
    pv89E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv89E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 5,
  pv92E1customLabel: 'Volver',
  pv92E1setData: {
    pv92E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv92E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv92E2customLabel: 'Solicitar',
  pv92E2setData: {
    pv92E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv92E2transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv92E10customLabel: null,
  pv92E10setData: {
    pv92E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv92E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv92E11customLabel: 'Salir',
  pv92E11setData: {
    pv92E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv92E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 8,
  pv95E1customLabel: 'Volver',
  pv95E1setData: {
    pv95E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv95E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv95E2customLabel: 'Solicitar',
  pv95E2setData: {
    pv95E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv95E2transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv95E10customLabel: null,
  pv95E10setData: {
    pv95E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorrosCE',
    },
    pv95E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv95E11customLabel: 'Salir',
  pv95E11setData: {
    pv95E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorrosCE',
    },
    pv95E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos de CuentasCapturaDocumentoAbrir  - Cuenta Nomina,

  // Eventos Pantalla 2,
  pv98E1customLabel: null,
  pv98E1setData: {
    pv98E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv98E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv98E2customLabel: 'Solicitar',
  pv98E2setData: {
    pv98E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv98E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 4,
  pv101E1customLabel: 'TratamientoDatos',
  pv101E1setData: {
    pv101E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv101E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv101E2customLabel: 'TomarFoto',
  pv101E2setData: {
    pv101E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv101E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv101E10customLabel: null,
  pv101E10setData: {
    pv101E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv101E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv101E11customLabel: 'Salir',
  pv101E11setData: {
    pv101E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv101E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 5,
  pv102E1customLabel: 'CapturaCedulaPosteriorExito',
  pv102E1setData: {
    pv102E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv102E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 6,

  pv103E1customLabel: 'TomarFoto',
  pv103E1setData: {
    pv103E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv103E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv103E10customLabel: null,
  pv103E10setData: {
    pv103E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv103E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv103E11customLabel: 'Salir',
  pv103E11setData: {
    pv103E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv103E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 7,
  pv104E1customLabel: 'CapturaCedulaFrontalExito',
  pv104E1setData: {
    pv104E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv104E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 8,
  pv105E1customLabel: 'Continuar',
  pv105E1setData: {
    pv105E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv105E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 9,

  pv106E10customLabel: null,
  pv106E10setData: {
    pv106E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv106E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv106E11customLabel: 'Salir',
  pv106E11setData: {
    pv106E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv106E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 10,

  pv107E1customLabel: 'TomarFoto',
  pv107E1setData: {
    pv107E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv107E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv107E10customLabel: null,
  pv107E10setData: {
    pv107E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv107E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv107E11customLabel: 'Salir',
  pv107E11setData: {
    pv107E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv107E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 11,
  pv108E1customLabel: 'CapturaHuellasExito',
  pv108E1setData: {
    pv108E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv108E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 12,
  pv388E1customLabel: 'TomarFoto',
  pv388E1setData: {
    pv388E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv388E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 14,
  pv110E1customLabel: 'Reintentar',
  pv110E1setData: {
    pv110E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv110E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 16,
  pv112E1customLabel: 'Reintentar',
  pv112E1setData: {
    pv112E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv112E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 18,
  pv114E1customLabel: 'Reintentar',
  pv114E1setData: {
    pv114E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv114E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 24,

  pv389E10customLabel: null,
  pv389E10setData: {
    pv389E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv389E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv389E11customLabel: 'Salir',
  pv389E11setData: {
    pv389E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNomina',
    },
    pv389E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos de CuentasIngresoDatosAbrir  - Cuenta Nomina Cliente Existente,
  // Eventos Pantalla 1,
  pv121E1customLabel: null,
  pv121E1setData: {
    pv121E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv121E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv121E10customLabel: null,
  pv121E10setData: {
    pv121E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv121E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv121E11customLabel: 'Salir',
  pv121E11setData: {
    pv121E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv121E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 2,
  pv122E1customLabel: null,
  pv122E1setData: {
    pv122E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv122E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv122E2customLabel: 'Guardar',
  pv122E2setData: {
    pv122E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv122E2transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv122E3customLabel: 'ActualziacionExitosa',
  pv122E3setData: {
    pv122E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv122E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
    pv122E3transactionDetailProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  pv122E4customLabel: 'IngresoMensual',
  pv122E4setData: {
    pv122E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv122E4transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv122E10customLabel: null,
  pv122E10setData: {
    pv122E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv122E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv122E11customLabel: 'Salir',
  pv122E11setData: {
    pv122E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
  },

  // Eventos Pantalla 4,

  pv124E10customLabel: null,
  pv124E10setData: {
    pv124E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv124E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv124E11customLabel: 'Salir',
  pv124E11setData: {
    pv124E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv124E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5,

  pv125E10customLabel: null,
  pv125E10setData: {
    pv125E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv125E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv125E11customLabel: 'Salir',
  pv125E11setData: {
    pv125E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv125E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  // Eventos Pantalla 6,

  pv126E10customLabel: null,
  pv126E10setData: {
    pv125E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv126E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv126E11customLabel: 'Salir',
  pv126E11setData: {
    pv126E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv126E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos de CuentasConfiguracionVinculacionAbrir - Cuenta Nomina Cliente Existente,

  // Eventos Pantalla 1,
  pv127E10customLabel: null,
  pv127E10setData: {
    pv127E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv127E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv127E11customLabel: 'Salir',
  pv127E11setData: {
    pv127E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv127E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 2,
  pv128E10customLabel: null,
  pv128E10setData: {
    pv128E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv128E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv128E11customLabel: 'Salir',
  pv128E11setData: {
    pv128E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv128E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  // Eventos Pantalla 5,

  pv131E10customLabel: null,
  pv131E10setData: {
    pv131E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv131E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv131E11customLabel: 'Salir',
  pv131E11setData: {
    pv131E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv131E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 7,
  pv133E10customLabel: null,
  pv133E10setData: {
    pv133E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv133E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv133E11customLabel: 'Salir',
  pv133E11setData: {
    pv133E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv133E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 8,
  pv134E10customLabel: null,
  pv134E10setData: {
    pv134E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv134E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  pv134E11customLabel: 'Salir',
  pv134E11setData: {
    pv134E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCE',
    },
    pv134E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos de Pantallas de CuentasIngresoDatosAbrir  - Ahorro CN,
  // Eventos Pantalla 1,

  pv165E6customLabel: 'VerificarDatoReverso',
  pv165E6setData: {
    pv165E6transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv165E6transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv165E7customLabel: 'VerificarDatoFrontal',
  pv165E7setData: {
    pv165E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv165E7transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv165E10customLabel: null,
  pv165E10setData: {
    pv165E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv165E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv165E11customLabel: 'Salir',
  pv165E11setData: {
    pv165E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv165E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 2,
  pv167E10customLabel: null,
  pv167E10setData: {
    pv167E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv167E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv167E11customLabel: 'Salir',
  pv167E11setData: {
    pv167E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv167E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 3,

  pv168E10customLabel: null,
  pv168E10setData: {
    pv168E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv168E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv168E11customLabel: 'Salir',
  pv168E11setData: {
    pv168E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv168E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 4,

  pv170E10customLabel: null,
  pv170E10setData: {
    pv170E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv170E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv170E11customLabel: 'Salir',
  pv170E11setData: {
    pv170E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv170E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 5,

  pv171E10customLabel: null,
  pv171E10setData: {
    pv171E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv171E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv171E11customLabel: 'Salir',
  pv171E11setData: {
    pv171E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv171E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv171E1customLabel: 'Continuar',
  pv171E1setData: {
    pv171E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv171E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv171E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'Ocupacion | ',
    },
  },

  // Eventos Pantalla 6,

  pv173E10customLabel: null,
  pv173E10setData: {
    pv173E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv173E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv173E11customLabel: 'Salir',
  pv173E11setData: {
    pv173E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv173E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 7,

  pv174E10customLabel: null,
  pv174E10setData: {
    pv174E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv174E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv174E11customLabel: 'Salir',
  pv174E11setData: {
    pv174E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv174E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 8,

  pv175E10customLabel: null,
  pv175E10setData: {
    pv175E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv175E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv175E11customLabel: 'Salir',
  pv175E11setData: {
    pv175E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv175E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 11,
  pv177E4customLabel: 'Error',
  pv177E4setData: {
    pv177E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv177E4transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv177E10customLabel: null,
  pv177E10setData: {
    pv177E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv177E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv177E11customLabel: 'Salir',
  pv177E11setData: {
    pv177E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv177E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 12,

  pv178E10customLabel: null,
  pv178E10setData: {
    pv178E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv178E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv178E11customLabel: 'Salir',
  pv178E11setData: {
    pv178E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv178E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 13,

  pv179E10customLabel: null,
  pv179E10setData: {
    pv179E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv179E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv179E11customLabel: 'Salir',
  pv179E11setData: {
    pv179E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv179E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 14,
  pv180E10customLabel: null,
  pv180E10setData: {
    pv180E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv180E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv180E11customLabel: 'Salir',
  pv180E11setData: {
    pv180E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv180E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 15,

  pv181E10customLabel: null,
  pv181E10setData: {
    pv181E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv181E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv181E11customLabel: 'Salir',
  pv181E11setData: {
    pv181E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv181E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 16,
  pv182E10customLabel: null,
  pv182E10setData: {
    pv182E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv182E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv182E11customLabel: 'Salir',
  pv182E11setData: {
    pv182E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv182E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 17,

  pv183E10customLabel: null,
  pv183E10setData: {
    pv183E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv183E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv183E11customLabel: 'Salir',
  pv183E11setData: {
    pv183E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv183E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 19,

  pv225E10customLabel: null,
  pv225E10setData: {
    pv225E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv225E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv225E11customLabel: 'Salir',
  pv225E11setData: {
    pv225E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv225E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantalla 20,

  pv226E10customLabel: null,
  pv226E10setData: {
    pv226E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv226E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  pv226E11customLabel: 'Salir',
  pv226E11setData: {
    pv226E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv226E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantallas de CuentasIngresoDatosAbrir  - Nomina CN,
  // Eventos Pantalla 1,
  pv187E6customLabel: 'VerificarDatoReverso',
  pv187E6setData: {
    pv187E6transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv187E6transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv187E7customLabel: 'VerificarDatoFrontal',
  pv187E7setData: {
    pv187E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv187E7transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv187E10customLabel: null,
  pv187E10setData: {
    pv187E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv187E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv187E11customLabel: 'Salir',
  pv187E11setData: {
    pv187E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv187E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 2,
  pv189E10customLabel: null,
  pv189E10setData: {
    pv189E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv189E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv189E11customLabel: 'Salir',
  pv189E11setData: {
    pv189E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv189E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 3,
  pv190E10customLabel: null,
  pv190E10setData: {
    pv190E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv190E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv190E11customLabel: 'Salir',
  pv190E11setData: {
    pv190E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv190E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 4,
  pv192E10customLabel: null,
  pv192E10setData: {
    pv192E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv192E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv192E11customLabel: 'Salir',
  pv192E11setData: {
    pv192E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv192E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5,
  pv193E10customLabel: null,
  pv193E10setData: {
    pv193E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv193E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv193E11customLabel: 'Salir',
  pv193E11setData: {
    pv193E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv193E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 8,
  pv196E10customLabel: null,
  pv196E10setData: {
    pv196E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv196E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv196E11customLabel: 'Salir',
  pv196E11setData: {
    pv196E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv196E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 10,
  pv195E3customLabel: 'Continuar | IngresosMensuales',
  pv195E3setData: {
    pv195E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv195E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv195E14customLabel: 'Error',
  pv195E14setData: {
    pv195E14transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv195E14transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv195E10customLabel: null,
  pv195E10setData: {
    pv195E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv195E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv195E11customLabel: 'Salir',
  pv195E11setData: {
    pv195E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv195E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 11,

  pv197E1customLabel: 'Continuar | GastosMensuales',
  pv197E1setData: {
    pv197E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv197E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv197E10customLabel: null,
  pv197E10setData: {
    pv197E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv197E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv197E11customLabel: 'Salir',
  pv197E11setData: {
    pv197E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv197E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 12,

  pv198E10customLabel: null,
  pv198E10setData: {
    pv198E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv198E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv198E11customLabel: 'Salir',
  pv198E11setData: {
    pv198E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv198E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 13,

  pv199E1customLabel: 'TooltipOperacionesExtranjeras',
  pv199E1setData: {
    pv199E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv199E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv199E10customLabel: null,
  pv199E10setData: {
    pv199E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv199E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv199E11customLabel: 'Salir',
  pv199E11setData: {
    pv199E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv199E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 14,

  pv200E10customLabel: null,
  pv200E10setData: {
    pv200E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv200E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv200E11customLabel: 'Salir',
  pv200E11setData: {
    pv200E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv200E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 15,
  pv201E3customLabel: null,
  pv201E3setData: {
    pv201E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv201E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv201E10customLabel: null,
  pv201E10setData: {
    pv201E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv201E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv201E11customLabel: 'Salir',
  pv201E11setData: {
    pv201E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv201E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 16,

  pv202E10customLabel: null,
  pv202E10setData: {
    pv202E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv202E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv202E11customLabel: 'Salir',
  pv202E11setData: {
    pv202E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv202E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 18,

  pv228E10customLabel: null,
  pv228E10setData: {
    pv228E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv228E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv228E11customLabel: 'Salir',
  pv228E11setData: {
    pv228E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv228E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 19,

  pv229E10customLabel: null,
  pv229E10setData: {
    pv229E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv229E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv229E11customLabel: 'Salir',
  pv229E11setData: {
    pv229E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv229E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos de Pantallas de CuentasConfiguracionVinculacionAbrir - Cuenta Ahorros Cliente Nuevo,

  // Eventos Pantalla 1,
  pv205E10customLabel: null,
  pv205E10setData: {
    pv205E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv205E10transactionName: {
      path: 'transaction.name',
      value: 'Configurar',
    },
  },

  pv205E11customLabel: 'Salir',
  pv205E11setData: {
    pv205E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv205E11transactionName: {
      path: 'transaction.name',
      value: 'Configurar',
    },
  },

  // Eventos Pantalla 2,
  pv206E10customLabel: null,
  pv206E10setData: {
    pv206E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv206E10transactionName: {
      path: 'transaction.name',
      value: 'Configurar',
    },
  },

  pv206E11customLabel: 'Salir',
  pv206E11setData: {
    pv206E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv206E11transactionName: {
      path: 'transaction.name',
      value: 'Configurar',
    },
  },

  // Eventos Pantalla 3,
  pv207E10customLabel: null,
  pv207E10setData: {
    pv207E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv207E10transactionName: {
      path: 'transaction.name',
      value: 'Configurar',
    },
  },

  pv207E11customLabel: 'Salir',
  pv207E11setData: {
    pv207E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv207E11transactionName: {
      path: 'transaction.name',
      value: 'Configurar',
    },
  },

  // Eventos Pantalla 4,
  pv208E1customLabel: 'Volver',
  pv208E1setData: {
    pv208E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv208E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv208E2customLabel: 'Solicitar',
  pv208E2setData: {
    pv208E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv208E2transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv208E10customLabel: null,
  pv208E10setData: {
    pv208E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv208E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv208E11customLabel: 'Salir',
  pv208E11setData: {
    pv208E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv208E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 5,
  pv209E1customLabel: 'Volver',
  pv209E1setData: {
    pv209E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv209E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv209E2customLabel: 'Solicitar',
  pv209E2setData: {
    pv209E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv209E2transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv209E10customLabel: null,
  pv209E10setData: {
    pv209E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv209E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv209E11customLabel: 'Salir',
  pv209E11setData: {
    pv209E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv209E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 6,
  pv210E1customLabel: 'Volver',
  pv210E1setData: {
    pv210E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv210E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv210E2customLabel: 'Solicitar',
  pv210E2setData: {
    pv210E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv210E2transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv210E10customLabel: null,
  pv210E10setData: {
    pv210E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv210E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv210E11customLabel: 'Salir',
  pv210E11setData: {
    pv210E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv210E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos de Pantallas de CuentasConfiguracionVinculacionAbrir - Cuenta Nomina Cliente Nuevo,

  // Eventos Pantalla 1,

  pv213E3customLabel: 'BuscarOficina',
  pv213E3setData: {
    pv213E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv213E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv213E4customLabel: 'BuscarCiudad',
  pv213E4setData: {
    pv213E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv213E4transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv213E10customLabel: null,
  pv213E10setData: {
    pv213E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv213E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv213E11customLabel: 'Salir',
  pv213E11setData: {
    pv213E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv213E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 2,

  pv214E3customLabel: 'CambiarSucursal',
  pv214E3setData: {
    pv214E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv214E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv214E10customLabel: null,
  pv214E10setData: {
    pv214E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv214E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv214E11customLabel: 'Salir',
  pv214E11setData: {
    pv214E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv214E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 3,
  pv215E10customLabel: null,
  pv215E10setData: {
    pv215E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv215E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv215E11customLabel: 'Salir',
  pv215E11setData: {
    pv215E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv215E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 4,
  pv216E10customLabel: null,
  pv216E10setData: {
    pv216E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv216E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv216E11customLabel: 'Salir',
  pv216E11setData: {
    pv216E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv216E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 5,

  pv217E10customLabel: null,
  pv217E10setData: {
    pv217E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv217E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv217E11customLabel: 'Salir',
  pv217E11setData: {
    pv217E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv217E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 6,
  pv218E10customLabel: null,
  pv218E10setData: {
    pv218E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv218E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv218E11customLabel: 'Salir',
  pv218E11setData: {
    pv218E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaNominaCN',
    },
    pv218E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos de Pantallas de PrestamoPersonalesContratar - Captura Documento,

  // Eventos Pantalla 2,
  pv238E1customLabel: null,
  pv238E1setData: {
    pv238E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv238E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv238E2customLabel: null,
  pv238E2setData: {
    pv238E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv238E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 5,
  pv241E1customLabel: 'TratamientoDatos',
  pv241E1setData: {
    pv241E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv241E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv241E2customLabel: 'TomarFoto',
  pv241E2setData: {
    pv241E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv241E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv241E10customLabel: null,
  pv241E10setData: {
    pv241E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv241E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv241E11customLabel: 'Salir',
  pv241E11setData: {
    pv241E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv241E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 6,
  pv242E1customLabel: 'CapturaCedulaPosteriorExito',
  pv242E1setData: {
    pv242E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv242E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 7,
  pv243E1customLabel: 'TomarFotoFC',
  pv243E1setData: {
    pv243E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv243E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv243E10customLabel: null,
  pv243E10setData: {
    pv243E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv243E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv243E11customLabel: 'Salir',
  pv243E11setData: {
    pv243E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv243E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 8,

  pv244E1customLabel: 'CapturaCedulaFrontalExito',
  pv244E1setData: {
    pv244E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv244E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 9,

  pv245E1customLabel: 'Continuar',
  pv245E1setData: {
    pv245E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv245E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 10,
  pv246E10customLabel: null,
  pv246E10setData: {
    pv246E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv246E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv246E11customLabel: 'Salir',
  pv246E11setData: {
    pv246E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv246E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 11,
  pv247E1customLabel: 'TomarFotoMD',
  pv247E1setData: {
    pv247E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv247E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv247E10customLabel: null,
  pv247E10setData: {
    pv247E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv247E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv247E11customLabel: 'Salir',
  pv247E11setData: {
    pv247E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv247E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 12,

  pv248E1customLabel: 'CapturaHuellasExito',
  pv248E1setData: {
    pv248E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv248E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 13,

  pv249E1customLabel: 'Continuar',
  pv249E1setData: {
    pv249E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv249E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 15,

  pv251E1customLabel: 'Reintentar',
  pv251E1setData: {
    pv251E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv251E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 17,

  pv253E1customLabel: 'Reintentar',
  pv253E1setData: {
    pv253E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv253E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos Pantalla 19,

  pv255E1customLabel: 'Reintentar',
  pv255E1setData: {
    pv255E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
    pv255E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
  },

  // Eventos de Pantallas de PrestamoPersonalesContratar - Credito Rotativo Ingreso,
  // Eventos Pantalla 1,

  pv263E11customLabel: 'Salir',
  pv263E11setData: {
    pv263E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv263E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 4,
  pv266E6customLabel: 'VerificarDatoReverso',
  pv266E6setData: {
    pv266E6transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv266E6transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv266E7customLabel: 'VerificarDatoFrontal',
  pv266E7setData: {
    pv266E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv266E7transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv266E10customLabel: null,
  pv266E10setData: {
    pv266E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv266E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv266E11customLabel: 'Salir',
  pv266E11setData: {
    pv266E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv266E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5,
  pv267E10customLabel: null,
  pv267E10setData: {
    pv267E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv267E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv267E11customLabel: 'Salir',
  pv267E11setData: {
    pv267E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv267E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 6,
  pv268E10customLabel: null,
  pv268E10setData: {
    pv268E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv268E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv268E11customLabel: 'Salir',
  pv268E11setData: {
    pv268E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv268E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 8,
  pv270E10customLabel: null,
  pv270E10setData: {
    pv270E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv270E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv270E11customLabel: 'Salir',
  pv270E11setData: {
    pv270E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv270E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 9

  pv271E10customLabel: null,
  pv271E10setData: {
    pv271E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv271E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv271E11customLabel: 'Salir',
  pv271E11setData: {
    pv271E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv271E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 10,
  pv272E3customLabel: 'Contrato | ',
  pv272E3setData: {
    pv272E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv272E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv272E10customLabel: null,
  pv272E10setData: {
    pv272E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv272E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv272E11customLabel: 'Salir',
  pv272E11setData: {
    pv272E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv272E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 11,

  pv273E10customLabel: null,
  pv273E10setData: {
    pv273E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv273E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv273E11customLabel: 'Salir',
  pv273E11setData: {
    pv273E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv273E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 12,
  pv274E3customLabel: 'Continuar  | Ingresos',
  pv274E3setData: {
    pv274E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv274E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv274E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv274E11customLabel: 'Salir',
  pv274E11setData: {
    pv274E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv274E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 14,
  pv276E1customLabel: 'Continuar',
  pv276E1setData: {
    pv276E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv276E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv276E2customLabel: 'MejorOtroDia',
  pv276E2setData: {
    pv276E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv276E2transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv276E10customLabel: null,
  pv276E10setData: {
    pv276E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv276E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv276E11customLabel: 'Salir',
  pv276E11setData: {
    pv276E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv276E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 21,
  pv282E1customLabel: 'InfoActividadEconomica',
  pv282E1setData: {
    pv282E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv282E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv282E10customLabel: null,
  pv282E10setData: {
    pv282E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv282E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv282E11customLabel: 'Salir',
  pv282E11setData: {
    pv282E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv282E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 23,

  pv285E10customLabel: null,
  pv285E10setData: {
    pv285E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv285E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv285E11customLabel: 'Salir',
  pv285E11setData: {
    pv285E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv285E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 23,

  pv286E11customLabel: 'Salir',
  pv286E11setData: {
    pv286E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv286E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos de  Pantallas de PrestamoPersonalesContratar - Credito rotativo Vinculacion,
  // Eventos Pantalla 1,

  pv288E10customLabel: null,
  pv288E10setData: {
    pv288E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv288E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv288E11customLabel: 'Salir',
  pv288E11setData: {
    pv288E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv288E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 2,

  pv289E10customLabel: null,
  pv289E10setData: {
    pv289E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv289E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv289E11customLabel: 'Salir',
  pv289E11setData: {
    pv289E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv289E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 3,

  pv290E10customLabel: null,
  pv290E10setData: {
    pv290E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv290E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv290E11customLabel: 'Salir',
  pv290E11setData: {
    pv290E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv290E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 4,

  pv291E10customLabel: null,
  pv291E10setData: {
    pv291E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv291E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv291E11customLabel: 'Salir',
  pv291E11setData: {
    pv291E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv291E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 5,

  pv292E10customLabel: null,
  pv292E10setData: {
    pv292E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv292E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv292E11customLabel: 'Salir',
  pv292E11setData: {
    pv292E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv292E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 6,

  pv293E10customLabel: null,
  pv293E10setData: {
    pv293E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv293E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv293E11customLabel: 'Salir',
  pv293E11setData: {
    pv293E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv293E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 9,

  pv296E10customLabel: null,
  pv296E10setData: {
    pv296E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv296E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv296E11customLabel: 'Salir',
  pv296E11setData: {
    pv296E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv296E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv296E3customLabel: 'BuscarCiudad',
  pv296E3setData: {
    pv296E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv296E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv296E4customLabel: 'BuscarOficina',
  pv296E4setData: {
    pv296E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv296E4transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 10,

  pv297E10customLabel: null,
  pv297E10setData: {
    pv297E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv297E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv297E11customLabel: 'Salir',
  pv297E11setData: {
    pv297E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv297E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv297E3customLabel: 'CambiarSucursal',
  pv297E3setData: {
    pv297E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv297E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 11,

  pv298E10customLabel: null,
  pv298E10setData: {
    pv298E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv298E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv298E11customLabel: 'Salir',
  pv298E11setData: {
    pv298E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv298E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 12,

  pv299E10customLabel: null,
  pv299E10setData: {
    pv299E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv299E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv299E11customLabel: 'Salir',
  pv299E11setData: {
    pv299E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv299E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 13,

  pv300E10customLabel: null,
  pv300E10setData: {
    pv300E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv300E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv300E11customLabel: 'Salir',
  pv300E11setData: {
    pv300E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv300E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 14,

  pv302E10customLabel: null,
  pv302E10setData: {
    pv302E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv302E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv302E11customLabel: 'Salir',
  pv302E11setData: {
    pv302E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv302E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 15,

  pv303E10customLabel: null,
  pv303E10setData: {
    pv303E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv303E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv303E11customLabel: 'Salir',
  pv303E11setData: {
    pv303E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv303E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 16,

  pv304E10customLabel: null,
  pv304E10setData: {
    pv304E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv304E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv304E11customLabel: 'Salir',
  pv304E11setData: {
    pv304E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv304E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 21,

  pv309E10customLabel: null,
  pv309E10setData: {
    pv309E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv309E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv309E11customLabel: 'Salir',
  pv309E11setData: {
    pv309E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv309E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv309E3customLabel: 'AsistidoOAutogestion',
  pv309E3setData: {
    pv309E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv309E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 22,

  pv310E10customLabel: null,
  pv310E10setData: {
    pv310E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv310E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv310E11customLabel: 'Salir',
  pv310E11setData: {
    pv310E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv310E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv310E3customLabel: 'AsistidoOAutogestion',
  pv310E3setData: {
    pv310E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'RotativoCN',
    },
    pv310E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Prestamo Personales Contratar - Prestamos,
  // Eventos Pantalla 2,

  pv313E1customLabel: null,
  pv313E1setData: {
    pv313E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv313E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv313E2customLabel: 'Solicitar',
  pv313E2setData: {
    pv313E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv313E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos pantalla 27,

  pv315E10customLabel: null,
  pv315E10setData: {
    pv315E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv315E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv315E11customLabel: 'Salir',
  pv315E11setData: {
    pv315E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv315E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos pantalla 28,

  pv316E10customLabel: null,
  pv316E10setData: {
    pv316E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv316E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv316E11customLabel: 'Salir',
  pv316E11setData: {
    pv316E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv316E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5,
  pv318E1customLabel: 'TratamientoDatos',
  pv318E1setData: {
    pv318E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv318E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv318E2customLabel: 'TomarFoto',
  pv318E2setData: {
    pv318E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv318E2transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv318E10customLabel: null,
  pv318E10setData: {
    pv318E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv318E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv318E11customLabel: 'Salir',
  pv318E11setData: {
    pv318E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv318E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 6,
  pv319E1customLabel: 'CapturaCedulaPosteriorExito',
  pv319E1setData: {
    pv319E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv319E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 7,

  pv320E1customLabel: 'TomarFotoFC',
  pv320E1setData: {
    pv320E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv320E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv320E10customLabel: null,
  pv320E10setData: {
    pv320E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv320E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv320E11customLabel: 'Salir',
  pv320E11setData: {
    pv320E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv320E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 8,
  pv321E1customLabel: 'CapturaCedulaFrontalExito',
  pv321E1setData: {
    pv321E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv321E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 8,
  pv322E1customLabel: 'Continuar',
  pv322E1setData: {
    pv322E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv322E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 10,
  pv323E10customLabel: null,
  pv323E10setData: {
    pv323E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv323E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv323E11customLabel: 'Salir',
  pv323E11setData: {
    pv323E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv323E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 11,

  pv324E1customLabel: 'TomarFotoMD',
  pv324E1setData: {
    pv324E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv324E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv324E10customLabel: null,
  pv324E10setData: {
    pv324E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv324E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  pv324E11customLabel: 'Salir',
  pv324E11setData: {
    pv324E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv324E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 12,
  pv325E1customLabel: 'CapturaHuellasExito',
  pv325E1setData: {
    pv325E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv325E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 13,
  pv326E1customLabel: 'Continuar',
  pv326E1setData: {
    pv326E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv326E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 15,
  pv328E1customLabel: 'Reintentar',
  pv328E1setData: {
    pv328E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv328E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 17,
  pv330E1customLabel: 'Reintentar',
  pv330E1setData: {
    pv330E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv330E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 19,
  pv332E1customLabel: 'Reintentar',
  pv332E1setData: {
    pv332E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv332E1transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Prestamo Credito Contratar - Prestamos,
  // Eventos Pantalla 1,
  pv340E10customLabel: null,
  pv340E10setData: {
    pv340E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv340E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv340E11customLabel: 'Salir',
  pv340E11setData: {
    pv340E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv340E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 4,
  pv343E6customLabel: 'VerificarDatoReverso',
  pv343E6setData: {
    pv343E6transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv343E6transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv343E7customLabel: 'VerificarDatoFrontal',
  pv343E7setData: {
    pv343E7transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv343E7transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv343E10customLabel: null,
  pv343E10setData: {
    pv343E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv343E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv343E11customLabel: 'Salir',
  pv343E11setData: {
    pv343E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv343E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 5,
  pv344E10customLabel: null,
  pv344E10setData: {
    pv344E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv344E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv344E11customLabel: 'Salir',
  pv344E11setData: {
    pv344E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv344E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 6,
  pv345E10customLabel: null,
  pv345E10setData: {
    pv345E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv345E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv345E11customLabel: 'Salir',
  pv345E11setData: {
    pv345E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv345E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 8,
  pv347E10customLabel: null,
  pv347E10setData: {
    pv347E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv347E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv347E11customLabel: 'Salir',
  pv347E11setData: {
    pv347E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv347E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 9,
  pv348E10customLabel: null,
  pv348E10setData: {
    pv348E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv348E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv348E11customLabel: 'Salir',
  pv348E11setData: {
    pv348E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv348E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 10,
  pv349E3customLabel: 'Contrato | ',
  pv349E3setData: {
    pv349E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv349E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv349E10customLabel: null,
  pv349E10setData: {
    pv349E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv349E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv349E11customLabel: 'Salir',
  pv349E11setData: {
    pv349E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv349E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 11,
  pv350E10customLabel: null,
  pv350E10setData: {
    pv350E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv350E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv350E11customLabel: 'Salir',
  pv350E11setData: {
    pv350E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv350E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 12,
  pv351E3customLabel: null,
  pv351E3setData: {
    pv351E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv351E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv351E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv351E10customLabel: null,
  pv351E10setData: {
    pv351E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv351E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv351E11customLabel: 'Salir',
  pv351E11setData: {
    pv351E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv351E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 13,
  pv352E1customLabel: 'Continuar',
  pv352E1setData: {
    pv352E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv352E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv352E2customLabel: 'MejorOtroDia',
  pv352E2setData: {
    pv352E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv352E2transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv352E10customLabel: null,
  pv352E10setData: {
    pv352E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv352E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv352E11customLabel: 'Salir',
  pv352E11setData: {
    pv352E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv352E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 14,
  pv353E1customLabel: 'Continuar',
  pv353E1setData: {
    pv353E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv353E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv353E2customLabel: 'MejorOtroDia',
  pv353E2setData: {
    pv353E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv353E2transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv353E10customLabel: null,
  pv353E10setData: {
    pv353E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv353E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv353E11customLabel: 'Salir',
  pv353E11setData: {
    pv353E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv353E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 20,
  pv359E1customLabel: 'InfoActividadEconomica',
  pv359E1setData: {
    pv359E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv359E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv359E10customLabel: null,
  pv359E10setData: {
    pv359E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv359E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv359E11customLabel: 'Salir',
  pv359E11setData: {
    pv359E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv359E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 21,
  pv360E10customLabel: null,
  pv360E10setData: {
    pv360E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv360E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv360E11customLabel: 'Salir',
  pv360E11setData: {
    pv360E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv360E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 23,
  pv362E10customLabel: null,
  pv362E10setData: {
    pv362E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv362E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv362E11customLabel: 'Salir',
  pv362E11setData: {
    pv362E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv362E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 24,
  pv363E10customLabel: null,
  pv363E10setData: {
    pv363E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv363E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  pv363E11customLabel: 'Salir',
  pv363E11setData: {
    pv363E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv363E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Prestamo ConfiguracionVinculacion Abrir - Prestamos,
  // Eventos Pantalla 1,
  pv365E10customLabel: null,
  pv365E10setData: {
    pv365E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv365E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv365E11customLabel: 'Salir',
  pv365E11setData: {
    pv365E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv365E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 2,
  pv366E10customLabel: null,
  pv366E10setData: {
    pv366E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv366E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv366E11customLabel: 'Salir',
  pv366E11setData: {
    pv366E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv366E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 3,
  pv367E10customLabel: null,
  pv367E10setData: {
    pv367E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv367E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv367E11customLabel: 'Salir',
  pv367E11setData: {
    pv367E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv367E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 4,
  pv368E10customLabel: null,
  pv368E10setData: {
    pv368E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv368E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv368E11customLabel: 'Salir',
  pv368E11setData: {
    pv368E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv368E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 5,
  pv369E10customLabel: null,
  pv369E10setData: {
    pv369E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv369E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv369E11customLabel: 'Salir',
  pv369E11setData: {
    pv369E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv369E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 6,
  pv370E10customLabel: null,
  pv370E10setData: {
    pv370E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv370E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv370E11customLabel: 'Salir',
  pv370E11setData: {
    pv370E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv370E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 9,
  pv373E10customLabel: null,
  pv373E10setData: {
    pv373E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv373E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv373E11customLabel: 'Salir',
  pv373E11setData: {
    pv373E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv373E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 10,
  pv374E3customLabel: 'CambiarSucursal',
  pv374E3setData: {
    pv374E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv374E3transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv374E10customLabel: null,
  pv374E10setData: {
    pv374E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv374E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv374E11customLabel: 'Salir',
  pv374E11setData: {
    pv374E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv374E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 11,
  pv375E10customLabel: null,
  pv375E10setData: {
    pv375E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv375E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv375E11customLabel: 'Salir',
  pv375E11setData: {
    pv375E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv375E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 12,
  pv376E10customLabel: null,
  pv376E10setData: {
    pv376E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv376E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv376E11customLabel: 'Salir',
  pv376E11setData: {
    pv376E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv376E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 13,
  pv377E10customLabel: null,
  pv377E10setData: {
    pv377E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv377E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv377E11customLabel: 'Salir',
  pv377E11setData: {
    pv377E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv377E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 14,
  pv378E10customLabel: null,
  pv378E10setData: {
    pv378E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv378E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv378E11customLabel: 'Salir',
  pv378E11setData: {
    pv378E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv378E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 15,
  pv379E10customLabel: null,
  pv379E10setData: {
    pv379E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv379E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv379E11customLabel: 'Salir',
  pv379E11setData: {
    pv379E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv379E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 16,
  pv380E10customLabel: null,
  pv380E10setData: {
    pv380E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv380E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv380E11customLabel: 'Salir',
  pv380E11setData: {
    pv380E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv380E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 17,
  pv381E10customLabel: null,
  pv381E10setData: {
    pv381E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv381E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv381E11customLabel: 'Salir',
  pv381E11setData: {
    pv381E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv381E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 18,
  pv382E10customLabel: null,
  pv382E10setData: {
    pv382E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv382E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  pv382E11customLabel: 'Salir',
  pv382E11setData: {
    pv382E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'PersonalCN',
    },
    pv382E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos de Onboarding vivienda,
  // Eventos Pantalla 1,
  pv391E11customLabel: 'Salir',
  pv391E11setData: {
    pv391E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv391E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv391E10customLabel: null,
  pv391E10setData: {
    pv391E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv391E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv391E3customLabel: 'Continuar',
  pv391E3setData: {
    pv391E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv391E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 3,
  pv393E11customLabel: 'Salir',
  pv393E11setData: {
    pv393E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv393E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv393E2customLabel: 'Continuar',
  pv393E2setData: {
    pv393E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv393E2transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv393E10customLabel: null,
  pv393E10setData: {
    pv393E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv393E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 4,
  pv394E11customLabel: 'Salir',
  pv394E11setData: {
    pv394E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv394E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv394E10customLabel: null,
  pv394E10setData: {
    pv394E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv394E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 5,
  pv395E11customLabel: 'Salir',
  pv395E11setData: {
    pv395E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv395E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv395E10customLabel: null,
  pv395E10setData: {
    pv395E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv395E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv395E3customLabel: 'Continuar',
  pv395E3setData: {
    pv395E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv395E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
    pv395E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 6,
  pv396E11customLabel: 'Salir',
  pv396E11setData: {
    pv396E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv396E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv396E10customLabel: null,
  pv396E10setData: {
    pv396E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv396E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 7,
  pv397E11customLabel: 'Salir',
  pv397E11setData: {
    pv397E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv397E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv397E10customLabel: null,
  pv397E10setData: {
    pv397E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv397E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv397E3customLabel: 'Continuar',
  pv397E3setData: {
    pv397E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv397E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
    pv397E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 8,
  pv398E11customLabel: 'Salir',
  pv398E11setData: {
    pv398E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv398E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv398E10customLabel: null,
  pv398E10setData: {
    pv398E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv398E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 9,
  pv399E11customLabel: 'Salir',
  pv399E11setData: {
    pv399E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv399E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv399E10customLabel: null,
  pv399E10setData: {
    pv399E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv399E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv399E3customLabel: 'Continuar',
  pv399E3setData: {
    pv399E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv399E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
    pv399E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 10,
  pv400E11customLabel: 'Salir',
  pv400E11setData: {
    pv400E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv400E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv400E10customLabel: null,
  pv400E10setData: {
    pv400E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv400E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv400E3customLabel: 'Continuar',
  pv400E3setData: {
    pv400E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv400E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
    pv400E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv400E3transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: 'CargaArchivo',
    },
  },

  // Eventos Pantalla 11,
  pv401E11customLabel: 'Salir',
  pv401E11setData: {
    pv401E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv401E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv401E10customLabel: null,
  pv401E10setData: {
    pv401E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv401E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 12,
  pv402E11customLabel: 'Salir',
  pv402E11setData: {
    pv402E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv402E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv402E10customLabel: null,
  pv402E10setData: {
    pv402E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv402E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 13,
  pv403E11customLabel: 'Salir',
  pv403E11setData: {
    pv403E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv403E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv403E10customLabel: null,
  pv403E10setData: {
    pv403E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv403E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 14,
  pv404E11customLabel: 'Salir',
  pv404E11setData: {
    pv404E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv404E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv404E10customLabel: null,
  pv404E10setData: {
    pv404E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv404E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv404E3customLabel: 'Continuar',
  pv404E3setData: {
    pv404E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv404E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
    pv404E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'Subdidio | ',
    },
    pv404E3transactionInstallmentsterm: {
      path: 'transaction.details.installmentsterm',
      value: null,
    },
  },

  // Eventos Pantalla 15,
  pv405E11customLabel: 'Salir',
  pv405E11setData: {
    pv405E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv405E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv405E10customLabel: null,
  pv405E10setData: {
    pv405E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv405E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv405E3customLabel: null,
  pv405E3setData: {
    pv405E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv405E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 16,
  pv406E11customLabel: 'Salir',
  pv406E11setData: {
    pv406E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv406E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv406E10customLabel: null,
  pv406E10setData: {
    pv406E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv406E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 17,
  pv407E11customLabel: 'Salir',
  pv407E11setData: {
    pv407E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv407E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv407E10customLabel: null,
  pv407E10setData: {
    pv407E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv407E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv407E3customLabel: 'Simular',
  pv407E3setData: {
    pv407E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv407E3transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 18,
  pv408E1customLabel: 'Seleccion | ',
  pv408E1setData: {
    pv408E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv408E1transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
    pv408E1transactionTax: {
      path: 'transaction.details.tax',
      value: null,
    },
  },
  pv408E2customLabel: 'VolverASimular',
  pv408E2setData: {
    pv408E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv408E2transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv408E11customLabel: 'Salir',
  pv408E11setData: {
    pv408E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv408E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv408E10customLabel: null,
  pv408E10setData: {
    pv408E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv408E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 19,
  pv409E11customLabel: 'Salir',
  pv409E11setData: {
    pv409E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv409E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv409E10customLabel: null,
  pv409E10setData: {
    pv409E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv409E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 20,
  pv410E11customLabel: 'Salir',
  pv410E11setData: {
    pv410E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv410E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv410E10customLabel: null,
  pv410E10setData: {
    pv410E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv410E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 21,
  pv411E11customLabel: 'Salir',
  pv411E11setData: {
    pv411E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv411E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv411E10customLabel: null,
  pv411E10setData: {
    pv411E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv411E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Eventos Pantalla 22,
  pv412E11customLabel: 'Salir',
  pv412E11setData: {
    pv412E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv412E11transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },
  pv412E10customLabel: null,
  pv412E10setData: {
    pv412E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'HipotecarioCN',
    },
    pv412E10transactionName: {
      path: 'transaction.name',
      value: 'Simulacion',
    },
  },

  // Cliente existente
  // Pantallas onboarding - tarjeta de credito - captura documento - cliente existente
  // Eventos Pantalla 2

  // Eventos transversales en pantallas
  E1customLabel: 'Salir',
  E1setData: {
    E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
    E1transactionName: {
      path: 'transaction.name',
      value: null,
    },
  },
  E2customLabel: null,
  E2setData: {
    E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: null,
    },
    E2transactionName: {
      path: 'transaction.name',
      value: null,
    },
  },

  // Pantallas onboarding - tarjeta de credito - captura documento - cliente existente
  // Eventos Pantalla 2
  pv423E3customLabel: 'TratamientoDeDatos',
  pv423E3setData: {
    pv423E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv423E3transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Eventos Pantalla 3
  pv424E3customLabel: 'Alerta',
  pv424E3setData: {
    pv424E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv424E3transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv424E4customLabel: 'ErrorCodigo',
  pv424E4setData: {
    pv424E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv424E4transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv424E5customLabel: null,
  pv424E5setData: {
    pv424E5transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv424E5transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Pantallas onboarding - tarjeta de credito - ingreso datos - cliente existente
  // Eventos Pantalla 1
  pv429E3customLabel: 'Continuar',
  pv429E3setData: {
    pv429E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv429E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv429E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 6
  pv434E3customLabel: 'Alerta',
  pv434E3setData: {
    pv434E3transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv434E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv434E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv434E4customLabel: null,
  pv434E4setData: {
    pv434E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv434E4transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 13
  pv441E1customLabel: 'Volver',
  pv441E1setData: {
    pv441E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv441E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 14
  pv442E1customLabel: 'Volver',
  pv442E1setData: {
    pv442E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv442E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 15
  pv443E1customLabel: 'Volver',
  pv443E1setData: {
    pv443E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv443E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Eventos Pantalla 16
  pv444E1customLabel: 'Volver',
  pv444E1setData: {
    pv444E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv444E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Pantallas onboarding - tarjeta de credito - configurar vinculacion - cliente existente
  // Eventos Pantalla 2
  pv446E3customLabel: 'Alerta',
  pv446E3setData: {
    pv446E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv446E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 3
  pv447E3customLabel: 'Continuar',
  pv447E3setData: {
    pv447E3cardnetwork: {
      path: 'transaction.details.cardnetwork',
      value: null,
    },
    pv447E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv447E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 7
  pv451E3customLabel: 'Continuar',
  pv451E3setData: {
    pv451E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv451E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv451E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 8
  pv452E3customLabel: 'TerminosYcondiciones',
  pv452E3setData: {
    pv452E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv452E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos Pantalla 9
  pv453E3customLabel: 'TerminosYcondiciones',
  pv453E3setData: {
    pv453E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'SolicitudTCCE',
    },
    pv453E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Eventos pantallas consulta solicitudes cliente nuevo
  // Eventos Pantalla 1
  pv458E11customLabel: 'Salir',
  pv458E11setData: {
    pv458E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv458E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv458E10customLabel: null,
  pv458E10setData: {
    pv458E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv458E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv458E2customLabel: null,
  pv458E2setData: {
    pv458E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv458E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },

  // Eventos Pantalla 2
  pv459E11customLabel: 'Salir',
  pv459E11setData: {
    pv459E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv459E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv459E10customLabel: null,
  pv459E10setData: {
    pv459E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv459E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv459E2customLabel: 'Consultar',
  pv459E2setData: {
    pv459E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv459E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv459E3customLabel: 'ErrorConsulta',
  pv459E3setData: {
    pv459E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv459E3transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },

  // Eventos Pantalla 3
  pv460E11customLabel: 'Salir',
  pv460E11setData: {
    pv460E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv460E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv460E10customLabel: null,
  pv460E10setData: {
    pv460E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv460E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv460E2customLabel: 'AdjuntarDocumentos',
  pv460E2setData: {
    pv460E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv460E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv460E3customLabel: 'ConsultaloAqui',
  pv460E3setData: {
    pv460E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv460E3transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv460E4customLabel: 'Alerta',
  pv460E4setData: {
    pv460E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv460E4transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
    pv460E4transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  // Eventos Pantalla 6
  pv463E1customLabel: null,
  pv463E1setData: {
    pv463E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv463E1transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv463E2customLabel: 'AlertaError',
  pv463E2setData: {
    pv463E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv463E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv463E11customLabel: 'Salir',
  pv463E11setData: {
    pv463E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv463E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv463E10customLabel: null,
  pv463E10setData: {
    pv463E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCN',
    },
    pv463E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },

  // Eventos Pantallas consulta solicitud cliente existente
  // Eventos Pantalla 1
  pv464E11customLabel: 'Salir',
  pv464E11setData: {
    pv464E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv464E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv464E10customLabel: null,
  pv464E10setData: {
    pv464E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv464E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv464E2customLabel: null,
  pv464E2setData: {
    pv464E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv464E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },

  // Eventos Pantalla 2
  pv465E11customLabel: 'Salir',
  pv465E11setData: {
    pv465E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv465E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv465E10customLabel: null,
  pv465E10setData: {
    pv465E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv465E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv465E2customLabel: 'ConsultarSolicitud',
  pv465E2setData: {
    pv465E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv465E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },

  // Eventos Pantalla 4
  pv467E11customLabel: 'Salir',
  pv467E11setData: {
    pv467E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv467E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv467E10customLabel: null,
  pv467E10setData: {
    pv467E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv467E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv467E2customLabel: 'AdjuntarDocumentos',
  pv467E2setData: {
    pv467E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv467E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv467E3customLabel: 'ConsultaloAqui',
  pv467E3setData: {
    pv467E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv467E3transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv467E4customLabel: 'Alerta',
  pv467E4setData: {
    pv467E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv467E4transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
    pv467E4transactionProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },

  // Eventos Pantalla 7
  pv470E1customLabel: null,
  pv470E1setData: {
    pv470E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv470E1transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv470E2customLabel: 'AlertaError',
  pv470E2setData: {
    pv470E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv470E2transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv470E11customLabel: 'Salir',
  pv470E11setData: {
    pv470E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv470E11transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },
  pv470E10customLabel: 'Salir',
  pv470E10setData: {
    pv470E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'ConsultaDeSolicitudesCE',
    },
    pv470E10transactionName: {
      path: 'transaction.name',
      value: 'Consulta',
    },
  },

  // Eventos Pantallas Onboarding Multiproducto - CN - Solicitud
  // Eventos Pantalla 1
  pv471E1customLabel: 'Solicitar',
  pv471E1setData: {
    pv471E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv471E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv471E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv471E11customLabel: 'Salir',
  pv471E11setData: {
    pv471E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv471E11transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv471E10customLabel: null,
  pv471E10setData: {
    pv471E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv471E10transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 2
  pv472E1customLabel: 'Error',
  pv472E1setData: {
    pv472E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv472E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv472E11customLabel: 'Salir',
  pv472E11setData: {
    pv472E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv472E11transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv472E10customLabel: null,
  pv472E10setData: {
    pv472E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv472E10transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 3
  pv473E1customLabel: 'ErrorSeleccionProductos',
  pv473E1setData: {
    pv473E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv473E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv473E11customLabel: 'Salir',
  pv473E11setData: {
    pv473E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv473E11transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv473E10customLabel: null,
  pv473E10setData: {
    pv473E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv473E10transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 4
  pv474E1customLabel: 'Finalizar',
  pv474E1setData: {
    pv474E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv474E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 5
  pv475E1customLabel: 'Finalizar',
  pv475E1setData: {
    pv475E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv475E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 6
  pv476E1customLabel: 'Continuar',
  pv476E1setData: {
    pv476E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv476E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 7
  pv477E1customLabel: 'Continuar',
  pv477E1setData: {
    pv477E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv477E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantalla 8
  pv478E1customLabel: 'Continuar',
  pv478E1setData: {
    pv478E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv478E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv478E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv478E11customLabel: 'Salir',
  pv478E11setData: {
    pv478E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv478E11transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv478E10customLabel: null,
  pv478E10setData: {
    pv478E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv478E10transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos Pantallas Onboarding Multiproducto - CN - Identificacion
  // Eventos Pantalla 4
  pv482E1customLabel: 'TratamientoDatos',
  pv482E1setData: {
    pv482E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv482E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv482E2customLabel: 'TomarFoto',
  pv482E2setData: {
    pv482E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv482E2transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv482E11customLabel: 'Salir',
  pv482E11setData: {
    pv482E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv482E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv482E10customLabel: null,
  pv482E10setData: {
    pv482E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv482E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 5
  pv483E1customLabel: 'Reintentar',
  pv483E1setData: {
    pv483E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv483E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 6
  pv484E1customLabel: 'TomarFoto',
  pv484E1setData: {
    pv484E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv484E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv484E11customLabel: 'Salir',
  pv484E11setData: {
    pv484E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv484E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv484E10customLabel: null,
  pv484E10setData: {
    pv484E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv484E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 7
  pv485E1customLabel: 'Reintentar',
  pv485E1setData: {
    pv485E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv485E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 8
  pv486E1customLabel: 'Continuar',
  pv486E1setData: {
    pv486E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv486E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 9
  pv487E1customLabel: 'Continuar',
  pv487E1setData: {
    pv487E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv487E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
    pv487E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv487E11customLabel: 'Salir',
  pv487E11setData: {
    pv487E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv487E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv487E10customLabel: null,
  pv487E10setData: {
    pv487E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv487E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 10
  pv488E1customLabel: 'TomarFoto',
  pv488E1setData: {
    pv488E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv488E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv488E11customLabel: 'Salir',
  pv488E11setData: {
    pv488E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv488E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv488E10customLabel: null,
  pv488E10setData: {
    pv488E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv488E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 11
  pv489E1customLabel: 'Reintentar',
  pv489E1setData: {
    pv489E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv489E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantallas Onboarding Multiproducto - CN - Oferta
  // Eventos Pantalla 1
  pv494E1customLabel: null,
  pv494E1setData: {
    pv494E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv494E1transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
    pv494E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv494E2customLabel: 'ModificarCupo',
  pv494E2setData: {
    pv494E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv494E2transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },
  pv494E11customLabel: 'Salir',
  pv494E11setData: {
    pv494E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv494E11transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },
  pv494E10customLabel: null,
  pv494E10setData: {
    pv494E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv494E10transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },

  // Eventos Pantalla 2
  pv495E1customLabel: null,
  pv495E1setData: {
    pv495E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv495E1transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
    pv495E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv495E11customLabel: 'Salir',
  pv495E11setData: {
    pv495E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv495E11transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },
  pv495E10customLabel: null,
  pv495E10setData: {
    pv495E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv495E10transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },

  // Eventos Pantalla 3
  pv496E1customLabel: 'Continuar',
  pv496E1setData: {
    pv496E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv496E1transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },
  pv496E1events: {
    name: 'transactionsimulationvalue',
    value: null,
  },
  pv496E2customLabel: 'ErrorMonto',
  pv496E2setData: {
    pv496E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv496E2transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },
  pv496E11customLabel: 'Salir',
  pv496E11setData: {
    pv496E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv496E11transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },
  pv496E10customLabel: null,
  pv496E10setData: {
    pv496E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv496E10transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },

  // Eventos Pantalla 4
  pv497E1customLabel: null,
  pv497E1setData: {
    pv497E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv497E1transactionName: {
      path: 'transaction.name',
      value: 'Oferta',
    },
  },

  // Eventos Pantallas Onboarding Multiproducto - CN - Configuracion
  // Eventos Pantalla 1
  pv498E1customLabel: 'Continuar',
  pv498E1setData: {
    pv498E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv498E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv498E11customLabel: 'Salir',
  pv498E11setData: {
    pv498E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv498E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv498E10customLabel: null,
  pv498E10setData: {
    pv498E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv498E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 2
  pv499E1customLabel: 'Continuar',
  pv499E1setData: {
    pv499E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv499E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv499E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv499E11customLabel: 'Salir',
  pv499E11setData: {
    pv499E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv499E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv499E10customLabel: null,
  pv499E10setData: {
    pv499E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv499E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 4
  pv501E1customLabel: 'Continuar',
  pv501E1setData: {
    pv501E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv501E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv501E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv501E11customLabel: 'Salir',
  pv501E11setData: {
    pv501E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv501E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv501E10customLabel: null,
  pv501E10setData: {
    pv501E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv501E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 5
  pv502E1customLabel: 'Aceptar',
  pv502E1setData: {
    pv502E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv502E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv502E11customLabel: 'Salir',
  pv502E11setData: {
    pv502E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv502E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv502E10customLabel: null,
  pv502E10setData: {
    pv502E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv502E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 6
  pv503E1customLabel: 'Continuar',
  pv503E1setData: {
    pv503E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv503E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv503E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: 'Pago | ',
    },
    pv503E1cardnetwork: {
      path: 'transaction.details.cardnetwork',
      value: null,
    },
  },
  pv503E11customLabel: 'Salir',
  pv503E11setData: {
    pv503E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv503E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv503E10customLabel: null,
  pv503E10setData: {
    pv503E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv503E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 7
  pv504E1customLabel: 'Continuar',
  pv504E1setData: {
    pv504E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv504E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv504E1cardnetwork: {
      path: 'transaction.details.cardnetwork',
      value: null,
    },
  },
  pv504E11customLabel: 'Salir',
  pv504E11setData: {
    pv504E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv504E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv504E10customLabel: null,
  pv504E10setData: {
    pv504E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv504E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 8
  pv505E1customLabel: 'Continuar',
  pv505E1setData: {
    pv505E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv505E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv505E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'EntregaTarjeta | ',
    },
  },
  pv505E11customLabel: 'Salir',
  pv505E11setData: {
    pv505E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv505E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv505E10customLabel: null,
  pv505E10setData: {
    pv505E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv505E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 9
  pv506E1customLabel: 'Continuar',
  pv506E1setData: {
    pv506E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv506E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv506E11customLabel: 'Salir',
  pv506E11setData: {
    pv506E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv506E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv506E10customLabel: null,
  pv506E10setData: {
    pv506E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv506E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 10
  pv507E1customLabel: 'Continuar',
  pv507E1setData: {
    pv507E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv507E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv507E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv507E11customLabel: 'Salir',
  pv507E11setData: {
    pv507E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv507E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv507E10customLabel: null,
  pv507E10setData: {
    pv507E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv507E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantallas Onboarding Multiproducto - CN - Vinculacion
  // Eventos Pantalla 1
  pv508E1customLabel: 'Solicitar',
  pv508E1setData: {
    pv508E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv508E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv508E11customLabel: 'Salir',
  pv508E11setData: {
    pv508E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv508E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv508E10customLabel: null,
  pv508E10setData: {
    pv508E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv508E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 2
  pv509E11customLabel: 'Salir',
  pv509E11setData: {
    pv509E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv509E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv509E10customLabel: null,
  pv509E10setData: {
    pv509E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv509E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 3
  pv510E1customLabel: 'Solicitar',
  pv510E1setData: {
    pv510E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv510E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv510E11customLabel: 'Salir',
  pv510E11setData: {
    pv510E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv510E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv510E10customLabel: null,
  pv510E10setData: {
    pv510E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv510E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 6
  pv513E1customLabel: 'Finalizar',
  pv513E1setData: {
    pv513E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv513E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv513E11customLabel: 'Salir',
  pv513E11setData: {
    pv513E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv513E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv513E10customLabel: null,
  pv513E10setData: {
    pv513E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv513E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 7
  pv514E1customLabel: 'Finalizar',
  pv514E1setData: {
    pv514E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv514E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv514E11customLabel: 'Salir',
  pv514E11setData: {
    pv514E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv514E11transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },
  pv514E10customLabel: null,
  pv514E10setData: {
    pv514E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv514E10transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos Pantalla 11
  pv518E1customLabel: 'Finalizar',
  pv518E1setData: {
    pv518E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv518E1transactionName: {
      path: 'transaction.name',
      value: 'Vinculacion',
    },
  },

  // Eventos pantallas Onboarding Multiproducto - CE - Solicitud
  // Pantalla 9
  pv519E1customLabel: 'Continuar',
  pv519E1setData: {
    pv519E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv519E1transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
    pv519E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv519E11customLabel: 'Salir',
  pv519E11setData: {
    pv519E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv519E11transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },
  pv519E10customLabel: null,
  pv519E10setData: {
    pv519E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv519E10transactionName: {
      path: 'transaction.name',
      value: 'Solicitud',
    },
  },

  // Eventos pantallas Onboarding Multiproducto - CE - Identificacion
  // Pantalla 2
  pv520E1customLabel: null,
  pv520E1setData: {
    pv520E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv520E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv520E2customLabel: 'CodigoReenviado',
  pv520E2setData: {
    pv520E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv520E2transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv520E3customLabel: 'ErrorCodigo',
  pv520E3setData: {
    pv520E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv520E3transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv520E4customLabel: 'Error',
  pv520E4setData: {
    pv520E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv520E4transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv520E11customLabel: 'Salir',
  pv520E11setData: {
    pv520E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv520E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv520E10customLabel: null,
  pv520E10setData: {
    pv520E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv520E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 2
  pv521E11customLabel: 'Salir',
  pv521E11setData: {
    pv521E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv521E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv521E10customLabel: null,
  pv521E10setData: {
    pv521E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv521E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 4
  pv522E11customLabel: 'Salir',
  pv522E11setData: {
    pv522E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv522E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv522E10customLabel: null,
  pv522E10setData: {
    pv522E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv522E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 5
  pv523E1customLabel: 'Continuar',
  pv523E1setData: {
    pv523E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv523E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 7
  pv525E1customLabel: 'Continuar',
  pv525E1setData: {
    pv525E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv525E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 8
  pv526E1customLabel: 'Reintentar',
  pv526E1setData: {
    pv526E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv526E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 9
  pv527E1customLabel: 'Finalizar',
  pv527E1setData: {
    pv527E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv527E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 10
  pv528E1customLabel: 'Actualizar | ',
  pv528E1setData: {
    pv528E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv528E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 11
  pv529E1customLabel: null,
  pv529E1setData: {
    pv529E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv529E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv529E2customLabel: 'ActualizacionExitosa',
  pv529E2setData: {
    pv529E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv529E2transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv529E11customLabel: 'Salir',
  pv529E11setData: {
    pv529E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv529E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv529E10customLabel: null,
  pv529E10setData: {
    pv529E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv529E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventns Pantallas Onboarding Multiproducto - CN Web - Identificacion
  // Pantalla 1
  pv530E11customLabel: 'Salir',
  pv530E11setData: {
    pv530E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv530E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv530E10customLabel: null,
  pv530E10setData: {
    pv530E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv530E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 2
  pv531E1customLabel: 'Continuar',
  pv531E1setData: {
    pv531E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv531E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
    pv531E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv531E1transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
  },
  pv531E11customLabel: 'Salir',
  pv531E11setData: {
    pv531E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv531E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv531E10customLabel: null,
  pv531E10setData: {
    pv531E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv531E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 3
  pv532E1customLabel: 'VerReverso',
  pv532E1setData: {
    pv532E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv532E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv532E11customLabel: 'Salir',
  pv532E11setData: {
    pv532E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv532E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv532E10customLabel: null,
  pv532E10setData: {
    pv532E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv532E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 6
  pv534E11customLabel: 'Salir',
  pv534E11setData: {
    pv534E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv534E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv534E10customLabel: null,
  pv534E10setData: {
    pv534E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv534E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 7
  pv535E11customLabel: 'Salir',
  pv535E11setData: {
    pv535E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv535E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv535E10customLabel: null,
  pv535E10setData: {
    pv535E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv535E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 8
  pv536E11customLabel: 'Salir',
  pv536E11setData: {
    pv536E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv536E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv536E10customLabel: null,
  pv536E10setData: {
    pv536E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv536E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 9
  pv537E1customLabel: 'EnviarCodigo',
  pv537E1setData: {
    pv537E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv537E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv537E11customLabel: 'Salir',
  pv537E11setData: {
    pv537E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv537E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv537E10customLabel: null,
  pv537E10setData: {
    pv537E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv537E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 10
  pv538E11customLabel: 'Salir',
  pv538E11setData: {
    pv538E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv538E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv538E10customLabel: null,
  pv538E10setData: {
    pv538E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv538E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 11
  pv539E11customLabel: 'Salir',
  pv539E11setData: {
    pv539E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv539E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv539E10customLabel: null,
  pv539E10setData: {
    pv539E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv539E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 12
  pv540E11customLabel: 'Salir',
  pv540E11setData: {
    pv540E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv540E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv540E10customLabel: null,
  pv540E10setData: {
    pv540E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv540E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 16
  pv541E1customLabel: 'Reintentar',
  pv541E1setData: {
    pv541E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv541E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv541E11customLabel: 'Salir',
  pv541E11setData: {
    pv541E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv541E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv541E10customLabel: null,
  pv541E10setData: {
    pv541E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv541E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 17
  pv542E11customLabel: 'Salir',
  pv542E11setData: {
    pv542E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv542E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv542E10customLabel: null,
  pv542E10setData: {
    pv542E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv542E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 18
  pv543E1customLabel: 'Reintentar',
  pv543E1setData: {
    pv543E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv543E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv543E11customLabel: 'Salir',
  pv543E11setData: {
    pv543E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv543E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv543E10customLabel: null,
  pv543E10setData: {
    pv543E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv543E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 19
  pv544E11customLabel: 'Salir',
  pv544E11setData: {
    pv544E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv544E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv544E10customLabel: null,
  pv544E10setData: {
    pv544E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv544E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 20
  pv545E11customLabel: 'Salir',
  pv545E11setData: {
    pv545E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv545E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv545E10customLabel: null,
  pv545E10setData: {
    pv545E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv545E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 21
  pv546E11customLabel: 'Salir',
  pv546E11setData: {
    pv546E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv546E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv546E10customLabel: null,
  pv546E10setData: {
    pv546E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv546E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 22
  pv547E11customLabel: 'Salir',
  pv547E11setData: {
    pv547E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv547E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv547E10customLabel: null,
  pv547E10setData: {
    pv547E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv547E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 23
  pv548E11customLabel: 'Salir',
  pv548E11setData: {
    pv548E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv548E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv548E10customLabel: null,
  pv548E10setData: {
    pv548E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv548E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 24
  pv549E11customLabel: 'Salir',
  pv549E11setData: {
    pv549E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv549E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv549E10customLabel: null,
  pv549E10setData: {
    pv549E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv549E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Pantalla 25
  pv550E1customLabel: 'Reintentar',
  pv550E1setData: {
    pv550E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv550E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv550E11customLabel: 'Salir',
  pv550E11setData: {
    pv550E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv550E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv550E10customLabel: null,
  pv550E10setData: {
    pv550E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv550E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventns Pantallas Onboarding Multiproducto - CN - Captura
  // Pantalla 2
  pv552E1customLabel: 'VerificarDatoReverso',
  pv552E1setData: {
    pv552E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv552E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv552E2customLabel: 'VerificarDatoFrontal',
  pv552E2setData: {
    pv552E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv552E2transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv552E11customLabel: 'Salir',
  pv552E11setData: {
    pv552E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv552E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv552E10customLabel: null,
  pv552E10setData: {
    pv552E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv552E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 3
  pv553E1customLabel: 'Continuar',
  pv553E1setData: {
    pv553E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv553E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv553E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv553E11customLabel: 'Salir',
  pv553E11setData: {
    pv553E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv553E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv553E10customLabel: null,
  pv553E10setData: {
    pv553E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv553E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 4
  pv554E11customLabel: 'Salir',
  pv554E11setData: {
    pv554E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv554E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv554E10customLabel: null,
  pv554E10setData: {
    pv554E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv554E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 5
  pv555E1customLabel: 'Continuar',
  pv555E1setData: {
    pv555E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv555E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv555E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv555E11customLabel: 'Salir',
  pv555E11setData: {
    pv555E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv555E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv555E10customLabel: null,
  pv555E10setData: {
    pv555E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv555E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 6
  pv556E11customLabel: 'Salir',
  pv556E11setData: {
    pv556E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv556E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv556E10customLabel: null,
  pv556E10setData: {
    pv556E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv556E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 7
  pv557E1customLabel: 'Continuar',
  pv557E1setData: {
    pv557E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv557E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv557E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv557E11customLabel: 'Salir',
  pv557E11setData: {
    pv557E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv557E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv557E10customLabel: null,
  pv557E10setData: {
    pv557E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv557E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 8
  pv558E11customLabel: 'Salir',
  pv558E11setData: {
    pv558E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv558E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv558E10customLabel: null,
  pv558E10setData: {
    pv558E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv558E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 10
  pv560E11customLabel: 'Salir',
  pv560E11setData: {
    pv560E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv560E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv560E10customLabel: null,
  pv560E10setData: {
    pv560E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv560E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 11
  pv561E11customLabel: 'Salir',
  pv561E11setData: {
    pv561E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv561E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv561E10customLabel: null,
  pv561E10setData: {
    pv561E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv561E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 12
  pv562E1customLabel: 'Continuar | GastosMensuales',
  pv562E1setData: {
    pv562E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv562E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv562E11customLabel: 'Salir',
  pv562E11setData: {
    pv562E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv562E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv562E10customLabel: null,
  pv562E10setData: {
    pv562E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv562E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 13
  pv563E1customLabel: 'TooltipOperacionesExtranjeras',
  pv563E1setData: {
    pv563E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv563E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv563E11customLabel: 'Salir',
  pv563E11setData: {
    pv563E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv563E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv563E10customLabel: null,
  pv563E10setData: {
    pv563E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv563E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 14
  pv564E1customLabel: 'Continuar | OperacionRealizada',
  pv564E1setData: {
    pv564E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv564E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv564E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv564E11customLabel: 'Salir',
  pv564E11setData: {
    pv564E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv564E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv564E10customLabel: null,
  pv564E10setData: {
    pv564E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv564E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 15
  pv565E11customLabel: 'Salir',
  pv565E11setData: {
    pv565E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv565E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv565E10customLabel: null,
  pv565E10setData: {
    pv565E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv565E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Pantalla 16
  pv566E1customLabel: 'Continuar | TipoProducto | ',
  pv566E1setData: {
    pv566E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv566E1transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
    pv566E1transactionDetailProductDetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv566E1transactionDetailsCurrency: {
      path: 'transaction.details.currency',
      value: null,
    },
    pv566E1transactionDetailsTransactioninstitution: {
      path: 'transaction.details.transactioninstitution',
      value: null,
    },
  },
  pv566E11customLabel: 'Salir',
  pv566E11setData: {
    pv566E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv566E11transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },
  pv566E10customLabel: null,
  pv566E10setData: {
    pv566E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'Multiproducto',
    },
    pv566E10transactionName: {
      path: 'transaction.name',
      value: 'Captura',
    },
  },

  // Eventos Pantallas de CuentasAhorro - CE
  // Eventos Pantalla 1
  pv569E1customLabel: 'Continuar',
  pv569E1setData: {
    pv569E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv569E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
    pv569E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv569E11customLabel: 'Salir',
  pv569E11setData: {
    pv569E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv569E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv569E10customLabel: null,
  pv569E10setData: {
    pv569E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv569E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 2
  pv570E1customLabel: null,
  pv570E1setData: {
    pv570E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv570E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv570E2customLabel: 'CodigoReenviado',
  pv570E2setData: {
    pv570E2transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv570E2transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv570E3customLabel: 'ErrorCodigo',
  pv570E3setData: {
    pv570E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv570E3transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv570E4customLabel: 'Error',
  pv570E4setData: {
    pv570E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv570E4transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv570E11customLabel: 'Salir',
  pv570E11setData: {
    pv570E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv570E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv570E10customLabel: null,
  pv570E10setData: {
    pv570E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv570E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 8
  pv571E1customLabel: 'Continuar',
  pv571E1setData: {
    pv571E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv571E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv571E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'Asesor | ',
    },
  },
  pv571E11customLabel: 'Salir',
  pv571E11setData: {
    pv571E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv571E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv571E10customLabel: null,
  pv571E10setData: {
    pv571E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv571E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 13
  pv574E11customLabel: 'Salir',
  pv574E11setData: {
    pv574E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv574E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv574E10customLabel: null,
  pv574E10setData: {
    pv574E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv574E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Onboarding Cuenta ahorros cliente nuevo eventos
  // Eventos Pantalla 11
  pv583E1customLabel: 'Continuar',
  pv583E1setData: {
    pv583E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv583E1transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
    pv583E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'Asesor | ',
    },
  },
  pv583E11customLabel: 'Salir',
  pv583E11setData: {
    pv583E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv583E11transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },
  pv583E10customLabel: null,
  pv583E10setData: {
    pv583E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv583E10transactionName: {
      path: 'transaction.name',
      value: 'Configuracion',
    },
  },

  // Onboarding Cuenta ahorros cliente nuevo eventos - web
  // Eventos Pantalla 1
  pv588E11customLabel: 'Salir',
  pv588E11setData: {
    pv588E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv588E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv588E10customLabel: null,
  pv588E10setData: {
    pv588E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv588E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 2
  pv589E1customLabel: 'Continuar',
  pv589E1setData: {
    pv589E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv589E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
    pv589E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },
  pv589E11customLabel: 'Salir',
  pv589E11setData: {
    pv589E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv589E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv589E10customLabel: null,
  pv589E10setData: {
    pv589E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv589E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 3
  pv590E1customLabel: 'VerReverso',
  pv590E1setData: {
    pv590E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv590E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv590E11customLabel: 'Salir',
  pv590E11setData: {
    pv590E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv590E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv590E10customLabel: null,
  pv590E10setData: {
    pv590E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv590E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 8
  pv594E11customLabel: 'Salir',
  pv594E11setData: {
    pv594E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv594E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv594E10customLabel: null,
  pv594E10setData: {
    pv594E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv594E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 9
  pv595E1customLabel: 'EnviarCodigo',
  pv595E1setData: {
    pv595E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv595E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv595E11customLabel: 'Salir',
  pv595E11setData: {
    pv595E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv595E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv595E10customLabel: null,
  pv595E10setData: {
    pv595E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv595E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 15
  pv598E1customLabel: 'Reintentar',
  pv598E1setData: {
    pv598E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv598E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 16
  pv599E1customLabel: 'Reintentar',
  pv599E1setData: {
    pv599E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv599E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 17
  pv600E11customLabel: 'Salir',
  pv600E11setData: {
    pv600E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv600E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv600E10customLabel: null,
  pv600E10setData: {
    pv600E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv600E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 18
  pv601E1customLabel: 'Reintentar',
  pv601E1setData: {
    pv601E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv601E1transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 20
  pv603E11customLabel: 'Salir',
  pv603E11setData: {
    pv603E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv603E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv603E10customLabel: null,
  pv603E10setData: {
    pv603E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv603E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 21
  pv604E11customLabel: 'Salir',
  pv604E11setData: {
    pv604E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv604E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv604E10customLabel: null,
  pv604E10setData: {
    pv604E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv604E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 22
  pv605E11customLabel: 'Salir',
  pv605E11setData: {
    pv605E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv605E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv605E10customLabel: null,
  pv605E10setData: {
    pv605E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv605E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 23
  pv606E11customLabel: 'Salir',
  pv606E11setData: {
    pv606E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv606E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv606E10customLabel: null,
  pv606E10setData: {
    pv606E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv606E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 24
  pv607E11customLabel: 'Salir',
  pv607E11setData: {
    pv607E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv607E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv607E10customLabel: null,
  pv607E10setData: {
    pv607E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv607E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 25
  pv608E11customLabel: 'Salir',
  pv608E11setData: {
    pv608E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv608E11transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },
  pv608E10customLabel: null,
  pv608E10setData: {
    pv608E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CuentaAhorros',
    },
    pv608E10transactionName: {
      path: 'transaction.name',
      value: 'Identificacion',
    },
  },

  /////////////// Eventos Onboarding cliente existente credito personal - web app
  //// Etapa Captura Documento   // Pantalla 1
  pv609E11customLabel: 'Salir',
  pv609E11setData: {
    pv609E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv609E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv609E10customLabel: null,
  pv609E10setData: {
    pv609E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv609E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv609E3customLabel: 'TratamientoDeDatos',
  pv609E3setData: {
    pv609E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv609E3transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Pantalla 2
  pv610E11customLabel: 'Salir',
  pv610E11setData: {
    pv610E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv610E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv610E10customLabel: null,
  pv610E10setData: {
    pv610E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv610E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv610E3customLabel: 'Alerta',
  pv610E3setData: {
    pv610E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv610E3transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv610E4customLabel: 'ErrorCodigo',
  pv610E4setData: {
    pv610E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv610E4transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv610E5customLabel: null,
  pv610E5setData: {
    pv610E5transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv610E5transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  // Pantalla 6
  pv614E11customLabel: 'Salir',
  pv614E11setData: {
    pv614E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv614E11transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },
  pv614E10customLabel: null,
  pv614E10setData: {
    pv614E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv614E10transactionName: {
      path: 'transaction.name',
      value: 'CapturaDocumento',
    },
  },

  //// Etapa Ingreso Datos
  // Pantalla 1
  pv615E11customLabel: 'Salir',
  pv615E11setData: {
    pv615E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv615E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv615E10customLabel: null,
  pv615E10setData: {
    pv615E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv615E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv615E3customLabel: 'Continuar',
  pv615E3setData: {
    pv615E1clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv615E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv615E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv615E4customLabel: 'Continuar',
  pv615E4setData: {
    pv615E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv615E4transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  // Pantalla 2
  pv616E11customLabel: 'Salir',
  pv616E11setData: {
    pv616E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv616E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv616E10customLabel: null,
  pv616E10setData: {
    pv616E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv616E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv616E3customLabel: 'Continuar',
  pv616E3setData: {
    pv616E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv616E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv616E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Pantalla 4
  pv618E1customLabel: null,
  pv618E1setData: {
    pv618E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv618E1transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Pantalla 7
  pv621E11customLabel: 'Salir',
  pv621E11setData: {
    pv621E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv621E11transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv621E10customLabel: null,
  pv621E10setData: {
    pv621E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv621E10transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv621E3customLabel: 'Alerta',
  pv621E3setData: {
    pv621E3transactionDetailsProductdetails: {
      path: 'transaction.details.productdetails',
      value: null,
    },
    pv621E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv621E3transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },
  pv621E4customLabel: null,
  pv621E4setData: {
    pv621E4transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv621E4transactionName: {
      path: 'transaction.name',
      value: 'IngresoDatos',
    },
  },

  // Etapa de Configuracion Vinculacion
  // Pantalla 1
  pv622E11customLabel: 'Salir',
  pv622E11setData: {
    pv622E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv622E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv622E10customLabel: null,
  pv622E10setData: {
    pv622E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv622E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv622E3customLabel: 'Continuar',
  pv622E3setData: {
    pv622E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv622E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv622E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 2
  pv623E11customLabel: 'Salir',
  pv623E11setData: {
    pv623E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv623E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv623E10customLabel: null,
  pv623E10setData: {
    pv623E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv623E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv623E3customLabel: 'Continuar',
  pv623E3setData: {
    pv623E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv623E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv623E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 3
  pv624E11customLabel: 'Salir',
  pv624E11setData: {
    pv624E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv624E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv624E10customLabel: null,
  pv624E10setData: {
    pv624E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv624E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 4
  pv625E11customLabel: 'Salir',
  pv625E11setData: {
    pv625E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv625E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv625E10customLabel: null,
  pv625E10setData: {
    pv625E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv625E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv625E3customLabel: 'Continuar',
  pv625E3setData: {
    pv625E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv625E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv625E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 5
  pv626E11customLabel: 'Salir',
  pv626E11setData: {
    pv626E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv626E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv626E10customLabel: null,
  pv626E10setData: {
    pv626E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv626E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv626E3customLabel: 'Continuar',
  pv626E3setData: {
    pv626E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv626E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv626E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 6
  pv627E11customLabel: 'Salir',
  pv627E11setData: {
    pv627E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv627E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv627E10customLabel: null,
  pv627E10setData: {
    pv627E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv627E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 7
  pv628E11customLabel: 'Salir',
  pv628E11setData: {
    pv628E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv628E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv628E10customLabel: null,
  pv628E10setData: {
    pv628E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv628E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 8
  pv629E11customLabel: 'Salir',
  pv629E11setData: {
    pv629E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv629E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv629E10customLabel: null,
  pv629E10setData: {
    pv629E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv629E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv629E3customLabel: 'Continuar',
  pv629E3setData: {
    pv629E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv629E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
    pv629E3transactionDestinationbank: {
      path: 'transaction.details.destinationbank',
      value: null,
    },
    pv629E3transactionDestinationAccounttype: {
      path: 'transaction.details.destinationaccounttype',
      value: null,
    },
  },

  // Pantalla 9
  pv630E11customLabel: 'Salir',
  pv630E11setData: {
    pv630E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv630E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv630E10customLabel: null,
  pv630E10setData: {
    pv630E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv630E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv630E3customLabel: 'Aceptar',
  pv630E3setData: {
    pv630E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
    pv630E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv630E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 10
  pv631E11customLabel: 'Salir',
  pv631E11setData: {
    pv631E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv631E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv631E10customLabel: null,
  pv631E10setData: {
    pv631E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv631E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv631E3customLabel: 'Continuar',
  pv631E3setData: {
    pv631E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: 'Asesor | ',
    },
    pv631E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv631E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 11
  pv632E11customLabel: 'Salir',
  pv632E11setData: {
    pv632E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv632E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv632E10customLabel: null,
  pv632E10setData: {
    pv632E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv632E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv632E3customLabel: 'TerminosYCondiciones',
  pv632E3setData: {
    pv632E3transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv632E3transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 12
  pv633E11customLabel: 'Salir',
  pv633E11setData: {
    pv633E11transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv633E11transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
  pv633E10customLabel: null,
  pv633E10setData: {
    pv633E10transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv633E10transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 13
  pv634E1customLabel: 'Finalizar',
  pv634E1setData: {
    pv634E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv634E1transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },

  // Pantalla 14
  pv635E1customLabel: 'Finalizar',
  pv635E1setData: {
    pv635E1transactionDetailsProductcategory: {
      path: 'transaction.details.productcategory',
      value: 'CreditoPersonal',
    },
    pv635E1transactionName: {
      path: 'transaction.name',
      value: 'ConfigurarVinculacion',
    },
  },
};
export const COUNTRY = {
  ar: 'AR',
  cl: 'CL',
  co: 'CO',
  oca: 'OCA',
  py: 'PY',
  uy: 'UY',
};

export const BUSINNESS = {
  pf: 'PF',
  pj: 'PJ',
  un: 'UN',
};

export const ENVIRONMENT = {
  loggeado: 'LG',
  noLoggeado: 'NL',
};

export const CHANNEL = {
  apppn: 'APN',
  superapp: 'SA',
  apptarjetas: 'AT',
  homeBanking: 'HB',
};

export const FAMILY = {
  commonArea: 'AreaComun',
  care: 'Atendimento',
  campaigns: 'Campanas',
  accounts: 'Cuentas',
  fidelity: 'Fidelidad',
  investments: 'Inversiones',
  payment: 'Pagamentos',
  loan: 'Prestamo',
  insurance: 'Seguros',
  services: 'Servicios',
  cards: 'Tarjetas',
  transfers: 'Transferencias',
};

export const SUBFAMILY = {
  personalAccidents: 'AccidentesPersonales',
  aguinaldoAdvance: 'AdelantoAguinaldo',
  customs: 'Aduana',
  savingsForecast: 'AhorroPrevisionalUdutario',
  savingsScheduled: 'AhorroProgramado',
  feed: 'Alimentacion',
  proxies: 'Apoderados',
  automotive: 'Automotores',
  help: 'Ayuda',
  banksLocais: 'BancosLocais',
  basic: 'Basica',
  beneficiaries: 'Beneficiarios',
  profitCards: 'BeneficioTarjetas',
  boxSavings: 'CajaAhorro',
  juniorSavingsBox: 'CajaAhorroJunior',
  cashiers: 'Cajeros',
  change: 'Cambio',
  captureDocument: 'CapturaDocumento',
  certification: 'Certificacion',
  chat: 'Chat',
  checks: 'Cheques',
  checksFanfold: 'ChequesFanfold',
  tradeExterior: 'ComercioExterior',
  configurationLinking: 'ConfiguracionVinculacion',
  foreignCurrency: 'CorrienteMonedaExtranjera',
  LocalCurrencyStream: 'CorrienteMonedaLocal',
  credit: 'Credito',
  ownAccounts: 'CuentasPropias',
  virtualAccounts: 'CuentasVirtuales',
  debitoAutomatico: 'DebitoAutomatico',
  depositsTermFixed: 'DepositosPlazoFijo',
  digitization: 'Digitalizacion',
  outside: 'Dxterior',
  bill: 'Factura',
  faq: 'FAQ',
  finance: 'Finanzas',
  fonasa: 'Fonasa',
  funds: 'Fondos',
  form: 'Formulario',
  formInitial: 'FormularioInicial',
  turnsIEDE: 'GirosIEDE',
  datacontact: 'DatosContacto',
  mortgage: 'Hipotecarios',
  historicYTaxasCommissions: 'HistoricoComisionesYTaxas',
  HistoricOfUnderstandings: 'HistoricoDeComprovantes',
  home: 'Home',
  incomedata: 'IngresoDatos',
  irpf: 'IRPF',
  itau: 'Itau',
  landingPage: 'LandingPage',
  letterChange: 'LetraDeCambio',
  letterOfRegulation: 'LetrasDeRegulacionMonetaria',
  linkChannelYoutube: 'LinkCanalYoutube',
  limit: 'Limite',
  creditline: 'LineaDeCredito',
  login: 'Login',
  movements: 'Movimientos',
  notification: 'Notificacion',
  offerProducts: 'OfertaProductos',
  paymentsSMS: 'PagosSMS',
  shareholdingInCertificateOfDeposit: 'ParticipacionEnCertificadoDeDeposito',
  finalStep: 'PasoFinal',
  riskProfile: 'PerfilDeRiesgo',
  personal: 'Personales',
  pld: 'PLD',
  preapproved: 'Preaprobado',
  products: 'Productos',
  proposta: 'Proposta',
  promotions: 'Promociones',
  points: 'Puntos',
  recharge: 'Recarga',
  rechargeable: 'Recargable',
  fundraising: 'Recaudadoras',
  registration: 'Registro',
  health: 'Salud',
  security: 'Seguridad',
  self: 'Self',
  services: 'Servicios',
  overdraft: 'Sobregiro',
  request: 'Solicitud',
  surcursales: 'Surcursales',
  tariff: 'Tarifario',
  cards: 'Tarjetas',
  card: 'TarjetaDebito',
  tolls: 'Telepeaje',
  typechange: 'TipoCambio',
  titleWithSectiones: 'TituloConsecciones',
  travel: 'Viajes',
  life: 'Vida',
  view: 'Vista',
  wallet: 'Wallet',
};

export const PRODUCT = {
  open: 'Abrir',
  activate: 'Activar',
  add: 'Agregar',
  schedule: 'Agendar',
  block: 'Bloquear ',
  change: 'Cambiar',
  cancel: 'Cancelar',
  redeem: 'Canjear',
  consult: 'Consultar',
  configure: 'Configurar',
  hire: 'Contratar',
  disable: 'Desabilitar',
  address: 'Direccionar',
  edit: 'Editar',
  remove: 'Eliminar',
  enable: 'Habilitar',
  log: 'Loguear',
  pay: 'Pagar',
  rescue: 'Rescatar',
  recharge: 'Recargar',
  request: 'Solicitar',
  offer: 'Ofertar',
  transfe: 'Transferir',
};
